import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useMemo, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import Select, { components } from 'react-select';
import { Rating } from 'react-simple-star-rating';
import Switch from 'react-switch';
import { loaderActions } from "../../../../_actions/loader.actions";
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import CustomSelection from '../../../../customControl/CustomSelection';
import CustomTimePicker from '../../../../customControl/CustomTimePicker';
import RichTextBox from '../../../../customControl/RichTextBox';
import { getAllData, patchUsersData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { formatDateyearmonthday, formatTimeHourMinute, NumericWithDecimal, onlyNumeric } from '../../../commonClass/CommonValidation';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { CommonFileURLWithFolder } from '../../../../ImageUpload/ImageCommon';

const Packagemaster = () => {

    // for understanding short inclusions (it can be modified)
    // 1 - Hotel, 2 - Flight, 3 - Sightseeing, 4 - Meal, 5 - Transfers, 6 - Activities, 7 - Guide, 8 - Airport Transfer

    const dispatch = useDispatch();
    const [locationData, setLocationData] = useState([]);
    const EnableSightseeingInclusionIds = [3];

    const [editorRef, setEditorRef] = useState(null);
    const [editorRef2, setEditorRef2] = useState(null);

    const [atFirstDisable, setAtFirstDisable] = useState(true)
    const [flightopen, setFlightOpen] = useState();

    const [sightseeingopen, steSightseeingOpen] = useState();
    const [disabled, setDisabled] = useState(false);
    const [basicdraftdisabled, setBasicDraftDisabled] = useState(true);
    const [backdisable, setBackDisable] = useState(false);
    const [modalShow, setModalShow] = useState(false);

    const [formerror, setFormError] = useState('');
    const [isRetrive, setIsRetrive] = useState(false);
    const [stateenable, setStateDisable] = useState(false);

    const [isSubmit, setIsSubmit] = useState(false);
    const [cleardisabled, setClearDisable] = useState(false);
    const [packageValidateStart, setPackageValidateStart] = useState(null);
    const [packageValidateEnd, setPackageValidateEnd] = useState(null);
    const packageD = useLocation();
    const navigate = useNavigate();

    const [bestpackage, setBestPackage] = useState(false);
    const [hotdeals, setHotDeals] = useState(false);

    const [isinternationaldestination, setIsInternationalDestination] = useState(false);
    const [isbestdestinatio, setIsBestDestination] = useState(false);
    const [istrendingholiday, setIsTrendingHoliday] = useState(false);

    const [isbasicShown, setIsBasicShown] = useState(true);
    const [isAddShown, setIsAddShown] = useState(false);
    const [isAddDraftShown, setIsAddDraftShown] = useState(false);
    const [isDetailblockshow, SetIsDetailBlockShow] = useState(false);

    const [flightvisible, setFlightVisibled] = useState(true);
    const [pkgfinalprice, setPkgFinalPrice] = useState(0);
    const [PkgSummary, setPkgSummary] = useState([]);
    const [hotelbuttontext, setHotelbuttontext] = useState('');
    const [sightseeingbuttontext, setSightseeingbuttontext] = useState('');
    const [flightbuttontext, setFlightbuttontext] = useState('');
    const [richboxheight, setRichBoxHeight] = useState(false)

    const [inventoryvalidation, setInventoryValidation] = useState({
        InventoryCount: 0,
        MinSoldoutDate: null,
        MaxSoldOutDate: null,
    });

    const [formvalue, setFormValue] = useState({
        PackageId: 0,
        PackageName: "",
        PackageCode: "",
        PackageCategoryId: 0,
        StateId: [],
        LocationId: [],
        Country: 0,
        CountryId: [],
        PackageTypeId: 0,
        PackageLevelId: 0,
        IsInterCity: true,
        IsBestPackage: false,
        ArrivalSlotId: 0,
        DepartureSlotId: 0,
        PackageValidateStart: null,
        PackageValidateEnd: null,

        PackageValidateStartD: '',
        PackageValidateEndD: '',

        PackageInventoryCountD: '',
        PackageCutOffCountD: '',
        PackageInventoryCount: 0,
        PackageCutOffCount: 0,
        PackageHighlights: "",
        IsActive: false,
        IsDraft: false,

        PackageBasicPrice: 0,
        PackageMarkup: "FIX",
        PackageMarkupValue: "0",
        GST: 0,
        PackageFinalValue: 0,
        ChildrenPrice: null,

        PackageBanner: [],
        PackageGallery: [],
        PackageMenu: [],
        InclusionD: '',
        datainclusiondetails: [],
        ExclusionD: '',
        dataexclusiondetails: [],
        PolicyD: '',
        datapolicydetails: [],
        CityD: '',
        CityName: '',
        CityDetailsD: '',
        datacitydetails: [],
        PackageInclusion: [],
        PackageExclusion: [],
        PackagePolicy: [],
        PackageOverview: [],
        PackagePlace: [],
        PackageItinerary: [],
        PackageThemeId: [],

        IsHotDeals: false,
        HotOfferPercentage: 0,
        IsInternationalDestination: false,
        IsBestDestination: false,
        IsTrendingHoliday: false,

        DaySightseeingId: 0,
        Day: '',
        DaySchedule: '',
        SightseeingId: 0,
        RoomPriceD: 0,
        PickUpPoint: '',
        DropPoint: '',
        Hours: '',
        ItineraryDetails: '',
        VehicalPrice: 0,
        AirrivalTime: null,
        DepartureTime: null,
        Duration: '',
        HotelPrice: '',

        FlightPrice: '',
        AttractionBasicId: [],
        InclusionId: [],
        ArrivalTimeD: '',
        DepartureTimeD: '',

        PackageFinalPrice: 0,
        PackageFixPrice: 0,
        PackageDiscount: 0,
        IsPriceType: false
    });

    //#endregion

    //#region handle Dropdown and radio loading part 
    const [slotlist, setSlotList] = useState([]);
    const [bannerlist, setBannerList] = useState([]);
    const [gallerylist, setGalleryList] = useState([]);
    const [packagetypelist, setPackageTypeList] = useState([]);
    const [packagelevellist, setPackageLevelList] = useState([]);
    const [packagecategorylist, setPackageCategoryList] = useState([]);
    const [inclusionlist, setInclusionList] = useState([]);
    const [exclusionlist, setExclusionList] = useState([]);
    const [policylist, setPolicyList] = useState([]);
    const [menulist, setMenuList] = useState([]);
    const [durationlist, setDurationList] = useState([]);
    const [visitfromduration, setVisitFromDurationList] = useState([]);
    const [visittoduration, setVisitToDurationList] = useState([]);
    const [packagepoint, setPackageoint] = useState([]);
    const [endpackagepoint, setEndPackageoint] = useState([]);
    const [packagetheme, setPackageTheme] = useState([]);
    const [aboutplacecitylist, setAboutPlaceCityList] = useState([]);
    const [roomtypelist, setRoomTypeList] = useState([]);
    const [sightseeinglist, setSightSeeingList] = useState([]);
    const [vehicaltypelist, setVehicalTypeList] = useState([]);

    //#region Transfers Inclusion and Vehicle variables
    const [vehicleTransferOpen, steVehicleTransferOpen] = useState(false);
    const [vehicleTransferButtonText, setVehicleTransferButtonText] = useState(false);
    const [vehicleTransferId, setVehicleTransferId] = useState(0);
    const [vehicleTransferDisabled, setVehicleTransferDisabled] = useState(false);
    const [vehicleTransferNameDisabled, setVehicleTransferNameDisabled] = useState(false);
    const [vehicleTransferCategoryAndListData, setVehicleTransferCategoryAndListData] = useState({ vehicleCategoryList: [], vehicleList: [] });
    const [selectedVehicleTransferDetail, setSelectedVehicleTransferDetail] = useState({
        VehicleDetailId: 0,
        VehicleName: "",
        SeatingCapacity: "",
        VehicleType: "",
    })
    //#endregion

    //#region Transfers Inclusions and TransferSightseeing
    const EnableTransferSightseeingInclusionIds = [5];
    const [transferSightseeinglist, setTransferSightSeeingList] = useState([]);
    const [transferSightseeingopen, setTransferSightseeingOpen] = useState(false);
    const [transferSightseeingbuttontext, setTransferSightseeingbuttontext] = useState(false);
    const [transferSightseeingdisable, setTransferSightseeingDisable] = useState(false);
    const [transferSightseeingDetail, setTransferSightseeingDetail] = useState({
        TransferSightseeingId: 0,
        TransferSightseeingName: "",
        TransferSightseeingPickupPoint: "",
        TransferSightseeingDropPoint: "",
        TransferSightseeingDuration: null,
        TransferSightseeingItineraryDetails: "",
    })
    //#endregion

    //#region Airport Transfer Inclusions and TransferSightseeing
    const EnableAirportSightseeingInclusionIds = [8];
    const [airportSightseeinglist, setAirportSightSeeingList] = useState([]);
    const [airportSightseeingopen, setAirportSightseeingOpen] = useState(false);
    const [airportSightseeingbuttontext, setAirportSightseeingbuttontext] = useState(false);
    const [airportSightseeingdisable, setAirportSightseeingDisable] = useState(false);
    const [airportSightseeingDetail, setAirportSightseeingDetail] = useState({
        AirportSightseeingId: 0,
        AirportSightseeingName: "",
        AirportSightseeingPickupPoint: "",
        AirportSightseeingDropPoint: "",
        AirportSightseeingDuration: null,
        AirportSightseeingItineraryDetails: "",
    })
    //#endregion

    const [defcheckedvalueofpackagetype, setDefCheckedValueOfPackageType] = useState(0);
    const [checkedvalueofpackagetypevalue, setCheckedValueOfPackageTypeValue] = useState(0);
    const [hotelname, setHotelName] = useState('');
    const [sightseeingname, setSightseeingName] = useState('');

    const [editdisabled, setEditDisabled] = useState(false);
    const [allbanner, setAllBanner] = useState([]);
    const [bannerdisabled, setBannerDisabled] = useState(false);
    const [allstartpoint, setAllStartpoint] = useState([]);
    const [startpointdisabled, setStartPointDisabled] = useState(false);
    const [allendpoint, setAllEndpoint] = useState([]);
    const [endpointdisabled, setEndPointDisabled] = useState(false);
    const [fromflight, setFlightfrom] = useState([]);
    const [fromflightdisable, setFromFlightDisable] = useState(false)
    const [allflightfrom, setAllFilghtFrom] = useState([]);
    const [toflight, setFlightTo] = useState([]);
    const [toflightdisable, setToFlightDisable] = useState(false)
    const [allflightto, setAllFilghtTo] = useState([]);
    const [hoteldisable, setHotelDisable] = useState(false);

    //#region Day Schedule state
    const [hotelList, setHotelList] = useState([]);
    const [hotelnameid, setHotelNameId] = useState(0);
    const [roomMealList, setRoomMealList] = useState([]);
    const [hotelroomtypeid, setHotelRoomTypeId] = useState(0);
    const [hotelRoomId, setHotelRoomId] = useState(0);
    const [hotelrating, setHotelRating] = useState();
    const [noofpaxid, setNoOfPaxId] = useState(0);
    const [mealTypeId, setMealTypeId] = useState(0);
    //#region end

    const [inclusionwithshortnamelist, setInclusionWithShortName] = useState([])
    const [sightseeingdisable, setSightseeingDisable] = useState(false)
    const [allsightseeing, setAllSightseeing] = useState([]);
    const [aboutcitydisable, setAboutCityDisable] = useState(false)
    const [allaboutcity, setAllAboutCity] = useState([]);

    const [nightlist, setNightList] = useState([]);
    const [nightid, setNightId] = useState(0);
    const [overviewCityList, setOverviewCityList] = useState([])
    const [overviewCityid, setOverviewCityId] = useState(0);

    const [overviewCityDetails, setOverviewCityDetails] = useState([]);
    const [overviewCity, setOverviewCity] = useState([])
    const [overviewNight, setOverviewNight] = useState([])
    const [overviewbtntext, setOverviewBtnText] = useState('Add');
    const [overviewCityIdEdit, setOverviewCityIdEdit] = useState(0)

    const [overviewCityNightError, setOverviewCityNightError] = useState('');
    const [overviewCityLengthError, setOverviewCityLengthError] = useState('');
    const [overviewId, setOverviewId] = useState(0);
    const [nightallcity, setNightAllCity] = useState([]);
    const [citydisable, setCityDisable] = useState(false);
    const [attractionList, setAttractionList] = useState([]);
    const [attractionDetailShow, setAttractionDetailShow] = useState(false);

    const getalllocationData = async () => {
        await getAllData('/master/vendor/v1/vengetpackagelocationcity').then((response) => {
            if (packageD.state.PackageId <= 0 || packageD.state.PackageId == null) {
            }
            else {
                setNightAllCity(response.data)
            }

            // load city overview in live
            const overviewCity = response.data?.filter((value) => formvalue?.LocationId?.includes(value.LocationId))?.map((ele) => ({
                label: ele.City,
                value: ele.LocationId
            }))
            setOverviewCityList(overviewCity)
        });
    }

    const getslot = async () => {
        const arrivallistslot = await getAllData('/master/v1/getpackageslot');
        setSlotList(arrivallistslot.data);
    }

    const arrivalslotlist = slotlist?.map((value) => ({
        label: value.SlotName,
        value: value.SlotId
    }));

    const departureslotlist = slotlist?.map((value) => ({
        label: value.SlotName,
        value: value.SlotId
    }));

    const getbannerlist = async () => {
        const PackageId = packageD.state.PackageId;
        const bannerlistD = await getAllData('/master/v1/getpackagebanner?PackageId=' + PackageId);

        setBannerList(bannerlistD.data?.filter(IsAct => IsAct.IsActive === true));
        setAllBanner(bannerlistD.data);
    }

    const bannerdatalist = bannerlist?.map((value) => ({
        label: value?.BannerName,
        value: value?.BannerId
    }));

    const getgallerylist = async () => {
        const PackageId = packageD.state.PackageId;
        const gallerylistdata = await getAllData('/master/v1/getpackagegallery?PackageId=' + PackageId);
        setGalleryList(gallerylistdata.data?.map((el) => ({
            label: el.ImageDisplayName,
            value: el.GalleryId,
            ImageList: el?.ImageList ? JSON.parse(el?.ImageList) : [],
            SelectedImages: el?.SelectedImages ? JSON.parse(el?.SelectedImages) : []
        })));
    }

    const getpackagetype = async () => {
        const packagetypelistdata = await getAllData('/master/v1/getpackagetype');
        setPackageTypeList(packagetypelistdata.data);
        packagetypelistdata.data?.map((value) => {
            if (value.IsDefault === true) {
                setDefCheckedValueOfPackageType(value.PackageTypeId);
                setCheckedValueOfPackageTypeValue(value.PackageTypeId);
                setFormValue((form) => ({ ...form, PackageTypeId: Number(value.PackageTypeId) }))
            }
        });
    }

    const getpackagelevel = async () => {
        const packagelevellistdata = await getAllData('/master/v1/getpackagelevel');
        setPackageLevelList(packagelevellistdata.data);
    }

    const IsInterCityRadio = [
        { id: 1, title: 'Intercity' },
        { id: 2, title: 'Intracity' }
    ]

    useEffect(() => {
        if (formvalue?.LocationId?.length > 1) {
            setFormValue((form) => ({ ...form, IsInterCity: true }));
        }
        else {
            setFormValue((form) => ({ ...form, IsInterCity: false }));
        }

    }, [formvalue?.LocationId])

    const handleFlight = () => {
        setFlightOpen(!flightopen)
        setFlightbuttontext(!flightbuttontext)
    }

    const handleHotel = () => {
        // setHotelbuttontext(!hotelopen)
        setHotelbuttontext(!hotelbuttontext)
    }

    const handleTransferSightseeing = (type) => {
        if (type === "Transfers") {
            setTransferSightseeingOpen(!transferSightseeingopen);
            setTransferSightseeingbuttontext(!transferSightseeingbuttontext);
        }
        else {
            setAirportSightseeingOpen(!airportSightseeingopen);
            setAirportSightseeingbuttontext(!airportSightseeingbuttontext);
        }
    }

    const handleSightseeing = () => {
        steSightseeingOpen(!sightseeingopen)
        setSightseeingbuttontext(!sightseeingbuttontext)
    }

    const handleVehicle = () => {
        steVehicleTransferOpen(!vehicleTransferOpen)
        setVehicleTransferButtonText(!vehicleTransferButtonText)
    }

    const getpackagecategory = async () => {
        const packagecategorylist = await getAllData('/master/v1/getpackagecategory');
        setPackageCategoryList(packagecategorylist.data);
    }
    const packagecategorydatalist = packagecategorylist?.map((value) => ({
        label: value.PackageCategoryName,
        value: value.PackageCategoryId
    }));

    const getInclusionList = async () => {
        const listofinclusiondata = await getAllData('/master/v1/getpackageinclusion');
        setInclusionList(listofinclusiondata.data);
    }

    const inclusionlistdata = inclusionlist?.map((value) => ({
        label: value.InclusionName,
        value: value.InclusionId,
        ShortName: value?.ShortName,
        IsActive: value?.IsActive
    }));

    const getExclusionList = async () => {
        const listofexclusiondata = await getAllData('/master/v1/getpackageexclusion');
        setExclusionList(listofexclusiondata.data);
    }

    const exclusionistdata = exclusionlist?.map((value) => ({
        label: value.ExclusionName,
        value: value.ExclusionId,
        IsActive: value.IsActive
    })) || [];

    const getPolisylist = async () => {
        const listofpolicydata = await getAllData('/master/v1/getpackagepolicy');
        setPolicyList(listofpolicydata.data);
    }

    const policylistdata = policylist?.map((value) => ({
        label: value.PolicyName,
        value: value.PolicyId
    }));

    const getMenulist = async () => {
        const listofmenudata = await getAllData('/master/v1/getpackagemenu');
        setMenuList(listofmenudata.data);
    }

    const getDurationdatallist = async () => {
        const durationlistD = await getAllData('/master/v1/getpackageduration');
        setDurationList(durationlistD.data);
    }

    const durationlistofoverview = durationlist?.map((value) => ({
        label: value.Duration,
        value: value.DurationId
    }));

    const getdurationtovisit = async () => {
        const visitduration = await getAllData('/master/v1/getpackagemonth');
        setVisitFromDurationList(visitduration.data);
        setVisitToDurationList(visitduration.data);
    }

    const visitfromdurationlist = visitfromduration?.map((value) => ({
        label: value.MonthName,
        value: value.MonthId
    }));

    const visittodurationlist = visittoduration?.map((value) => ({
        label: value.MonthName,
        value: value.MonthId
    }));

    const getpackagepoint = async () => {
        await getAllData('/master/v1/getpackagelocationcity').then((packagepointlist) => {
            setPackageoint(packagepointlist.data?.filter(IsAct => IsAct.IsActive === true));
            setEndPackageoint(packagepointlist.data?.filter(IsAct => IsAct.IsActive === true));
            setFlightfrom(packagepointlist.data?.filter(IsAct => IsAct.IsActive === true));
            setFlightTo(packagepointlist.data?.filter(IsAct => IsAct.IsActive === true));
            setAllFilghtFrom(packagepointlist.data);
            setAllFilghtTo(packagepointlist.data);
            setAllStartpoint(packagepointlist.data);
            setAllEndpoint(packagepointlist.data);
            handleRetrive();
            dispatch(loaderActions.end());
        });
    }

    const packagepointfromlist = packagepoint?.map((value) => ({
        label: value.City,
        value: value.LocationId
    }));

    const packagepointtolist = endpackagepoint?.map((value) => ({
        label: value.City,
        value: value.LocationId
    }));

    const getpackagethemelist = async () => {
        const packagethemelistD = await getAllData('/master/v1/getpackagetheme');
        setPackageTheme(packagethemelistD.data);
    }

    const packagethemelist = packagetheme?.map((value) => ({
        label: value.ThemeName,
        value: value.ThemeId
    }));

    const getaboutplacecity = async () => {
        const aboutplacecity = await getAllData('/master/v1/getpackagelocationcity');
        setAboutPlaceCityList(aboutplacecity.data?.filter(IsAct => IsAct.IsActive === true));
        setAllAboutCity(aboutplacecity.data)
    }

    const aboutplacecitydatalist = aboutplacecitylist?.map((value) => ({
        label: value.City,
        value: value.LocationId
    }));
    const flightfrom = fromflight?.map((value) => ({
        label: value?.City,
        value: value?.LocationId
    }));

    const flightto = toflight?.map((value) => ({
        label: value?.City,
        value: value?.LocationId
    }));

    const getpackageinclusionwithshortname = async () => {
        const getpackageinclusionwithshortname = await getAllData('/master/v1/getpackageinclusionwithshortname');
        setInclusionWithShortName(getpackageinclusionwithshortname?.data?.map((value) => ({
            label: value.ShortName,
            value: value.InclusionId
        })));
    }

    //#region start day schedule func
    const gethotelnamelist = async (data) => {
        const hotelList = await postUsersData('/master/v1/getpackagehotel', data);

        if (hotelList?.status) {
            const dataObj = hotelList.data?.filter(IsAct => IsAct.isActive === true)?.map((hotel) => ({ ...hotel, label: hotel?.name, value: hotel?.hotelId }));
            setHotelList(dataObj);
        }

        // setAllHotel(roomtype.data);
    }

    const handleRoomTypeChange = async (e) => {
        const roomMealTypes = e?.hotelMealModel.map((val) => ({
            ...val,
            label: val.rateTypeName,
            value: val.rateTypeId
        })) || [];

        setRoomMealList(roomMealTypes);

        if (hotelroomtypeid !== e.value) {
            setNoOfPaxId(e?.noOfPax);
            formvalue.HotelPrice = ''
        }
        setHotelRoomId(e.hotelRoomId);
        setMealTypeId(0);
        setHotelRoomTypeId(e.value);
    }

    const handleMealType = (val) => {
        setFormValue({
            ...formvalue, HotelPrice: formvalue?.IsPriceType ? val?.price : 0
        });
        setMealTypeId(val?.value)
    };

    //#region end Day Schedule Function
    const getsightseeinglistdata = async () => {
        const sightseeingD = await getAllData('/master/v1/getpackagesightseeing?packageId=' + packageD?.state?.PackageId);
        setSightSeeingList(sightseeingD.data?.filter(IsAct => IsAct.IsActive === true));
        setTransferSightSeeingList(sightseeingD.data?.filter(IsAct => IsAct.IsActive === true));
        setAirportSightSeeingList(sightseeingD.data?.filter(IsAct => IsAct.IsActive === true));
        setAllSightseeing(sightseeingD.data)
    }
    const getvehiclecategoryandlist = async () => {
        const vehiclecategoryandlist = await getAllData('/master/v1/getvehiclecategoryandlist');
        if (vehiclecategoryandlist?.status) {

            vehiclecategoryandlist?.data?.vehicleCategoryList?.map((obj) => {
                obj.label = obj?.VehicleCategory
                obj.value = obj?.VehicleCategoryId
                return obj;
            })
            vehiclecategoryandlist?.data?.vehicleList?.map((obj) => {
                obj.label = obj?.VehicleName
                obj.value = obj?.VehicleDetailId
                return obj;
            })

            setVehicleTransferCategoryAndListData((prev) => ({
                ...prev,
                vehicleCategoryList: vehiclecategoryandlist?.data?.vehicleCategoryList ? vehiclecategoryandlist?.data?.vehicleCategoryList : [],
                vehicleList: vehiclecategoryandlist?.data?.vehicleList ? vehiclecategoryandlist?.data?.vehicleList : []
            }));
        }
        else {
            setVehicleTransferCategoryAndListData((prev) => ({
                ...prev,
                vehicleCategoryList: [],
                vehicleList: []
            }));
        }
    }

    const sightseeinglistdata = sightseeinglist?.map((value) => ({
        label: value?.SightseeingName,
        value: value?.SightseeingId,
        ItineraryDetails: value?.ItineraryDetails
    }));

    const transfersightseeinglistdata = transferSightseeinglist?.map((value) => ({
        label: value?.SightseeingName,
        value: value?.SightseeingId
    }));

    const airportSightseeinglistdata = airportSightseeinglist?.map((value) => ({
        label: value?.SightseeingName,
        value: value?.SightseeingId
    }));

    const getattractionbasiclist = async () => {
        const attractionbasiclist = await getAllData('/master/v1/getattractionbasiclist')
        if (attractionbasiclist?.status) {
            let attraction = attractionbasiclist?.data?.filter((obj) => formvalue?.LocationId?.includes(obj?.LocationId))?.map((item) => ({
                value: item?.AttractionBasicId,
                label: item?.AttractionName,
                category: item?.CategoryName,
                theme: item?.ThemeName,
                type: item?.TypeName,
            }))
            setAttractionList(attraction)
        }
        else {
            setAttractionList([])
        }
    }

    const handleSelectAttraction = (e) => {
        reseterrormessage();
        setFormValue((form) => ({ ...form, AttractionBasicId: e.map(obj => obj.value) }))
    }

    const InputOption = ({
        getStyles,
        Icon,
        isDisabled,
        isFocused,
        isSelected,
        children,
        innerProps,
        ...rest
    }) => {
        const [isActive, setIsActive] = useState(false);
        const onMouseDown = () => setIsActive(true);
        const onMouseUp = () => setIsActive(false);
        const onMouseLeave = () => setIsActive(false);

        // styles
        let bg = "transparent";
        if (isFocused) bg = "#eee";
        if (isActive) bg = "#B2D4FF";

        const style = {
            alignItems: "center",
            backgroundColor: bg,
            color: "inherit",
            display: "flex "
        };

        // prop assignment
        const props = { ...innerProps, onMouseDown, onMouseUp, onMouseLeave, style };

        return (
            <components.Option
                {...rest}
                isDisabled={isDisabled}
                isFocused={isFocused}
                isSelected={isSelected}
                getStyles={getStyles}
                innerProps={props}
            >
                <span className='position-relative'>
                    <input className='form-check-input dropdowncheckbox' type="checkbox" defaultChecked={isSelected} />
                    <span className='dropdownvalue'>
                        {children}
                    </span>
                </span>
            </components.Option>
        );
    };

    const locationDropdown = useMemo(() =>
        locationData?.reduce((acc, curr) => {
            curr.countryData?.map((obj) => {
                acc.country.push({ value: obj.CountryId, label: obj.CountryName })
            })
            curr.stateData?.filter(state => formvalue?.CountryId?.includes(state.CountryId))?.map((obj) => {
                acc.state.push({ value: obj.StateId, label: obj.StateNAme })
            })
            curr.cityData?.filter(city => (formvalue?.CountryId?.filter(countryId => countryId !== 1)?.includes(city.CountryId)
            ) || (formvalue?.StateId?.filter(StateId => StateId !== 1)?.includes(city.StateId)))
                ?.forEach((obj) => {
                    acc.city.push({ value: obj.LocationId, label: obj.City });
                });

            if (!formvalue?.CountryId?.includes(1)) {
                let stateid = acc.state[0]?.value
                formvalue?.StateId?.push(stateid)
            }

            return acc
        }, { country: [], state: [], city: [] })
        , [locationData, formvalue.CountryId, formvalue.StateId])

    const getcountrystatecity = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const countrystatecity = await getAllData('/master/v1/getcountrystatecity')
            if (countrystatecity.status) {
                setLocationData([countrystatecity?.data])
            }
            else {
                dispatch({ type: 'ALERTING', message: countrystatecity.message })
                dispatch(loaderActions.end())
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end())
        }
    }

    const onSelectChange = (name, e) => {
        setBasicDraftDisabled(false);
        setFormError('');
        if (name === "CountryId") {
            const selectedCountryId = e?.map(obj => obj?.value);
            setFormValue(form => ({
                ...form,
                StateId: [],
                LocationId: [],
                CountryId: selectedCountryId,
                PackageLevelId: selectedCountryId.length === 1 && selectedCountryId?.[0] === 1 ? 1 : (selectedCountryId.length > 1 || selectedCountryId.length === 1 && selectedCountryId?.[0] !== 1) ? 2 : 0
            }))
        }
        else if (name === "StateId") {
            setFormValue(form => ({ ...form, LocationId: [], StateId: e?.map(obj => obj?.value) }))
        }
        else if (name === "LocationId") {
            setFormValue(form => ({ ...form, LocationId: e?.map(obj => obj?.value) }))
        }
    }

    useEffect(() => {
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            if (packageD.state != null) {
                getcountrystatecity();
                getalllocationData();
                getslot();
                getbannerlist();
                getgallerylist();
                getpackagetype();
                getpackagelevel();
                getpackagecategory();
                getInclusionList();
                getExclusionList();
                getPolisylist();
                getMenulist();
                getDurationdatallist();
                getdurationtovisit();
                getpackagepoint();
                getpackagethemelist();
                getaboutplacecity();
                getpackageinclusionwithshortname();
                getsightseeinglistdata();
                getvehiclecategoryandlist();
                setEditDisabled(packageD.state.editdisabled);
                if (packageD.state.PackageId > 0) {
                    if (packageD.state.viewtype === 'View') {
                        setDisabled(packageD.state.editdisabled);
                    };
                    setAtFirstDisable(packageD.state.atfirstdisable);
                    setClearDisable(true);
                    setIsBasicShown(false);
                    setIsAddShown(true);
                    setIsAddDraftShown(true);
                    SetIsDetailBlockShow(true);
                    setIsRetrive(true);
                    setStateDisable(true);
                }
            }
            else {
                navigate('/Packagelist')
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }, []);

    useEffect(() => {
        if (formvalue?.PackageValidateStartD && formvalue?.PackageValidateEnd) {

            setHotelNameId(0);
            setHotelRoomTypeId(0);
            setMealTypeId(0);
            setRoomMealList([]);
            setRoomTypeList([]);
            setHotelbuttontext(false)

            gethotelnamelist({
                PackageId: formvalue?.PackageId,
                PackageValidateStart: formvalue?.PackageValidateStartD,
                PackageValidateEnd: formvalue?.PackageValidateEnd
            });
        }
    }, [formvalue?.PackageValidateStart, formvalue?.PackageValidateEnd])
    //#endregion

    //#region handle dropdown change
    const [banneridlist, setBannerIdList] = useState({
        BannerId: 0
    });

    const [themeidlist, setThemeIdList] = useState([{
        ThemeId: 0,
        Id: 0
    }]);

    const [bannerimgpath, setBannerImgPath] = useState('');

    const themeimgpathlist = useState([{
        ThemeId: 0,
        ThemePath: '',
        Id: 0
    }]);

    const [themeimgpath, setThemeImgPath] = useState(themeimgpathlist);
    const [galleryimgpath, setGalleryImgPath] = useState([]);
    const [bannerId, setBannerId] = useState(0);
    const [durationid, setDurationId] = useState(0);
    const [visitfromdurationid, setVisitFromDurationId] = useState(0);
    const [visittodurationid, setVisitToDurationId] = useState(0);
    const [visitpointfromid, setVisitFromId] = useState(0);
    const [visitpointtoid, setVisitToId] = useState(0);

    const [themebyid, setThemeById] = useState(0);
    const [themebycounter, setThemeCounter] = useState(0);

    useEffect(() => {
        if (formvalue?.LocationId?.length > 0) {
            getattractionbasiclist();
        }
    }, [formvalue?.LocationId])

    const handleBannerChange = (e) => {
        setBannerId(e.value);
        banneridlist.BannerId = e.value
        formvalue.PackageBanner = [banneridlist]
        bannerlist?.filter((obj) => obj.BannerId === e.value).map((value) => {
            setBannerImgPath(CommonFileURLWithFolder + value.BannerPath);
        });
        reseterrormessage();
        setEditDisabled(false);
    }

    const removeBannerImage = () => {
        setBannerId(0);
        banneridlist.BannerId = 0
        formvalue.PackageBanner = [banneridlist]
        setBannerImgPath('');
        reseterrormessage();
        setEditDisabled(false);
    }

    const handleisActive = (e) => {
        if (!isAddShown) {
            setFormValue((form) => ({ ...form, IsActive: !form?.IsActive }));
            reseterrormessage();
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setFormValue((form) => ({ ...form, IsActive: !form?.IsActive }));
            reseterrormessage();
            setEditDisabled(false);
        }
        setModalShow(false);
    }

    const handleGalleryChange = (e) => {
        setFormValue((form) => ({
            ...form,
            PackageGallery: e?.map((val) => ({
                GalleryId: val.value,
                GalleryMasterImageId: galleryimgpath?.filter(item => item?.GalleryId === val.value)?.length > 0 ? galleryimgpath?.filter(item => item?.GalleryId === val.value)?.map(newid => newid?.GalleryMasterImageId) : val?.ImageList?.map(el => el.GalleryMasterImageId)
            }))
        }));
        let pathlist = [];

        e?.forEach((check) => {
            const exists = galleryimgpath?.some(
                (item) => item?.GalleryId === check.value
            );
            if (exists) {
                const filtered = galleryimgpath?.filter(
                    (obj) => obj?.GalleryId === check.value
                );
                pathlist = [...pathlist, ...filtered];
            } else {
                const matched = gallerylist?.find(
                    (obj) => obj.value === check.value
                );
                const images =
                    matched?.ImageList?.map((el) => ({
                        GalleryId: matched.value,
                        GalleryPath: CommonFileURLWithFolder + el?.ImagePath,
                        GalleryMasterImageId: el?.GalleryMasterImageId
                    })) || [];

                pathlist = [...pathlist, ...images];
            }
        });
        setGalleryImgPath(pathlist || []);
        reseterrormessage();
        setEditDisabled(false);
    }

    const removeGalleryImage = (id, GalleryMasterImageId) => {
        setGalleryImgPath((oldState) => oldState?.filter((item) => item.GalleryMasterImageId !== GalleryMasterImageId));
        setFormValue((form) => {
            const updated = form?.PackageGallery?.map((item) =>
                item.GalleryId === id
                    ? {
                        ...item,
                        GalleryMasterImageId: item?.GalleryMasterImageId?.filter(
                            (imgId) => imgId !== GalleryMasterImageId
                        )
                    }
                    : item
            );
            // remove objects with empty GalleryMasterImageId
            const filtered = updated?.filter((item) => item?.GalleryMasterImageId?.length > 0);
            return {
                ...form,
                PackageGallery: filtered
            };
        });
        reseterrormessage();
        setEditDisabled(false);
    }

    const handledropdown = (name, val) => {
        reseterrormessage();
        setEditDisabled(false);
        setFormValue((form) => ({ ...form, [name]: val }))
    }

    const [totalNights, setTotalNights] = useState(0)

    const handledurationchange = (e) => {
        setDurationId(e.value);
        reseterrormessage();
        setEditDisabled(false);
        const nightid = durationlist?.map(id => {
            if (id.DurationId === e.value) {
                return id.NightId
            }
        }).find(x => x != undefined ? x : '')
        setTotalNights(nightid)
        const nightlistdata = durationlist?.filter(obj => obj.NightId <= nightid)?.map((value) => ({
            label: value.Night,
            value: value.NightId
        }));
        setNightList(nightlistdata)
    }

    const handleNightChange = (e) => {
        const night = [
            { label: e.label, value: e.value }
        ]
        setNightId(e.value)
        reseterrormessage();
        setEditDisabled(false);
        setOverviewNight(night)
    }

    const handlecityDatachange = (e) => {
        const city = [
            { label: e.label, value: e.value }
        ]
        setOverviewCityId(e.value)
        reseterrormessage();
        setEditDisabled(false);
        setOverviewCity(city)
    }

    const [curTotalNight, setCurTotalNight] = useState(0)
    const handleOverviewAdd = (e) => {
        reseterrormessage()
        if (overviewbtntext === 'Add') {
            let totalnight = 0
            overviewCityDetails?.map(value => {
                let temp = parseInt(value.night)
                totalnight = temp + totalnight
            })
            let temp2 = parseInt(overviewNight[0]?.label != undefined ? overviewNight[0]?.label : 0)
            totalnight = temp2 + totalnight
            setCurTotalNight(totalnight)
            if (totalnight > totalNights) {
                setOverviewCityLengthError('Only ' + totalNights + ' nights are allowed')
            }
            else {
                if (overviewCityid === 0 || nightid === 0) {
                    setOverviewCityNightError('Kindly select city with no. of nights')
                }
                setOverviewId(overviewId + 1)
                setOverviewCityDetails([...overviewCityDetails, {
                    packageOverviewCityId: overviewId + 1,
                    city: overviewCity[0].label,
                    cityId: overviewCity[0].value,
                    night: overviewNight[0].label,
                    nightId: overviewNight[0].value
                }
                ]);
                setOverviewCityId(0)
                setNightId(0)
                setOverviewCity([])
                setOverviewNight([])
            }
        }
        else {
            if (overviewCityIdEdit > 0) {
                handleeditofoverview(overviewCityIdEdit);
            }
        }
    }

    const handleEditOverviewCity = (id, e) => {
        setOverviewBtnText('Update');
        setOverviewCityIdEdit(id)
        overviewCityDetails?.filter(obj => obj.packageOverviewCityId === id)?.map(value => {
            setOverviewCityId(value.cityId)
            setNightId(value.nightId)
            const city = [
                { label: value.city, value: value.cityId }
            ]
            const night = [
                { label: value.night, value: value.nightId }
            ]
            setOverviewCity(city)
            setOverviewNight(night)
            let allcitylist = nightallcity?.filter(IsAct => IsAct.IsActive === true);
            setOverviewCityList(allcitylist?.filter((val) => formvalue?.LocationId?.includes(val.LocationId))?.map((ele) => ({
                label: ele.City,
                value: ele.LocationId
            })));
            setCityDisable(false);
            if (!allcitylist?.find(IsCity => IsCity.LocationId === value.cityId)) {
                setCityDisable(true)
                setOverviewCityList((prvCityData) => prvCityData?.length > 0 ? [...prvCityData, nightallcity?.find(isCity => isCity.LocationId === value.cityId)]?.map((el) => ({
                    label: el.City,
                    value: el.LocationId
                })) : [])
            }
        })

        reseterrormessage();
        setEditDisabled(false);
    }

    const handleeditofoverview = (id) => {
        let totalnight = 0
        let tid = 0
        overviewCityDetails?.map(value => {
            if (value.packageOverviewCityId === id) {
                tid = parseInt(value.night)
            }
            let temp = parseInt(value.night)
            totalnight = temp + totalnight
        })
        let temp2 = parseInt(overviewNight[0]?.label != undefined ? overviewNight[0]?.label : 0)
        totalnight = temp2 + totalnight - tid
        setCurTotalNight(totalnight)
        if (totalnight > totalNights) {
            setOverviewCityLengthError('Only ' + totalNights + ' nights are allowed')
        }
        else {
            const overviewData = overviewCityDetails?.map(value => {
                if (value.packageOverviewCityId === id) {
                    value.city = overviewCity[0].label
                    value.night = overviewNight[0].label
                    value.cityId = overviewCity[0].value
                    value.nightId = overviewNight[0].value
                }
                return value
            })
            setOverviewCityDetails(overviewData)
            setOverviewBtnText('Add');
            setOverviewCityId(0)
            setNightId(0)
            reseterrormessage();
            setEditDisabled(false);
            setOverviewCity([])
            setOverviewNight([])
        }
    }

    const removeverviewCity = (id, e) => {
        setOverviewCityDetails((oldState) => oldState?.filter((item) => item.packageOverviewCityId !== id))
        setOverviewBtnText('Add');
        setOverviewCityId(0)
        setNightId(0)
        reseterrormessage();
        setEditDisabled(false);
    }

    useEffect(() => {
        let totalnight = 0
        overviewCityDetails?.map(value => {
            let temp = parseInt(value.night)
            totalnight = temp + totalnight
        })
        setCurTotalNight(totalnight)
    }, [overviewCityDetails, overviewNight, curTotalNight])

    const handledurationfromchange = (e) => {
        setVisitFromDurationId(e.value);
        reseterrormessage();
        setEditDisabled(false);
    }

    const handledurationtochange = (e) => {
        setVisitToDurationId(e.value);
        reseterrormessage();
        setEditDisabled(false);
    }

    const handlevisitfrompoint = (e) => {
        setVisitFromId(e.value);
        reseterrormessage();
        setEditDisabled(false);
    }

    const handlevisittopoint = (e) => {
        setVisitToId(e.value);
        reseterrormessage();
        setEditDisabled(false);
    }

    const handlethemebychange = (e) => {
        setThemeById(e.value);
        reseterrormessage();
        setThemeCounter(themebycounter + 1);
        setEditDisabled(false);
    }

    const GetThemeImage = () => {
        const themeimagerepeat = themeimgpath?.filter((obj) => obj.ThemeId === themebyid);
        if (themeimagerepeat.length === 0) {
            packagetheme?.filter((obj) => obj.ThemeId === themebyid).map((value) => {
                if (themebycounter === 1) {
                    setThemeIdList([{ ThemeId: themebyid, Id: themebycounter }]);
                    setThemeImgPath(current => [{ ThemeId: value.ThemeId, ThemePath: CommonFileURLWithFolder + value.ImagePath, Id: themebycounter }]);
                }
                else {
                    setThemeIdList(current => [...current, { ThemeId: themebyid, Id: themebycounter }]);
                    setThemeImgPath(current => [...current, { ThemeId: value.ThemeId, ThemePath: CommonFileURLWithFolder + value.ImagePath, Id: themebycounter }]);
                }
            });
        }
    }

    const removeThmeImage = (id) => {
        setThemeImgPath((oldState) => oldState?.filter((item) => item.Id !== id));
        setThemeIdList((oldState) => oldState?.filter((item) => item.Id !== id));
        setThemeById(0);
        reseterrormessage();
        setEditDisabled(false);
    }

    const handleDaysightseeing = (e) => {
        setFormValue((form) => ({ ...form, DaySightseeingId: e.value, Day: e.label, DaySchedule: e.ItineraryDetails }));
    }

    const handleinclusionnamechange = (e) => {
        reseterrormessage();
        const selectedInclusion = e.map(obj => obj.value)
        setFormValue((form) => ({ ...form, InclusionId: selectedInclusion }));
        if (!selectedInclusion?.includes(1)) {
            setHotelNameId(0);
            setHotelRoomId(0);
            setMealTypeId(0);
            setHotelRating(0);
            setHotelRoomTypeId(0);
            setHotelName('');
            setRoomTypeList([]);
            formvalue.HotelPrice = ''
            setNoOfPaxId(0);
        }
        if (!EnableSightseeingInclusionIds?.some((ele) => selectedInclusion?.includes(ele))) {
            formvalue.SightseeingId = 0
            formvalue.PickUpPoint = ''
            formvalue.DropPoint = ''
            formvalue.Hours = ''
            formvalue.ItineraryDetails = ''
            setHoursTime(null)
            setSightseeingName("");
            setVehicalTypeId(0);
            formvalue.VehicalPrice = ''
            setVehicalPrice('');
            setVehicalListData([]);
            setVehicalTypeList([]);
            setSightSeeingId(0);
        }
        if (!EnableTransferSightseeingInclusionIds?.some((ele) => selectedInclusion?.includes(ele))) {
            setTransferSightseeingDetail((form) => ({
                ...form,
                TransferSightseeingId: 0,
                TransferSightseeingName: "",
                TransferSightseeingPickupPoint: "",
                TransferSightseeingDropPoint: "",
                TransferSightseeingDuration: null,
                TransferSightseeingItineraryDetails: "",
            }))

        }
        if (!EnableAirportSightseeingInclusionIds?.some((ele) => selectedInclusion?.includes(ele))) {
            setAirportSightseeingDetail((form) => ({
                ...form,
                AirportSightseeingId: 0,
                AirportSightseeingName: "",
                AirportSightseeingPickupPoint: "",
                AirportSightseeingDropPoint: "",
                AirportSightseeingDuration: null,
                AirportSightseeingItineraryDetails: "",
            }))

        }
        if (!selectedInclusion?.includes(5)) {
            steVehicleTransferOpen(false)
            setVehicleTransferButtonText(false)
            setVehicleTransferDisabled(false)
            setVehicleTransferNameDisabled(false)
            setVehicleTransferId(0)
            setSelectedVehicleTransferDetail((prev) => ({
                ...prev,
                VehicleDetailId: 0,
                VehicleName: "",
                SeatingCapacity: "",
                VehicleType: "",
            }))
        }

        if (e.filter(obj => obj.value === 1)?.length === 0 && hotelbuttontext) {
            setHotelbuttontext(!hotelbuttontext)
        }
        if (e.filter(obj => obj.value === 2)?.length === 0 && flightopen) {
            setFlightOpen(!flightopen)
            setFlightbuttontext(!flightbuttontext)
        }
        if (e.filter(obj => EnableSightseeingInclusionIds?.includes(obj.value))?.length === 0 && sightseeingopen) {
            steSightseeingOpen(!sightseeingopen)
            setSightseeingbuttontext(!sightseeingbuttontext)
        }
        if (e.filter(obj => EnableTransferSightseeingInclusionIds?.includes(obj.value))?.length === 0 && transferSightseeingopen) {
            setTransferSightseeingOpen(!transferSightseeingopen);
            setTransferSightseeingbuttontext(!transferSightseeingbuttontext);
        }
        if (e.filter(obj => EnableAirportSightseeingInclusionIds?.includes(obj.value))?.length === 0 && airportSightseeingopen) {
            setAirportSightseeingOpen(!airportSightseeingopen);
            setAirportSightseeingbuttontext(!airportSightseeingbuttontext);
        }
        if (e.filter(obj => obj.value === 5)?.length === 0 && vehicleTransferOpen) {
            steVehicleTransferOpen(!vehicleTransferOpen)
            setVehicleTransferButtonText(!vehicleTransferButtonText)
        }
    }

    const attractionDetail = useMemo(() => {
        return attractionList?.filter((obj) => formvalue?.AttractionBasicId?.includes(obj.value))
    }, [formvalue?.AttractionBasicId, attractionList])

    const handlehotelnamechange = (e) => {
        setHotelName(e.name);
        setHotelNameId(e.value);
        setHotelRating(e.rating);

        const roomdetail = e.hotelRoomsModel?.map((val) => ({ ...val, label: val.roomTypeName, value: val.roomTypeId }));
        setRoomTypeList(roomdetail);

        //on Hotel change clear date dependent on it
        setFormValue({ ...formvalue, HotelPrice: '' })
        setNoOfPaxId(0);
        setHotelRoomTypeId(0);
        setMealTypeId(0);
        setHotelbuttontext(false);
        setHotelRoomId(0);
    }

    const [vehicalistdata, setVehicalListData] = useState([]);
    const [vehicalprice, setVehicalPrice] = useState('');
    const [vehicaltypeid, setVehicalTypeId] = useState(0);
    const [sightseeingid, setSightSeeingId] = useState(0);

    const handletransfersightseeingchange = (e, type) => {
        if (type === "Transfers") {
            transferSightseeinglist?.filter(obj => obj?.SightseeingId === e?.value).forEach((value) => {
                setTransferSightseeingDetail((form) => ({
                    ...form,
                    TransferSightseeingId: e?.value,
                    TransferSightseeingName: value?.SightseeingName,
                    TransferSightseeingPickupPoint: value?.PickUpPoint,
                    TransferSightseeingDropPoint: value?.DropPoint,
                    TransferSightseeingDuration: value?.Hours ? dayjs(value?.Hours) : null,
                    TransferSightseeingItineraryDetails: value?.ItineraryDetails,
                }))
            })
        }
        else {
            airportSightseeinglist?.filter(obj => obj?.SightseeingId === e?.value).forEach((value) => {
                setAirportSightseeingDetail((form) => ({
                    ...form,
                    AirportSightseeingId: e?.value,
                    AirportSightseeingName: value?.SightseeingName,
                    AirportSightseeingPickupPoint: value?.PickUpPoint,
                    AirportSightseeingDropPoint: value?.DropPoint,
                    AirportSightseeingDuration: value?.Hours ? dayjs(value?.Hours) : null,
                    AirportSightseeingItineraryDetails: value?.ItineraryDetails,
                }))
            })
        }

    }

    const handlesightseeingchange = async (e) => {
        sightseeinglist?.filter(obj => obj.SightseeingId === e.value).map((value) => {
            formvalue.SightseeingId = e.value
            formvalue.PickUpPoint = value.PickUpPoint
            formvalue.DropPoint = value.DropPoint
            formvalue.Hours = value.Hours
            formvalue.ItineraryDetails = value.ItineraryDetails
            setHoursTime(value.Hours ? dayjs(value.Hours) : null)
            setSightseeingName(value.SightseeingName);
        })
        const SightseeingId = formvalue.SightseeingId;
        const vehicallist = await postUsersData('/master/v1/getpackagesightseeingdetail', { SightseeingId });
        const vehichallistD = vehicallist.data?.map((value) => ({
            label: value.VehicleName,
            value: value.VehicleDetailId
        })) || [];
        setVehicalTypeId(0);
        formvalue.VehicalPrice = ''
        setVehicalPrice('');
        setVehicalListData(vehichallistD);
        setVehicalTypeList(vehicallist.data);
        setSightSeeingId(e.value);
    }

    const handlevehicaltype = (e) => {
        const pricedata = vehicaltypelist?.filter((obj) => obj.VehicleDetailId === e.value).map((value) => {
            return value.Price
        });
        setVehicalTypeId(e.value);
        formvalue.VehicalPrice = pricedata[0]
        setVehicalPrice(pricedata[0]);
    }

    useEffect(() => {
        if (themebycounter > 0)
            GetThemeImage();
    }, [themebycounter])

    //#endregion

    //#region  clear section 
    const handleclear = () => {
        clear();
    }

    const clear = () => {
        reseterrormessage();
        resetDisableStateofcontrol();
        setFormValue({
            ...formvalue, PackageName: "", PackageCode: "", StateId: [], LocationId: [], CountryId: [], ChildrenPrice: null,
            PackageTypeId: defcheckedvalueofpackagetype, PackageLevelId: 0, IsInterCity: false, IsBestPackage: false,
            ArrivalSlotId: 0, DepartureSlotId: 0, PackageValidateStart: null, PackageValidateEnd: null,
            PackageValidateStartD: "", PackageValidateEndD: "",
            PackageInventoryCountD: '', PackageInventoryCount: 0, PackageCutOffCountD: '', PackageCutOffCount: 0,
            PackageHighlights: "", PackageOverview: [],
            IsActive: false, IsDraft: false, PackageBanner: [], PackageGallery: [],
            Day: '', AttractionBasicId: [], InclusionId: [], DaySchedule: '', AirrivalTime: null, DepartureTime: null,
            ArrivalTimeD: '', DepartureTimeD: '', HotelPrice: '', SightseeingId: 0,
            Duration: '', PickUpPoint: '', DropPoint: '', ItineraryDetails: '',
            Hours: '', FlightPrice: '', InclusionD: '', datainclusiondetails: [],
            ExclusionD: '', dataexclusiondetails: [], PolicyD: '', datapolicydetails: [],
            CityD: '', CityName: '', CityDetailsD: '', datacitydetails: [], PackageInclusion: [],
            PackageExclusion: [], PackagePlace: [], PackageItinerary: [], PackageThemeId: [], IsHotDeals: false,
            HotOfferPercentage: 0, IsInternationalDestination: false, IsBestDestination: false, IsTrendingHoliday: false
        });
        setTransferSightseeingDetail((form) => ({
            ...form,
            TransferSightseeingId: 0, TransferSightseeingName: "", TransferSightseeingPickupPoint: "",
            TransferSightseeingDropPoint: "", TransferSightseeingDuration: null, TransferSightseeingItineraryDetails: "",
        }))
        setAirportSightseeingDetail((form) => ({
            ...form,
            AirportSightseeingId: 0, AirportSightseeingName: "", AirportSightseeingPickupPoint: "",
            AirportSightseeingDropPoint: "", AirportSightseeingDuration: null, AirportSightseeingItineraryDetails: "",
        }))
        resetcontrolvalues();
    }

    const resetcontrolvalues = () => {
        setBannerImgPath('');
        setBannerIdList({ BannerId: 0 });
        setGalleryImgPath([]);
        setBannerId(0);
        setBestPackage(false);
        setDurationId(0);
        setVisitFromDurationId(0);
        setVisitToDurationId(0);
        setVisitFromId(0);
        setVisitToId(0);
        setCheckedValueOfPackageTypeValue(defcheckedvalueofpackagetype);
        setInclusionDetails([]);
        setExclusionDetails([]);
        setPolicyDetails([]);
        setFlightFromId(0);
        setFlightToId(0);
        setClassId(0);
        setSupplierId(0);
        setVehicalTypeId(0);
        setVehicalPrice(0);
        setFlightNo('');
        setAirlineId(0);
        setHotelNameId(0);
        setHotelRating(0);
        setHotelName('Hotel Name');
        setSightseeingName('Sightseeing Name');
        setHotelRoomTypeId(0);
        setSightSeeingId(0);
        setNoOfPaxId(0);
        setItineraryBtnText('Add');
        setDepartureTime("--:--");
        setArrivalTime("--:--");
        setHoursTime(null);
        setPackageValidateStart(null);
        setPackageValidateEnd(null);
    }

    const reseterrormessage = () => {
        setFormError('');
        setPolicyonDuplicateError('');
        setInclusionDuplicateError('');
        setExclusionDuplicateError('');
        setOverviewCityNightError('')
        setOverviewCityLengthError('')
    }

    const resetDisableStateofcontrol = () => {
        setIsSubmit(false);
        if (packageD.state.PackgeId === 0) {
            setStateDisable(false);
        }
        setDisabled(false);
        setBasicDraftDisabled(true);
        setClearDisable(false);
        setBannerDisabled(false);
        setStartPointDisabled(false);
        setEndPointDisabled(false);
        setFromFlightDisable(false);
        setToFlightDisable(false);
        setHotelDisable(false);
        setSightseeingDisable(false);
        setAboutCityDisable(false);
        setTransferSightseeingDisable(false);
        setAirportSightseeingDisable(false);
    }
    //#endregion

    //#region Back button 
    const handleBackButton = () => {
        reseterrormessage();
        resetDisableStateofcontrol();
        resetcontrolvalues();
        navigate('/Packagelist');
    }
    //#endregion

    //#region inclusion start
    const [inclusionduplicateerror, setInclusionDuplicateError] = useState('');
    const [inclusionvalue, setInclusion] = useState([]);
    const InclusionDetails = useState([{
        InclsuionId: 0,
        Inclusion: '',
        SeqNo: 0
    }]);

    const [datainclusiondetails, setInclusionDetails] = useState(InclusionDetails);
    const [datainclusioncounter, setInclusionCounter] = useState(0);
    const InclusionClick = () => {
        if (formvalue.InclusionD !== '')
            setInclusionCounter(datainclusioncounter + 1);
    };

    function AddDataRowForInclusionDetails() {
        if (packageD.state.PackageId === 0) {
            let duplicate = datainclusiondetails?.filter(obj => obj.InclsuionId === inclusionvalue[0]?.value)
            if (duplicate.length === 0) {
                if (datainclusioncounter === 1) {
                    setInclusionDetails(current => [{
                        SeqNo: datainclusioncounter,
                        Inclusion: formvalue.InclusionD,
                        InclsuionId: inclusionvalue[0]?.value,
                        ShortName: inclusionvalue[0]?.ShortName
                    }]);
                }
                else {
                    setInclusionDetails(current => [...current, {
                        SeqNo: datainclusioncounter,
                        Inclusion: formvalue.InclusionD,
                        InclsuionId: inclusionvalue[0].value,
                        ShortName: inclusionvalue[0]?.ShortName
                    }]);
                }
            }
            else {
                setInclusionDuplicateError('You can not add duplicate value');
            }

        }
        else {
            let dinc = datainclusiondetails?.filter(obj => obj.SeqNo > 0);

            let len = dinc.length;
            let duplicate = datainclusiondetails?.filter(obj => obj.InclsuionId === inclusionvalue[0]?.value)

            if (inclusionvalue[0]?.value > 0) {
                if (duplicate.length === 0) {
                    if (len === 0) {
                        setInclusionDetails(current => [{
                            SeqNo: datainclusioncounter,
                            Inclusion: formvalue.InclusionD,
                            InclsuionId: inclusionvalue[0]?.value,
                            ShortName: inclusionvalue[0]?.ShortName
                        }]);
                    }
                    else {
                        setInclusionDetails(current => [...current, {
                            SeqNo: datainclusioncounter,
                            Inclusion: formvalue.InclusionD,
                            InclsuionId: inclusionvalue[0].value,
                            ShortName: inclusionvalue[0]?.ShortName
                        }]);
                    }
                }
                else {
                    setInclusionDuplicateError('You can not add duplicate value');
                }

            }
        }

    }

    useEffect(() => {
        if (datainclusioncounter > 0)
            AddDataRowForInclusionDetails();
    }, [datainclusioncounter]);

    const inclusionremovev = (id, e) => {
        setInclusionDetails((oldState) => oldState?.filter((item) => item.SeqNo !== id));
        reseterrormessage();
        setEditDisabled(false);
    }

    const handleinclusionchange = (e) => {
        formvalue.InclusionD = e.label
        const Inclusiontype = [
            { value: e.value, label: e.label, ShortName: e?.ShortName }
        ]
        setInclusion(Inclusiontype);
        reseterrormessage();
        setEditDisabled(false);
    }
    //#endregion 

    //#region Exclusion start
    const [exclusionduplicateerror, setExclusionDuplicateError] = useState('');
    const [exclusionvalue, setExclusion] = useState([]);
    const ExclusionDetails = useState([{
        ExclusionId: 0,
        Exclusion: '',
        SeqNo: 0
    }]);

    const [dataexclusiondetails, setExclusionDetails] = useState(ExclusionDetails);
    const [dataexclusioncounter, setExclusionCounter] = useState(0);
    const ExclusionClick = () => {
        if (formvalue.ExclusionD !== '')
            setExclusionCounter(dataexclusioncounter + 1);
    };

    function AddDataRowForExclusionDetails() {
        if (packageD.state.PackageId === 0) {
            let duplicate = dataexclusiondetails?.filter(obj => obj.ExclusionId === exclusionvalue[0]?.value)
            if (duplicate.length === 0) {
                if (datainclusioncounter === 1) {
                    setExclusionDetails(current => [{ SeqNo: dataexclusioncounter, Exclusion: formvalue.ExclusionD, ExclusionId: exclusionvalue[0].value }]);
                }
                else {
                    setExclusionDetails(current => [...current, { SeqNo: dataexclusioncounter, Exclusion: formvalue.ExclusionD, ExclusionId: exclusionvalue[0].value }]);
                }
            }
            else {
                setExclusionDuplicateError('You can not add duplicate value');
            }

        }
        else {

            let dexc = dataexclusiondetails?.filter(obj => obj.SeqNo > 0);

            let len = dexc.length;

            let duplicate = dataexclusiondetails?.filter(obj => obj.ExclusionId === exclusionvalue[0]?.value)

            if (exclusionvalue[0]?.value > 0) {
                if (duplicate.length === 0) {
                    if (len === 0) {
                        setExclusionDetails(current => [{ SeqNo: dataexclusioncounter, Exclusion: formvalue.ExclusionD, ExclusionId: exclusionvalue[0].value }]);
                    }
                    else {
                        setExclusionDetails(current => [...current, { SeqNo: dataexclusioncounter, Exclusion: formvalue.ExclusionD, ExclusionId: exclusionvalue[0].value }]);
                    }
                }
                else {
                    setExclusionDuplicateError('You can not add duplicate value');
                }

            }
        }
    }

    useEffect(() => {
        if (dataexclusioncounter > 0)
            AddDataRowForExclusionDetails();
    }, [dataexclusioncounter]);

    const exclusionremovev = (id, e) => {
        setExclusionDetails((oldState) => oldState?.filter((item) => item.SeqNo !== id));
        reseterrormessage();
        setEditDisabled(false);
    }

    const handleexclusionchange = (e) => {
        formvalue.ExclusionD = e.label
        const Exclusiontype = [
            { value: e.value, label: e.label }
        ]
        setExclusion(Exclusiontype);
        reseterrormessage();
        setEditDisabled(false);
    }
    //#endregion

    //#region policy start
    const [policyduplicateerror, setPolicyonDuplicateError] = useState('');
    const [policyvalue, setPolicy] = useState([]);
    const PolicyDetails = useState([{
        PolicyId: 0,
        Policy: '',
        SeqNo: 0
    }]);

    const [datapolicydetails, setPolicyDetails] = useState(PolicyDetails);
    const [datapolicycounter, setPolicyCounter] = useState(0);
    const PolicyClick = () => {
        if (formvalue.PolicyD !== '')
            setPolicyCounter(datapolicycounter + 1);
    };

    function AddDataRowForPolicyDetails() {
        if (packageD.state.PackageId === 0) {
            let duplicate = datapolicydetails?.filter(obj => obj.PolicyId === policyvalue[0]?.value)
            if (duplicate.length === 0) {
                if (datainclusioncounter === 1) {
                    setPolicyDetails(current => [{ SeqNo: datapolicycounter, Policy: formvalue.PolicyD, PolicyId: policyvalue[0].value }]);
                }
                else {
                    setPolicyDetails(current => [...current, { SeqNo: datapolicycounter, Policy: formvalue.PolicyD, PolicyId: policyvalue[0].value }]);
                }
            }
            else {
                setExclusionDuplicateError('You can not add duplicate value');
            }

        }
        else {

            let dexc = datapolicydetails?.filter(obj => obj.SeqNo > 0);

            let len = dexc.length;

            let duplicate = datapolicydetails?.filter(obj => obj.PolicyId === policyvalue[0]?.value)

            if (policyvalue[0]?.value > 0) {
                if (duplicate.length === 0) {
                    if (len === 0) {
                        setPolicyDetails(current => [{ SeqNo: datapolicycounter, Policy: formvalue.PolicyD, PolicyId: policyvalue[0].value }]);
                    }
                    else {
                        setPolicyDetails(current => [...current, { SeqNo: datapolicycounter, Policy: formvalue.PolicyD, PolicyId: policyvalue[0].value }]);
                    }

                }
                else {
                    setPolicyonDuplicateError('You can not add duplicate value');
                }

            }
        }
    }
    useEffect(() => {
        if (datapolicycounter > 0)
            AddDataRowForPolicyDetails();
    }, [datapolicycounter]);

    const policyremovev = (id, e) => {
        setPolicyDetails((oldState) => oldState?.filter((item) => item.SeqNo !== id));
        reseterrormessage();
        setEditDisabled(false);
    }

    const handlepolicyonchange = (e) => {
        formvalue.PolicyD = e.label
        const Policytype = [
            { value: e.value, label: e.label }
        ]
        setPolicy(Policytype);
        reseterrormessage();
        setEditDisabled(false);
    }
    //#endregion

    //#region image upload
    const [placeimagename, setImageName] = useState('');
    const [placeimagepath, setImagePath] = useState(null);

    //#endregion 

    //#region About start
    const [aboutplaceid, setAboutPlaceId] = useState(0);
    const [cityvalue, setCityValue] = useState(0);
    const [aboutplacebtntext, setAboutPlaceBtnText] = useState('Add');

    const CityDetails = useState([{
        City: '',
        CityName: '',
        CityDetails: '',
        PlaceImageName: '',
        PlaceImagePath: '',
        SeqNo: 0
    }]);
    const [datacitydetails, setCityDetails] = useState(CityDetails);
    const [datacitycounter, setCityCounter] = useState(0);
    const [checkduplicatecity, setCheckDuplicateCity] = useState(0)

    const CityClick = () => {
        const error = {}
        const abc = datacitydetails?.map(value => {
            return value.City;
        })
        const duplicatecity = abc?.includes(cityvalue)
        if (aboutplacebtntext === 'Add') {
            if (cityvalue === 0) {
                error.AboutPlaceError = 'Please enter all required field';
                setFormError(error);
                return;
            }
            else if (formvalue.CityDetailsD === null) {
                error.AboutPlaceError = 'Kindly add city details in location master';
                setFormError(error);
                return;
            }
            else {
                if (duplicatecity) {
                    error.AboutPlaceError = 'City already exist';
                    setFormError(error);
                    return;
                }
                setCityCounter(datacitycounter + 1);
            }
        }
        if (aboutplacebtntext !== 'Add') {
            if (cityvalue === 0) {
                error.AboutPlaceError = 'Please enter all required field';
                setFormError(error);
                return;
            }
            else if (formvalue.CityDetailsD === null) {
                error.AboutPlaceError = 'Kindly add city details in location master';
                setFormError(error);
                return;
            }
            else {
                if (checkduplicatecity !== cityvalue) {
                    if (duplicatecity) {
                        error.AboutPlaceError = 'City already exist';
                        setFormError(error);
                        return;
                    }
                }
                AddDataRowForCityDetails();
            }
        }

    };

    function AddDataRowForCityDetails() {
        if (packageD.state.PackageId === 0) {
            if (aboutplacebtntext === 'Add') {
                if (datacitycounter === 1) {
                    setCityDetails(current => [{ SeqNo: datacitycounter, City: formvalue.CityD, CityName: formvalue.CityName, CityDetails: formvalue.CityDetailsD, PlaceImageName: placeimagename, PlaceImagePath: placeimagepath }]);
                    setFormValue({ ...formvalue, CityD: '', CityName: '', CityDetailsD: '' })
                    setImageName('')
                    setImagePath(null)
                    setCityValue(0)
                    setFormError('')

                }
                else {
                    setCityDetails(current => [...current, { SeqNo: datacitycounter, City: formvalue.CityD, CityName: formvalue.CityName, CityDetails: formvalue.CityDetailsD, PlaceImageName: placeimagename, PlaceImagePath: placeimagepath }]);
                    setFormValue({ ...formvalue, CityD: '', CityName: '', CityDetailsD: '' })
                    setImageName('')
                    setImagePath(null)
                    setCityValue(0)
                    setFormError('')
                }
            }
            else {
                if (aboutplaceid > 0) {
                    handleeditaboutplacedetail(aboutplaceid);
                }

            }
        }
        else {

            let dinc = datacitydetails?.filter(obj => obj.SeqNo > 0);

            let len = dinc.length;

            if (aboutplaceid === 0) {

                if (len === 0) {
                    setCityDetails(current => [{ SeqNo: datacitycounter, City: formvalue.CityD, CityName: formvalue.CityName, CityDetails: formvalue.CityDetailsD, PlaceImageName: placeimagename, PlaceImagePath: placeimagepath }]);
                    setFormValue({ ...formvalue, CityD: '', CityName: '', CityDetailsD: '' })
                    setImageName('')
                    setImagePath(null)
                    setCityValue(0)
                    setFormError('')
                }
                else {
                    setCityDetails(current => [...current, { SeqNo: datacitycounter, City: formvalue.CityD, CityName: formvalue.CityName, CityDetails: formvalue.CityDetailsD, PlaceImageName: placeimagename, PlaceImagePath: placeimagepath }]);
                    setFormValue({ ...formvalue, CityD: '', CityName: '', CityDetailsD: '' })
                    setImageName('')
                    setImagePath(null)
                    setCityValue(0)
                    setFormError('')
                }

            }
            else if (aboutplaceid > 0) {

                handleeditaboutplacedetail(aboutplaceid);
            }
        }

    }

    const handleeditaboutplacedetail = (id) => {
        const newList = datacitydetails?.map((item) => {
            if (item.SeqNo === id) {
                const updatedItem = {
                    ...item,
                    City: formvalue.CityD,
                    CityName: formvalue.CityName,
                    CityDetails: formvalue.CityDetailsD,
                    PlaceImageName: placeimagename,
                    PlaceImagePath: placeimagepath,
                };
                return updatedItem;
            }

            return item;
        });
        setCityDetails(newList);
        setFormValue({ ...formvalue, CityD: '', CityName: '', CityDetailsD: '' })
        setImageName('')
        setImagePath(null)
        setCityValue(0)
        setFormError('')
        setAboutPlaceBtnText('Add');
        setAboutPlaceId(0)
        setEditDisabled(false);
    }

    useEffect(() => {
        if (datacitycounter > 0) {
            if (cityvalue !== 0) {
                AddDataRowForCityDetails();
            }
        }
    }, [datacitycounter]);

    const cityremovev = (id, e) => {
        setCityDetails((oldState) => oldState?.filter((item) => item.SeqNo !== id));
        reseterrormessage();
        setEditDisabled(false);
        setFormValue({ ...formvalue, CityD: '', CityName: '', CityDetailsD: '' })
        setImageName('')
        setImagePath(null)
        setCityValue(0)
        setFormError('')
        setAboutPlaceBtnText('Add');
    }

    const cityeditdata = (id, e) => {
        setAboutPlaceBtnText('Update');
        datacitydetails?.filter(obj => obj.SeqNo === id).map((ele, index) => {
            setCityValue(ele.City);
            setCheckDuplicateCity(ele.City)
            formvalue.CityD = ele.City
            formvalue.CityName = ele.CityName
            formvalue.CityDetailsD = ele.CityDetails
            setImageName(ele.PlaceImageName);
            setImagePath(ele.PlaceImagePath);
            setAboutPlaceId(id);
            let allaboutcitylist = allaboutcity?.filter(IsAct => IsAct.IsActive === true);
            setAboutPlaceCityList(allaboutcity?.filter(IsAct => IsAct.IsActive === true));
            setAboutCityDisable(false);
            if (!allaboutcitylist?.find(IsAboutCity => IsAboutCity.LocationId === ele.City)) {
                setAboutCityDisable(true)
                setAboutPlaceCityList((prvAboutdata) => prvAboutdata?.length > 0 ? [...prvAboutdata, allaboutcity?.find(isBanner => isBanner.LocationId === ele.City)] : [])
            }
            setFormError('')
        })
    }

    const handlecityonchange = async (e) => {
        formvalue.CityName = e.label
        formvalue.CityD = e.value
        setCityValue(e.value);
        setEditDisabled(false);
        setFormError('');
        getaboutplacedetailsfromlocmaster(e.value)
    }

    const getaboutplacedetailsfromlocmaster = async (id) => {
        await getAllData('/master/v1/getaboutplacedetailsfromlocmaster?CityId=' + id).then(res => {
            res.data?.map(obj => {
                formvalue.CityD = obj.LocationId
                formvalue.CityDetailsD = obj.CityDetail
                setImagePath(CommonFileURLWithFolder + obj.PlaceImagePath)
                setImageName(obj.PlaceImageName)
            })
        })
    }

    //#endregion

    //#region 
    const [Shown, setShown] = useState({
        Overview: true,
        Itinerary: false,
        Inclusion: true,
        Exclusion: true,
        Policies: false,
        Summary: false,
        About: false,
        Visibility: true,
        Price: true,
    });

    const showDivHandlerD = (id) => {
        const newList = menulist?.map((item) => {
            if (item.PackageMenuId === id) {
                setShown({
                    ...Shown,
                    [item.PackageMenuName]: !item.IsDefault
                });
                const updatedItem = {
                    ...item,
                    IsDefault: !item.IsDefault,
                };
                return updatedItem;
            }
            return item;
        });
        setMenuList(newList);
        setMenuList(newList);
        reseterrormessage();
        setEditDisabled(false);

        if ((formvalue.PackageTypeId) === 1) {
            setFlightVisibled(false);
            clearFlightDetail();
        } else { setFlightVisibled(true) }
    }

    //#endregion

    //#region submit
    const onDraftSubmit = (e) => {
        e.preventDefault();
        handledataforsubmit();
        setFormError(validateDraftData(formvalue));
    }

    const onSubmitData = (e) => {
        e.preventDefault();
        handledataforsubmit();
        setFormError(validateData());
    }

    const handledataforsubmit = () => {

        formvalue.PackageInclusion = datainclusiondetails?.filter(obj => obj.SeqNo > 0).map(obj => ({
            InclusionId: obj.InclsuionId
        }))

        formvalue.PackageExclusion = dataexclusiondetails?.filter(obj => obj.SeqNo > 0).map(obj => ({
            ExclusionId: obj.ExclusionId
        }))

        formvalue.PackagePolicy = datapolicydetails?.filter(obj => obj.SeqNo > 0).map(obj => ({
            PolicyId: obj.PolicyId
        }))

        const menuidlistd = menulist?.filter(obj => obj.IsDefault === true).map((obj) => ({
            PackageMenuId: obj.PackageMenuId
        }));

        formvalue.PackageMenu = menuidlistd

        const themeidlistD = themeidlist?.filter(obj => obj.ThemeId > 0).map(obj => ({
            ThemeId: obj.ThemeId
        }));

        formvalue.PackageOverview = [{
            DurationId: durationid,
            BestTimeVisitFromId: visitfromdurationid,
            BestTimeVisitToId: visittodurationid,
            PackageStartPointLocationId: visitpointfromid,
            PackageEndPointLocationId: visitpointtoid,
            PackageOverviewTheme: themeidlistD,
            PackageOverviewCities: overviewCityDetails
        }]
        const aboutplacedetail = datacitydetails?.map(obj => ({
            LocationId: obj.City,
            CityDetail: obj.CityDetails,
            PlaceImageName: obj.PlaceImageName,
            PlaceImagePath: obj.PlaceImagePath
        }))
        formvalue.PackagePlace = aboutplacedetail

        formvalue.PackageItinerary = dataitinerary?.filter(obj => obj.SeqNo > 0)
        if (menuidlistd?.filter(obj => obj.PackageMenuId === 2).length === 0) {
            formvalue.PackageMarkup = 'FIX'
            formvalue.PackageMarkupValue = '0'
            formvalue.PackageFinalValue = 0
            formvalue.PackageFixPrice = 0
            formvalue.PackageMarkupValue = '0'
            formvalue.PackageBasicPrice = 0
        }
        else {

            formvalue.PackageMarkup = gsttype

            formvalue.PackageFinalValue = Number(pkgfinalprice)
        }
    }

    const onBasicDraftSubmit = (e) => {
        e.preventDefault();
        setFormError(validateDraftData(formvalue));
    }

    const onSubmitBasicDraftForm = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            let status = false;
            let data = false;

            const packagebasic = await postUsersData('/master/v1/draftpackage', {
                ...formvalue,
                GST: formvalue?.IsPriceType ? formvalue.GST : 0,
                PackageFixPrice: formvalue?.IsPriceType ? formvalue.PackageFixPrice : 0,
                PackageMarkupValue: formvalue?.IsPriceType ? formvalue.PackageMarkupValue : '0'
            });
            status = packagebasic.status;
            data = packagebasic.data;
            if ((!status && data === null) || (!status && !data)) {
                dispatch({ type: 'ALERTINGMESSAGE', message: packagebasic.message })
                resetDisableStateofcontrol();
                return;
            }
            else {
                if (data > 0) {
                    dispatch({ type: 'ALERTINGMESSAGE', message: packagebasic.message })
                    clear();
                }
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    const onSubmitForm = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            let status1 = false;
            let data1 = false;
            const packagebasic = await patchUsersData('/master/v1/updatepackage', {
                ...formvalue,
                GST: formvalue?.IsPriceType ? formvalue.GST : 0,
                PackageFixPrice: formvalue?.IsPriceType ? formvalue.PackageFixPrice : 0,
                PackageMarkupValue: formvalue?.IsPriceType ? formvalue.PackageMarkupValue : '0',
            });

            status1 = packagebasic?.status;
            data1 = packagebasic?.data;

            if ((!status1 && data1 === null) || (!status1 && !data1)) {
                dispatch({ type: 'ALERTING', message: packagebasic.message })
                resetDisableStateofcontrol();
                return;
            }
            else {
                if (status1 && data1 > 0) {
                    dispatch({ type: 'ALERTINGMESSAGE', message: packagebasic.message })
                    clear();
                }
                else {
                    dispatch({ type: 'ALERTINGMESSAGE', message: packagebasic.message })
                    resetDisableStateofcontrol();
                    return;
                }
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    const DepartureSlotid = useRef(null)
    const BannerImgPath = useRef(null)
    const GalleryCount = useRef(null)
    const ArrivalSlotId = useRef(null)
    const StateId = useRef(null)
    const CountryId = useRef(null)
    const Locationid = useRef(null)
    const PackageCategory = useRef(null)

    useEffect(() => {
        if (Object.keys(formerror).length === 0 && isSubmit && !isRetrive) {
            setBasicDraftDisabled(true);
            setDisabled(true);
            setStateDisable(true);
            setBackDisable(true);
            setClearDisable(true);
            onSubmitBasicDraftForm();
        }
        if (Object.keys(formerror).length === 0 && isSubmit && isRetrive) {
            setBasicDraftDisabled(true);
            setDisabled(true);
            setStateDisable(true);
            setBackDisable(true);
            setClearDisable(true);
            onSubmitForm();
        }
        if (Object.keys(formerror).length > 0) {

            let id = Object.keys(formerror)[0];
            let inc = Object.keys(formerror).find(obj => obj === "InclusionError");
            let exc = Object.keys(formerror).find(obj => obj === "ExclusionError");

            let pkgdur = Object.keys(formerror).find(obj => obj === "PackageDuration");
            let btvf = Object.keys(formerror).find(obj => obj === "BestTimeVisitFrom");
            let bttv = Object.keys(formerror).find(obj => obj === "BestTimeToVisit");
            let pkgstrpoint = Object.keys(formerror).find(obj => obj === "PackageStartPoint");
            let pkgendpoint = Object.keys(formerror).find(obj => obj === "PackageEndPoint");
            let themelist = Object.keys(formerror).find(obj => obj === "ThemeList");
            let overviewcitydetail = Object.keys(formerror).find(obj => obj === "overviewCityDetail");
            let totalnightspending = Object.keys(formerror).find(obj => obj === "totalNightsPending");

            let pcy = Object.keys(formerror).find(obj => obj === "PolicyError");

            let abtplc = Object.keys(formerror).find(obj => obj === "AboutPlaceError")

            let itnery = Object.keys(formerror).find(obj => obj === "ItineraryError")

            let childprice = Object.keys(formerror).find(obj => obj === "ChildrenPrice")

            if (inc?.length > 0 || inclusionduplicateerror?.length > 0) {
                let incllopased = document.getElementById("InclusionError")
                if (incllopased.ariaExpanded === "false")
                    document.querySelector("#InclusionError").click();
            }
            if (exc?.length > 0 || exclusionduplicateerror?.length > 0) {
                let exccllopased = document.getElementById("ExclusionError")
                if (exccllopased.ariaExpanded === "false")
                    document.querySelector("#ExclusionError").click();
            }
            if (pkgdur?.length > 0 || btvf?.length > 0 || bttv?.length > 0 || pkgstrpoint?.length > 0 || pkgendpoint?.length > 0 || themelist?.length > 0 || overviewcitydetail?.length > 0 || totalnightspending?.length > 0) {
                let overviewcllopased = document.getElementById("OverviewError")
                if (overviewcllopased.ariaExpanded === "false")
                    document.querySelector("#OverviewError").click();
            }
            if (pcy?.length > 0 || policyduplicateerror?.length > 0) {
                let policycllopased = document.getElementById("PolicyError")
                if (policycllopased.ariaExpanded === "false")
                    document.querySelector("#PolicyError").click();
            }
            if (abtplc?.length > 0) {
                let aboutcllopased = document.getElementById("AboutPlaceError")
                if (aboutcllopased.ariaExpanded === "false")
                    document.querySelector("#AboutPlaceError").click();
            }
            if (itnery?.length > 0) {
                let itenrycllopased = document.getElementById("ItineraryError")
                if (itenrycllopased.ariaExpanded === "false")
                    document.querySelector("#ItineraryError").click();
            }
            if (childprice?.length > 0) {
                let childpricecllopased = document.getElementById("PricingError")
                if (childpricecllopased.ariaExpanded === "false")
                    document.querySelector("#PricingError").click();
            }

            if (id === "DepartureSlotid" || id === "BannerImgPath" || id === "GalleryCount" || id === "ArrivalSlotId" || id === "StateId" || id === "Locationid" || id === "PackageCategory") {
                eval(id).current.focus();
            }
            else if (id === "PackageValidateStart") {
                document.getElementById("startdate").focus();
            }
            else if (id === "PackageDateValidation" || id === "PackageValidateEnd") {
                document.getElementById("enddate").focus();
            }
            else {
                let doc = document.getElementById(id);
                if (doc !== null)
                    doc.focus();
            }
        }

    }, [formerror]);
    //#endregion

    //#region validate section

    const validateDraftData = (values) => {
        const error = {};
        formvalue.IsDraft = true
        setIsSubmit(true);

        if (values.CountryId.length <= 0) {
            error.Country = 'Cannot leave blank, input is mandatory.'
            setIsSubmit(false);
        }
        if (values.CountryId?.includes(1)) {
            if (values?.StateId?.length === 0) {
                error.StateId = 'Please select State';
                setIsSubmit(false);
            }
            if (values?.StateId?.length > 15) {
                error.StateId = 'Maximum 15 states can be selected';
                setIsSubmit(false);
            }
        }
        if (values?.LocationId?.length === 0) {
            error.Locationid = 'Please select City';
            setIsSubmit(false);
        }
        if (values?.LocationId?.length > 15) {
            error.Locationid = 'Maximum 15 cities can be selected';
            setIsSubmit(false);
        }

        if (values.PackageName.trim().length === 0) {
            error.PackageName = 'Please enter package name';
            setIsSubmit(false);
        }
        if (values.PackageName.trim().length > 50) {
            error.PackageName = 'Maximum length of the package name is 50';
            setIsSubmit(false);
        }
        return error;
    }

    const validateData = () => {
        const error = {};
        formvalue.IsDraft = false
        setIsSubmit(true);

        if (formvalue?.PackageDiscount === null) {
            error.PackageDiscount = 'Kindly Enter Discount.'
            setIsSubmit(false);
        }
        if (formvalue?.countryId <= 0) {
            error.Country = 'Cannot leave blank, input is mandatory.'
            setIsSubmit(false);
        }
        if (formvalue?.CountryId.includes(1)) {
            if (formvalue?.StateId?.length === 0) {
                error.StateId = 'Please select State';
                setIsSubmit(false);
            }
            if (formvalue?.StateId?.length > 15) {
                error.StateId = 'Maximum 15 states can be selected';
                setIsSubmit(false);
            }
        }
        if (formvalue?.LocationId?.length === 0) {
            error.Locationid = 'Please select City';
            setIsSubmit(false);
        }
        if (formvalue?.LocationId?.length > 15) {
            error.Locationid = 'Maximum 15 cities can be selected';
            setIsSubmit(false);
        }

        if (formvalue?.PackageName.trim().length === 0) {
            error.PackageName = 'Please enter package name';
            setIsSubmit(false);
        }
        if (formvalue?.PackageName.trim().length > 50) {
            error.PackageName = 'Maximum length of the package name is 50';
            setIsSubmit(false);
        }
        if (formvalue?.PackageCategoryId === 0) {
            error.PackageCategory = "Please select Package Category";
            setIsSubmit(false);
        }
        if (formvalue?.ArrivalSlotId === 0) {
            error.ArrivalSlotId = 'Please select Arrival Slot';
            setIsSubmit(false);
        }
        if (formvalue?.DepartureSlotId === 0) {
            error.DepartureSlotid = 'Please select Departure Slot';
            setIsSubmit(false);
        }
        if (!formvalue?.PackageValidateStartD || formvalue?.PackageValidateStartD.trim().length === 0) {
            error.PackageValidateStart = 'Please select package start date';
            setIsSubmit(false);
        }
        if (!formvalue?.PackageValidateEndD || formvalue?.PackageValidateEndD.trim().length === 0) {
            error.PackageValidateEnd = 'Please select package end date';
            setIsSubmit(false);
        }
        if (formvalue?.PackageValidateStartD > formvalue?.PackageValidateEndD && formvalue?.PackageValidateStartD !== null && formvalue?.PackageValidateEndD !== null && formvalue?.PackageValidateStartD !== "" && formvalue?.PackageValidateEndD !== "") {
            error.PackageDateValidation = "Please enter valid end Date";
            setIsSubmit(false);
        }
        if (inventoryvalidation.MinSoldoutDate != null) {
            if (formatDateyearmonthday(inventoryvalidation.MinSoldoutDate) < formatDateyearmonthday(formvalue?.PackageValidateStartD)) {
                error.PackageValidateStart = 'You are not allowed to change the date as inventory is already in use';
                setIsSubmit(false);
            }
        }
        if (inventoryvalidation.MaxSoldOutDate != null) {
            if (formatDateyearmonthday(inventoryvalidation.MaxSoldOutDate) > formatDateyearmonthday(formvalue?.PackageValidateEndD)) {
                error.PackageValidateEnd = 'You are not allowed to change the date as inventory is already in use';
                setIsSubmit(false);
            }
        }
        if (inventoryvalidation.MaxSoldOutDate != null && inventoryvalidation.MaxSoldOutDate != null) {
            if (formvalue?.PackageCutOffCountD != null && formvalue?.PackageCutOffCountD != 0) {
                var d = new Date(formvalue?.PackageValidateEndD);
                d.setDate(d.getDate() - formvalue?.PackageCutOffCountD);
                if (d <= new Date(inventoryvalidation.MaxSoldOutDate)) {
                    error.PackageCutOffCount = "You are not allowed to change the date as inventory is already in use";
                    setIsSubmit(false);
                }
            }
        }
        if (formvalue?.PackageInventoryCountD.toString() == '0' || formvalue?.PackageInventoryCountD.toString().trim().length === 0) {
            error.PackageInventoryCount = "Please enter Inventory Count";
            setIsSubmit(false);
        }
        if (inventoryvalidation.InventoryCount > 0) {
            if (formvalue?.PackageInventoryCountD < inventoryvalidation.InventoryCount) {
                error.PackageInventoryCount = "Inventory can not be decreased lesser than max inventory sold";
                setIsSubmit(false);
            }
        }
        if (formvalue?.PackageCutOffCountD === null) {
            error.PackageCutOffCount = "Please enter CutOff Count";
            setIsSubmit(false);
        }
        if (formvalue?.PackageCutOffCountD !== null) {
            if (formvalue?.PackageCutOffCountD > 100 || formvalue?.PackageCutOffCountD < 0) {
                error.PackageCutOffCount = "Package Cut off days should be between 0 to 100";
                setIsSubmit(false);
            }
        }
        if (formvalue?.PackageHighlights.trim().length === 0) {
            error.PackageHighlights = "Please enter Package Highlights";
            setIsSubmit(false);
        }
        if (bannerimgpath === '') {
            error.BannerImgPath = "Please select Banner";
            setIsSubmit(false);
        }
        if (formvalue?.PackageGallery?.length === 0) {
            error.GalleryCount = "Please select at least one Gallery";
            setIsSubmit(false);
        }
        const inclusioncount = datainclusiondetails?.filter((obj) => obj.SeqNo > 0);
        if (inclusioncount.length === 0) {
            error.InclusionError = 'Please select at least one Inclusion';
            setIsSubmit(false);
        }

        const exclsuioncount = dataexclusiondetails?.filter((obj) => obj.SeqNo > 0);
        if (exclsuioncount.length === 0) {
            error.ExclusionError = 'Please select at least one Exclusion';
            setIsSubmit(false);
        }

        const pricecount = menulist?.filter((obj) => obj.PackageMenuId === 9 && obj.IsDefault === true);
        if (pricecount.length === 1) {
            if (formvalue?.ChildrenPrice === null && formvalue?.IsPriceType) {
                error.ChildrenPrice = 'Kindly add pricing for children';
                setIsSubmit(false);
            }
        }

        const policymenuselection = menulist?.filter((obj) => obj.PackageMenuId === 5 && obj.IsDefault === true)
        const policycount = datapolicydetails?.filter((obj) => obj.SeqNo > 0);

        if (policymenuselection.length === 1 && policycount.length === 0) {
            error.PolicyError = 'Please enter at least one policy';
            setIsSubmit(false);
        }

        const overviewcount = menulist?.filter((obj) => obj.PackageMenuId === 1 && obj.IsDefault === true);
        if (overviewcount.length === 1) {
            if (durationid === 0) {
                error.PackageDuration = "Please select package duration.";
                setIsSubmit(false);
            }
            if (visitfromdurationid === 0) {
                error.BestTimeVisitFrom = "Please select Best time visit from.";
                setIsSubmit(false);
            }
            if (visittodurationid === 0) {
                error.BestTimeToVisit = "Please select Best time visit to.";
                setIsSubmit(false);
            }
            if (visitpointfromid === 0) {
                error.PackageStartPoint = "Please select Package start point.";
                setIsSubmit(false);
            }
            if (visitpointtoid === 0) {
                error.PackageEndPoint = "Please select Package end point.";
                setIsSubmit(false);
            }
            const themeidcount = themeidlist?.filter(obj => obj.Id > 0);
            if (themeidcount.length === 0) {
                error.ThemeList = 'Please select package theme';
                setIsSubmit(false);
            }
            if (overviewCityDetails?.length === 0) {
                error.overviewCityDetail = 'Please select city with required no. of nights';
                setIsSubmit(false);
            }
            if (overviewCityDetails?.length > 0 && curTotalNight !== totalNights) {
                if (curTotalNight < totalNights) {
                    if ((totalNights - curTotalNight) > 1) {
                        error.totalNightsPending = 'Kindly add ' + JSON.stringify(totalNights - curTotalNight) + ' nights more';
                    }
                    else {
                        error.totalNightsPending = 'Kindly add ' + JSON.stringify(totalNights - curTotalNight) + ' night more';
                    }
                }
                else {
                    if (totalNights > 1) {
                        error.totalNightsPending = 'Only ' + JSON.stringify(totalNights) + ' nights are allowed';
                    }
                    else {
                        error.totalNightsPending = 'Only ' + JSON.stringify(totalNights) + ' night are allowed';
                    }
                }
                setIsSubmit(false);
            }
        }
        //obj.SeqNo
        const aboutmenucount = menulist?.filter((obj) => obj.PackageMenuId === 7 && obj.IsDefault === true)
        const aboutmenudatacount = datacitydetails?.filter((obj) => obj.SeqNo > 0);

        if (aboutmenucount.length === 1 && aboutmenudatacount.length === 0) {
            error.AboutPlaceError = 'Please enter about place detail';
            setIsSubmit(false);
        }

        const itinerarymenucount = menulist?.filter((obj) => obj.PackageMenuId === 2 && obj.IsDefault === true)
        const itinerarydatacount = dataitinerary?.filter((obj) => obj.SeqNo > 0)

        if (itinerarymenucount.length === 1 && itinerarydatacount.length === 0) {
            error.ItineraryError = 'Please enter itinerary detail';
            setIsSubmit(false);
        }
        if (gsttype === 'GST' && (formvalue?.PackageFixPrice < 1 || formvalue?.PackageFixPrice > 99.99)) {
            error.MarkupvalueError = 'Entered percentage should be 1 < value < 100';
            setIsSubmit(false);
        }
        return error;
    }
    //#endregion

    //#region retrive data
    const [retrivedata, setRetriveData] = useState([]);

    const handleRetrive = async () => {
        const PackageId = packageD.state.PackageId;
        const PackageById = await postUsersData('/master/v1/getpackagebyid', { PackageId });
        setRetriveData(PackageById.data);

    }

    useEffect(() => {
        if (retrivedata?.length === 1 && menulist?.length > 0 && locationData?.length > 0) {
            RetriveData();
        }
    }, [retrivedata, locationData]);

    const RetriveData = () => {
        retrivedata?.map(obj => {
            formvalue.CountryId = obj?.countryId
            formvalue.PackageLevelId = obj?.packageLevelId
            formvalue.PackageDiscount = obj.packageDiscount
            formvalue.PackageId = obj.packageId
            formvalue.PackageName = obj.packageName
            formvalue.PackageCode = obj.packageCode
            formvalue.PackageCategoryId = obj.packageCategoryId
            formvalue.StateId = obj.stateId
            formvalue.LocationId = obj.locationId
            formvalue.PackageTypeId = Number(obj.packageTypeId)
            formvalue.PackageLevelId = Number(obj.packageLevelId)
            formvalue.IsInterCity = obj?.isInterCity
            formvalue.IsBestPackage = obj.isBestPackage
            formvalue.ArrivalSlotId = obj.arrivalSlotId
            formvalue.DepartureSlotId = obj.departureSlotId
            formvalue.PackageValidateStart = obj.packageValidateStart
            formvalue.PackageValidateEnd = obj.packageValidateEnd
            formvalue.IsPriceType = obj?.isPriceType
            const overviewCity = nightallcity?.filter((value) => obj.locationId?.includes(value.LocationId))?.map((ele) => ({
                label: ele.City,
                value: ele.LocationId
            }))
            setOverviewCityList(overviewCity)

            const nightid = durationlist?.map(id => {
                if (id.DurationId === obj.packageOverview[0]?.durationId) {
                    return id.NightId
                }
            }).find(x => x != undefined ? x : '')
            setTotalNights(nightid)

            const nightlistdata = durationlist?.filter(obj => obj.NightId <= nightid)?.map((value) => ({
                label: value.Night,
                value: value.NightId
            }));
            setNightList(nightlistdata)

            if (obj.packageValidateStart !== null) {
                formvalue.PackageValidateStartD = formatDateyearmonthday(obj.packageValidateStart)
                setPackageValidateStart(new Date(formatDateyearmonthday(obj.packageValidateStart)))
            }
            if (obj.packageValidateEnd !== null) {
                formvalue.PackageValidateEndD = formatDateyearmonthday(obj.packageValidateEnd)
                setPackageValidateEnd(new Date(formatDateyearmonthday(obj.packageValidateEnd)))
            }
            formvalue.PackageInventoryCount = obj.packageInventoryCount
            formvalue.PackageCutOffCount = obj.packageCutOffCount
            if (obj.packageInventoryCount === 0) {
                formvalue.PackageInventoryCountD = ''
            }
            else {
                formvalue.PackageInventoryCountD = obj.packageInventoryCount
            }
            if (obj.packageCutOffCount === null) {
                formvalue.PackageCutOffCountD = ''
            }
            else {
                formvalue.PackageCutOffCountD = obj.packageCutOffCount
            }


            formvalue.ChildrenPrice = obj.childrenPrice
            setChildPrice(obj.childrenPrice)
            formvalue.PackageHighlights = obj.packageHighlights
            formvalue.IsActive = obj.isActive
            formvalue.IsDraft = obj.isDraft
            formvalue.PackageBanner = obj.packageBanner
            formvalue.PackageGallery = obj.packageGallery?.map(el => ({
                GalleryId: el.galleryId,
                GalleryMasterImageId: gallerylist?.filter(ele => ele.value === el.galleryId)?.[0]?.SelectedImages?.map(list => list?.GalleryMasterImageId)
            }));

            formvalue.PackageMenu = obj.packageMenu
            formvalue.PackageInclusion = obj.packageInclusion
            formvalue.PackageExclusion = obj.packageExclusion
            formvalue.PackagePolicy = obj.packagePolicy
            formvalue.PackageOverview = obj.packageOverview
            formvalue.PackagePlace = obj.packagePlace
            formvalue.PackageSummary = obj.packageSummary

            formvalue.IsBestPackage = obj.isBestPackage
            formvalue.IsHotDeals = obj.isHotDeals
            formvalue.HotOfferPercentage = obj.hotOfferPercentage
            formvalue.IsInternationalDestination = obj.isInternationalDestination
            formvalue.IsBestDestination = obj.isBestDestination
            formvalue.IsTrendingHoliday = obj.isTrendingHoliday
            formvalue.PackageItinerary = obj.packageItinerary

            formvalue.PackageBasicPrice = obj.packageBasicPrice
            formvalue.PackageMarkup = obj.packageMarkup
            formvalue.PackageMarkupValue = (obj.packageMarkupValue === null ? "0" : obj.packageMarkupValue.toString())
            formvalue.PackageFixPrice = obj.packageMarkupValue
            formvalue.PackageFinalValue = obj.packageFinalValue
            formvalue.PackageFinalPrice = obj.packageFinalValue
            formvalue.GST = 1
            formvalue.PackageSummary = obj.packageSummary
            setInventoryValidation({ ...inventoryvalidation, InventoryCount: obj.inventoryCount, MinSoldoutDate: obj.minSoldoutDate, MaxSoldOutDate: obj.maxSoldOutDate })

            if (formvalue.PackageOverview?.length > 0) {
                if (formvalue.PackageOverview[0].packageStartPointLocationId > 0) {
                    // Start to End point Dropdown
                    let allpointlist = allstartpoint?.filter(IsAct => IsAct.IsActive === true);
                    setPackageoint(allstartpoint?.filter(IsAct => IsAct.IsActive === true));
                    setStartPointDisabled(false);
                    if (!allpointlist?.find(IsStartPoint => IsStartPoint.LocationId === formvalue.PackageOverview[0].packageStartPointLocationId)) {
                        setStartPointDisabled(true)
                        setPackageoint((prvStartdata) => prvStartdata?.length > 0 ? [...prvStartdata, allstartpoint?.find(isStartPoint => isStartPoint.LocationId === formvalue.PackageOverview[0].packageStartPointLocationId)] : [])

                    }
                }
                if (formvalue.PackageOverview[0].packageEndPointLocationId > 0) {
                    let allEndpointlist = allendpoint?.filter(IsAct => IsAct.IsActive === true);
                    setEndPackageoint(allendpoint?.filter(IsAct => IsAct.IsActive === true));
                    setEndPointDisabled(false);
                    if (!allEndpointlist?.find(IsEndPoint => IsEndPoint.LocationId === formvalue.PackageOverview[0].packageEndPointLocationId)) {
                        setEndPointDisabled(true)
                        setEndPackageoint((prvEnddata) => prvEnddata?.length > 0 ? [...prvEnddata, allendpoint?.find(isEndPoint => isEndPoint.LocationId === formvalue.PackageOverview[0].packageEndPointLocationId)] : [])

                    }
                }
            }

        });
        setPkgFinalPrice(formvalue.PackageFinalPrice);
        setGstId(1);
        setGst(5)
        if (formvalue.PackageMarkup && formvalue.PackageMarkup !== null) {
            setGstType(formvalue.PackageMarkup);
        }
        else {
            setGstType('FIX');
        }
        if ((formvalue.PackageTypeId) === 1) {
            setFlightVisibled(false);
            clearFlightDetail();
        }
        else { setFlightVisibled(true) }

        setBestPackage(formvalue.IsBestPackage);
        setHotDeals(formvalue.IsHotDeals)
        setIsInternationalDestination(formvalue.IsInternationalDestination);
        setIsBestDestination(formvalue.IsBestDestination);
        setIsTrendingHoliday(formvalue.IsTrendingHoliday);
        const bannerid = formvalue.PackageBanner?.map((obj) => {
            return obj.bannerId;
        }) || [];
        setBannerId(bannerid[0]);
        banneridlist.BannerId = bannerid[0]

        if (formvalue.PackageBanner?.length > 0) {
            let allbannerlist = allbanner?.filter(IsAct => IsAct.IsActive === true);
            setBannerList(allbanner?.filter(IsAct => IsAct.IsActive === true));
            setBannerDisabled(false);
            if (!allbannerlist?.find(IsBannerName => IsBannerName.BannerId === formvalue.PackageBanner[0].bannerId)) {
                setBannerDisabled(true)
                setBannerList((prvBannerdata) => prvBannerdata?.length > 0 ? [...prvBannerdata, allbanner?.find(isBanner => isBanner.BannerId === formvalue.PackageBanner[0].bannerId)] : [])

            }
            allbanner?.filter(isBanner => isBanner.BannerId === bannerid[0]).map((value) => {
                setBannerImgPath(CommonFileURLWithFolder + value.BannerPath);
            })
        }

        if (formvalue.PackageGallery?.length > 0) {
            const pathlist = gallerylist?.filter((obj) => formvalue.PackageGallery?.some((item) => item.GalleryId === obj.value))
                ?.flatMap((val) =>
                    val?.SelectedImages?.map((el) => ({
                        GalleryId: val.value,
                        GalleryPath: CommonFileURLWithFolder + el?.ImagePath,
                        GalleryMasterImageId: el?.GalleryMasterImageId
                    })) || []
                );
            setGalleryImgPath(pathlist || []);
        }

        formvalue.PackageMenu?.map((val, index) => {
            const newList = menulist;
            newList?.filter(e => e.PackageMenuId === val.packageMenuId).map((item) => {
                item.IsDefault = true;
                Shown[item.PackageMenuName] = true;
            });
            setMenuList(newList);
        });

        formvalue.PackageInclusion?.filter((obj) => obj.inclusionId > 0).map((val, index) => {
            const d = inclusionlistdata?.filter((obj) => obj.value === val.inclusionId).map((obj) => { return obj })
            if (index === 0) {
                let cnti = index + 1
                setInclusionDetails(current => [{
                    InclsuionId: val.inclusionId,
                    ShortName: d[0]?.ShortName,
                    Inclusion: d[0]?.label,
                    SeqNo: cnti
                }]);
                setInclusionCounter(index + 1);
            }
            else {
                let cntz = index + 1
                setInclusionDetails(current => [...current, {
                    InclsuionId: val.inclusionId,
                    ShortName: d[0]?.ShortName,
                    Inclusion: d[0]?.label,
                    SeqNo: cntz
                }]);
                setInclusionCounter(index + 1);
            }
        });

        formvalue.PackageExclusion?.filter((obj) => obj.exclusionId > 0).map((val, index) => {
            const d = exclusionistdata?.filter((obj) => obj.value === val.exclusionId).map((obj) => { return obj.label })

            if (index === 0) {
                let cnti = index + 1
                setExclusionDetails(current => [{ SeqNo: cnti, Exclusion: d[0], ExclusionId: val.exclusionId }]);
                setExclusionCounter(index + 1);
            }
            else {
                let cntz = index + 1
                setExclusionDetails(current => [...current, { SeqNo: cntz, Exclusion: d[0], ExclusionId: val.exclusionId }]);
                setExclusionCounter(index + 1);
            }

        });

        formvalue.PackagePolicy?.filter((obj) => obj.policyId > 0).map((val, index) => {
            const d = policylistdata?.filter((obj) => obj.value === val.policyId).map((obj) => { return obj.label });

            if (index === 0) {
                let cnti = index + 1
                setPolicyDetails(current => [{ SeqNo: cnti, Policy: d[0], PolicyId: val.policyId }]);
                setPolicyCounter(index + 1);
            } else {
                let cntz = index + 1
                setPolicyDetails(current => [...current, { SeqNo: cntz, Policy: d[0], PolicyId: val.policyId }]);
                setPolicyCounter(index + 1);
            }

        });


        setCheckedValueOfPackageTypeValue(formvalue.PackageTypeId);

        if (formvalue.PackageOverview?.length > 0) {
            setDurationId(formvalue.PackageOverview[0].durationId);
            setVisitFromDurationId(formvalue.PackageOverview[0].bestTimeVisitFromId);
            setVisitToDurationId(formvalue.PackageOverview[0].bestTimeVisitToId);
            setVisitFromId(formvalue.PackageOverview[0].packageStartPointLocationId);
            setVisitToId(formvalue.PackageOverview[0].packageEndPointLocationId);
            setOverviewCityDetails(formvalue.PackageOverview[0].packageOverviewCities)

            if (formvalue.PackageOverview[0].packageOverviewTheme?.length > 0) {
                formvalue.PackageOverview[0].packageOverviewTheme?.map((val, index) => {

                    const d = packagetheme?.filter((obj) => obj.ThemeId === val.themeId).map((ele) => {
                        return ele.ImagePath;
                    });
                    if (index === 0) {
                        let cnti = index + 1
                        setThemeIdList([{ ThemeId: val.themeId, Id: cnti }]);
                        setThemeImgPath(current => [{ ThemeId: val.themeId, ThemePath: CommonFileURLWithFolder + d[0], Id: cnti }]);
                        setThemeCounter(index + 1);
                    }
                    else {
                        let cntz = index + 1
                        setThemeIdList(current => [...current, { ThemeId: val.themeId, Id: cntz }]);
                        setThemeImgPath(current => [...current, { ThemeId: val.themeId, ThemePath: CommonFileURLWithFolder + d[0], Id: cntz }]);
                        setThemeCounter(index + 1);
                    }
                });
            }
        }

        if (formvalue.PackagePlace?.length > 0) {
            formvalue.PackagePlace?.map((val, index) => {
                if (index === 0) {
                    let cnti = index + 1
                    setCityDetails(current => [{
                        SeqNo: cnti, City: val.locationId, CityName: val.city,
                        CityDetails: val.cityDetail, PlaceImageName: val.placeImageName,
                        PlaceImagePath: val.placeImagePath
                    }]);
                    setCityCounter(index + 1);
                }
                else {
                    let cntz = index + 1
                    setCityDetails(current => [...current, {
                        SeqNo: cntz, City: val.locationId, CityName: val.city,
                        CityDetails: val.cityDetail, PlaceImageName: val.placeImageName,
                        PlaceImagePath: val.placeImagePath
                    }]);
                    setCityCounter(index + 1);
                }
            });
        }

        if (formvalue.PackageItinerary?.length > 0) {
            formvalue.PackageItinerary?.map((val, index) => {
                if (index === 0) {
                    let intiti = index + 1;
                    setDataItinerary(current =>
                        [{
                            SeqNo: intiti,
                            Day: val.day,
                            DaySightseeingId: val?.daySightSeeingId,
                            DaySchedule: val.daySchedule,
                            FlightFromLocationId: val.flightFromLocationId,
                            FlightToLocationId: val.flightToLocationId,
                            FlightNo: val.flightNo,
                            ArrivalTime: (val.arrivalTime) !== '1900-01-01T00:00:00' ? val.arrivalTime : null,
                            DepartureTime: (val.departureTime) !== '1900-01-01T00:00:00' ? val.departureTime : null,
                            ArrivalTimeD: (val.arrivalTime) !== '1900-01-01T00:00:00' ? formatTimeHourMinute(val.arrivalTime) : '',
                            DepartureTimeD: (val.departureTime) !== '1900-01-01T00:00:00' ? formatTimeHourMinute(val.departureTime) : '',
                            ClassId: val.classId,
                            SupplierId: val.supplierId,
                            FlightPrice: Number(val.flightPrice),
                            HotelId: val.hotelId,
                            RoomTypeId: val.roomTypeId,
                            HotelRoomId: val?.hotelRoomId,
                            RateTypeId: val?.rateTypeId,
                            NoOfPax: val.noOfPax,
                            HotelPrice: val.hotelPrice,
                            SightseeingId: val.sightseeingId,
                            VehicleId: val.vehicleId,
                            SightseeingPrice: val.sightseeingPrice,
                            AirlineId: val.airlineId,
                            AttractionBasicId: val?.attractionBasicId,
                            inclusionId: val?.inclusionId,
                            VehicleCategoryId: val?.vehicleCategoryId,
                            TransaferVehicleDetailId: val?.transaferVehicleDetailId,
                            TransferSightseeingId: val?.transferSightseeingId,
                            AirportSightseeingId: val?.airportSightseeingId,
                        }]);
                    setDataItineraryCounter(index + 1);
                }
                else {
                    let intitiz = index + 1;
                    setDataItinerary(current =>
                        [...current, {
                            SeqNo: intitiz,
                            Day: val.day,
                            DaySightseeingId: val?.daySightSeeingId,
                            DaySchedule: val.daySchedule,
                            FlightFromLocationId: val.flightFromLocationId,
                            FlightToLocationId: val.flightToLocationId,
                            FlightNo: val.flightNo,
                            ArrivalTime: (val.arrivalTime) !== '1900-01-01T00:00:00' ? val.arrivalTime : null,
                            DepartureTime: (val.departureTime) !== '1900-01-01T00:00:00' ? val.departureTime : null,
                            ArrivalTimeD: (val.arrivalTime) !== '1900-01-01T00:00:00' ? formatTimeHourMinute(val.arrivalTime) : '',
                            DepartureTimeD: (val.departureTime) !== '1900-01-01T00:00:00' ? formatTimeHourMinute(val.departureTime) : '',
                            ClassId: val.classId,
                            SupplierId: val.supplierId,
                            FlightPrice: Number(val.flightPrice),
                            HotelId: val.hotelId,
                            RoomTypeId: val.roomTypeId,
                            HotelRoomId: val?.hotelRoomId,
                            RateTypeId: val?.rateTypeId,
                            NoOfPax: val.noOfPax,
                            HotelPrice: val.hotelPrice,
                            SightseeingId: val.sightseeingId,
                            VehicleId: val.vehicleId,
                            SightseeingPrice: val.sightseeingPrice,
                            AirlineId: val.airlineId,
                            AttractionBasicId: val?.attractionBasicId,
                            inclusionId: val?.inclusionId,
                            VehicleCategoryId: val?.vehicleCategoryId,
                            TransaferVehicleDetailId: val?.transaferVehicleDetailId,
                            TransferSightseeingId: val?.transferSightseeingId,
                            AirportSightseeingId: val?.airportSightseeingId,
                        }]);
                    setDataItineraryCounter(index + 1);
                }
            })
        }

        if (formvalue.PackageSummary?.length > 0) {
            setPkgSummary(formvalue.PackageSummary)
        }
    }

    //#endregion

    //#region  Package type and level change handle
    const handlePackageTypeChange = (id, e) => {
        setFormValue((form) => ({ ...form, PackageTypeId: Number(e.target.value) }))
        setEditDisabled(false);

        if ((e.target.value) === 1) {
            setFlightVisibled(false);
            clearFlightDetail();
        } else { setFlightVisibled(true) }

        const newList = packagetypelist?.map((item) => {
            if (item.PackageTypeId === id) {
                const updatedItem = {
                    ...item,
                    IsDefualt: !item.IsDefualt,
                };
                return updatedItem;
            }
            return item;
        });
        setPackageTypeList(newList);
        setCheckedValueOfPackageTypeValue(id);
        setpackagetypecounter(counterpackagetype + 1);
    }

    const handleOnChange = (name, value) => {
        reseterrormessage();
        setEditDisabled(false);
        setFormValue({
            ...formvalue,
            [name]: value
        })
    }

    const [counterpackagetype, setpackagetypecounter] = useState(0);
    const handlepackagetyperadio = (id) => {
        const newList = packagetypelist?.map((item) => {
            if (item.PackageTypeId !== id) {
                const updatedItem = {
                    ...item,
                    IsDefualt: false,
                };
                return updatedItem;
            }
            return item;
        });
        setPackageTypeList(newList);
    }

    useEffect(() => {
        if (counterpackagetype > 0)
            handlepackagetyperadio(checkedvalueofpackagetypevalue);
    }, [counterpackagetype]);
    //#endregion

    //#region iteninory section 
    const [flightfromid, setFlightFromId] = useState(0);
    const [flighttoid, setFlightToId] = useState(0);
    const [airlinelist, setAirlineList] = useState([]);
    const [airlineid, setAirlineId] = useState(0);
    const [flightnolist, setFlightNoList] = useState([]);
    const [flightno, setFlightNo] = useState('');
    const [supplierlist, setSupplierList] = useState([]);
    const [airlineclasslist, setAirlineClassList] = useState([]);
    const [flightdata, setFlightData] = useState([]);
    const [classid, setClassId] = useState(0);
    const [supplierid, setSupplierId] = useState(0);
    const [itineraryid, setItineraryId] = useState(0);

    const Itinerary = useState([{
        SeqNo: 0,
        DaySightseeingId: 0,
        Day: '',
        DaySchedule: '',
        FlightFromLocationId: 0,
        FlightToLocationId: 0,
        FlightNo: '',
        ArrivalTime: null,
        DepartureTime: null,
        ArrivalTimeD: "",
        DepartureTimeD: "",
        ClassId: 0,
        SupplierId: 0,
        FlightPrice: 0,
        HotelId: 0,
        HotelRoomId: 0,
        RateTypeId: 0,
        RoomTypeId: 0,
        NoOfPax: 0,
        HotelPrice: 0,
        SightseeingId: 0,
        VehicleId: 0,
        SightseeingPrice: 0,
        AirlineId: 0,
        AttractionBasicId: [],
        inclusionId: [],
        VehicleCategoryId: 0,
        TransaferVehicleDetailId: 0,
        TransferSightseeingId: 0,
        AirportSightseeingId: 0,
    }])

    const [dataitinerary, setDataItinerary] = useState(Itinerary);
    const [dataitinerarycounter, setDataItineraryCounter] = useState(0);
    const [itinerarybtntext, setItineraryBtnText] = useState('Add');

    const handleFlightFromchange = (e) => {
        setFlightFromId(e.value);
        if (flighttoid > 0) {
            resetflightselection();
            getAirlineData(e.value, flighttoid);
        }
    }

    const handleFlightToChange = (e) => {
        setFlightToId(e.value);
        if (flightfromid > 0) {
            resetflightselection();
            getAirlineData(flightfromid, e.value);
        }
    }

    const getAirlineData = async (fromid, toid) => {
        const airlinelistD = await getAllData('/master/v1/getpackageairlinebydstarv?dstid=' + fromid + '&arvid=' + toid);
        const airlinedatalist = airlinelistD.data?.map((value) => ({
            value: value.AirlineId,
            label: value.AirlineName
        })) || [];
        setAirlineList(airlinedatalist);
    }

    const resetflightselection = () => {
        setAirlineId(0);
        setFlightData([]);
        setFlightNoList([]);
        setFlightNo('');
        formvalue.DepartureTime = null
        formvalue.AirrivalTime = null
        formvalue.DepartureTimeD = ''
        formvalue.ArrivalTimeD = ''

        setArrivalTime("--:--")
        setDepartureTime("--:--")
        setHoursTime(null);
        formvalue.Duration = ''
        formvalue.FlightPrice = ''
        setSupplierList([]);
        setAirlineClassList([]);
        setAirlineList([]);
    }

    const resetflightairlineselection = () => {
        setFlightNo('');
        formvalue.DepartureTime = null
        formvalue.AirrivalTime = null
        formvalue.DepartureTimeD = ''
        formvalue.ArrivalTimeD = ''

        setArrivalTime("--:--")
        setDepartureTime("--:--")
        setHoursTime(null);
        formvalue.FlightPrice = ''
        setSupplierList([]);
        setAirlineClassList([]);
    }

    const handleAirlineChange = (e) => {
        if (airlineid !== e.value) {
            resetflightairlineselection();
        }
        setAirlineId(e.value);
        getflightnodata(e.value);
    }

    const getflightnodata = async (id) => {
        const flightnolistD = await getAllData('/master/v1/getpackageairlinedetail?airlineId=' + id + '&dstid=' + flightfromid + '&arvid=' + flighttoid);
        const flightlistdata = flightnolistD.data?.map((value) => ({
            value: value.FlightNo,
            label: value.FlightNo
        })) || []
        setFlightData(flightnolistD.data);
        setFlightNoList(flightlistdata);
    }

    const handleFlightNoChange = (e) => {
        setFlightNo(e.value);
        flightdata?.filter(obj => obj.FlightNo === e.value).map((value) => {
            formvalue.DepartureTime = formatTimeHourMinute(value.DepartureTime)
            formvalue.AirrivalTime = formatTimeHourMinute(value.AirrivalTime)
            formvalue.DepartureTimeD = formatTimeHourMinute(value.DepartureTime)
            formvalue.ArrivalTimeD = formatTimeHourMinute(value.AirrivalTime)
            setArrivalTime(formatTimeHourMinute(value.AirrivalTime))
            setDepartureTime(formatTimeHourMinute(value.DepartureTime))
            formvalue.Duration = value.Duration

            const supplierlist = flightdata?.filter(obj => obj.FlightNo === e.value).map((value) => ({
                value: value.SupplierId,
                label: value.SupplierName
            })) || [];

            const classlist = flightdata?.filter(obj => obj.FlightNo === e.value).map((value) => ({
                value: value.AirlineClassId,
                label: value.AirlineClassName
            })) || [];

            setSupplierList(supplierlist);
            setAirlineClassList(classlist);
        })
    }

    const handleclasschange = (e) => {
        setClassId(e.value)
    }

    const handlesupplierchange = (e) => {
        setSupplierId(e.value);
    }

    const handleitinerary = (e) => {
        const error = {}
        if (formvalue?.DaySightseeingId <= 0) {
            error.ItineraryError = 'Please enter all mandatory fields';
            setFormError(error);
            return;
        }
        if (formvalue.Day.trim() !== '' && formvalue.DaySchedule.trim() !== '') {
            if (formvalue.Day.trim().length > 500) {
                error.ItineraryDayError = 'Maximum character limit is 500 characters.';
                setFormError(error);
            }
        }
        else if (formvalue.Day.trim().length <= 0) {
            error.ItineraryError = 'Please enter all mandatory fields';
            setFormError(error);
            return;
        }

        else if (formvalue.DaySchedule.trim().length <= 0) {
            error.ItineraryError = 'Please enter all mandatory fields';
            setFormError(error);
            return;
        }
        if (EnableTransferSightseeingInclusionIds?.some((ele) => formvalue.InclusionId?.includes(ele)) && transferSightseeingDetail.TransferSightseeingId === 0) {
            error.ItineraryError = 'Please enter all mandatory fields';
            setFormError(error);
            return;
        }
        if (EnableAirportSightseeingInclusionIds?.some((ele) => formvalue.InclusionId?.includes(ele)) && airportSightseeingDetail.AirportSightseeingId === 0) {
            error.ItineraryError = 'Please enter all mandatory fields';
            setFormError(error);
            return;
        }

        if (formvalue.InclusionId?.includes(1) && hotelnameid <= 0) {
            error.ItineraryError = 'Please select Hotel.';
            setFormError(error);
            setHotelbuttontext(true)
            return;
        } else if (hotelnameid > 0 && (hotelRoomId <= 0 || mealTypeId <= 0)) {
            error.ItineraryError = 'Please enter all mandatory fields';
            setFormError(error);
            setHotelbuttontext(true)
            return;
        }
        if (formvalue?.InclusionId?.includes(5) && vehicleTransferId <= 0) {
            error.ItineraryError = 'Please select vehicle';
            setFormError(error);
            steVehicleTransferOpen(true);
            setVehicleTransferButtonText(true);
            return;
        } else if (formvalue?.InclusionId?.includes(5) && vehicleTransferId > 0 && selectedVehicleTransferDetail?.VehicleDetailId <= 0) {
            error.ItineraryError = 'Please select vehicle name.';
            setFormError(error);
            steVehicleTransferOpen(true);
            setVehicleTransferButtonText(true);
            return;
        }

        if (Object.keys(error).length <= 0) {
            setDataItineraryCounter(dataitinerarycounter + 1);
        }
    }

    const AddItineraryData = () => {
        if (packageD.state.PackageId === 0) {
            if (itinerarybtntext === 'Add') {
                let Day = formvalue.Day
                let DaySightseeingId = formvalue?.DaySightseeingId
                let DayScheduleD = formvalue.DaySchedule
                let AirrivalTime = formvalue.ArrivalTimeD
                let DepartureTime = formvalue.DepartureTimeD
                let HotelPrice = formvalue.HotelPrice
                let SightseeingId = formvalue.SightseeingId
                let FlightPrice = formvalue.FlightPrice
                let fromid = flightfromid;
                let toid = flighttoid;
                let supid = supplierid;
                let clsid = classid;
                let vehitypeid = vehicaltypeid;
                let price = vehicalprice;

                if (dataitinerarycounter === 1) {
                    setDataItinerary(current => [{
                        SeqNo: dataitinerarycounter,
                        Day: Day,
                        DaySightseeingId: DaySightseeingId,
                        DaySchedule: DayScheduleD,
                        FlightFromLocationId: fromid,
                        FlightToLocationId: toid,
                        FlightNo: flightno ? flightno : "",
                        ArrivalTime: (AirrivalTime !== null && AirrivalTime !== '' && AirrivalTime !== '--:--') ? "2022-11-10T" + AirrivalTime + ":00" : null,
                        ArrivalTimeD: (AirrivalTime !== null && AirrivalTime !== '' && AirrivalTime !== '--:--') ? "2022-11-10T" + AirrivalTime + ":00" : null,
                        DepartureTime: (DepartureTime !== null && DepartureTime !== '' && DepartureTime !== '--:--') ? "2022-11-10T" + DepartureTime + ":00" : null,
                        DepartureTimeD: (DepartureTime !== null && DepartureTime !== '' && DepartureTime !== '--:--') ? "2022-11-10T" + DepartureTime + ":00" : null,
                        ClassId: clsid,
                        SupplierId: supid,
                        FlightPrice: Number(FlightPrice),
                        HotelId: hotelnameid,
                        RoomTypeId: hotelroomtypeid,
                        HotelRoomId: hotelRoomId,
                        RateTypeId: mealTypeId,
                        NoOfPax: noofpaxid,
                        HotelPrice: HotelPrice ? HotelPrice : 0,
                        SightseeingId: SightseeingId,
                        VehicleId: vehitypeid,
                        SightseeingPrice: price === "" ? 0 : price,
                        AirlineId: Number(airlineid),
                        AttractionBasicId: formvalue?.AttractionBasicId,
                        inclusionId: formvalue?.InclusionId,
                        VehicleCategoryId: vehicleTransferId,
                        TransaferVehicleDetailId: selectedVehicleTransferDetail?.VehicleDetailId,
                        TransferSightseeingId: transferSightseeingDetail?.TransferSightseeingId,
                        AirportSightseeingId: airportSightseeingDetail?.AirportSightseeingId,
                    }]);
                } else {
                    setDataItinerary(current => [...current, {
                        SeqNo: dataitinerarycounter,
                        Day: Day,
                        DaySightseeingId: DaySightseeingId,
                        DaySchedule: DayScheduleD,
                        FlightFromLocationId: fromid,
                        FlightToLocationId: toid,
                        FlightNo: flightno ? flightno : "",
                        ArrivalTime: (AirrivalTime !== null && AirrivalTime !== '' && AirrivalTime !== '--:--') ? "2022-11-10T" + AirrivalTime + ":00" : null,
                        ArrivalTimeD: (AirrivalTime !== null && AirrivalTime !== '' && AirrivalTime !== '--:--') ? "2022-11-10T" + AirrivalTime + ":00" : null,
                        DepartureTime: (DepartureTime !== null && DepartureTime !== '' && DepartureTime !== '--:--') ? "2022-11-10T" + DepartureTime + ":00" : null,
                        DepartureTimeD: (DepartureTime !== null && DepartureTime !== '' && DepartureTime !== '--:--') ? "2022-11-10T" + DepartureTime + ":00" : null,
                        ClassId: clsid,
                        SupplierId: supid,
                        FlightPrice: Number(FlightPrice),
                        HotelId: hotelnameid,
                        RoomTypeId: hotelroomtypeid,
                        HotelRoomId: hotelRoomId,
                        RateTypeId: mealTypeId,
                        NoOfPax: noofpaxid,
                        HotelPrice: HotelPrice ? HotelPrice : 0,
                        SightseeingId: SightseeingId,
                        VehicleId: vehitypeid,
                        SightseeingPrice: price === "" ? 0 : price,
                        AirlineId: Number(airlineid),
                        AttractionBasicId: formvalue?.AttractionBasicId,
                        inclusionId: formvalue?.InclusionId,
                        VehicleCategoryId: vehicleTransferId,
                        TransaferVehicleDetailId: selectedVehicleTransferDetail?.VehicleDetailId,
                        TransferSightseeingId: transferSightseeingDetail?.TransferSightseeingId,
                        AirportSightseeingId: airportSightseeingDetail?.AirportSightseeingId,
                    }]);
                }
            }
            else {
                if (itineraryid > 0) {
                    handleeditofitinerary(itineraryid);
                }
            }
        }
        else {
            let dinc = dataitinerary?.filter(obj => obj.SeqNo > 0);

            let len = dinc.length;
            if (itineraryid === 0 && formvalue.Day.trim() !== '' && formvalue.DaySchedule.trim() !== '') {
                if (len === 0) {
                    setDataItinerary(current => [{
                        SeqNo: dataitinerarycounter,
                        Day: formvalue.Day,
                        DaySightseeingId: formvalue?.DaySightseeingId,
                        DaySchedule: formvalue.DaySchedule,
                        FlightFromLocationId: flightfromid,
                        FlightToLocationId: flighttoid,
                        FlightNo: flightno ? flightno : "",
                        ArrivalTime: (formvalue.ArrivalTimeD !== null && formvalue.ArrivalTimeD !== '' && formvalue.ArrivalTimeD !== '--:--') ? "2022-11-10T" + formvalue.ArrivalTimeD + ":00" : null,
                        DepartureTime: (formvalue.DepartureTimeD !== null && formvalue.DepartureTimeD !== '' && formvalue.DepartureTimeD !== '--:--') ? "2022-11-10T" + formvalue.DepartureTimeD + ":00" : null,
                        ArrivalTimeD: (formvalue.ArrivalTimeD !== null && formvalue.ArrivalTimeD !== '' && formvalue.ArrivalTimeD !== '--:--') ? "2022-11-10T" + formvalue.ArrivalTimeD + ":00" : null,
                        DepartureTimeD: (formvalue.DepartureTimeD !== null && formvalue.DepartureTimeD !== '' && formvalue.DepartureTimeD !== '--:--') ? "2022-11-10T" + formvalue.DepartureTimeD + ":00" : null,
                        ClassId: classid,
                        SupplierId: supplierid,
                        FlightPrice: Number(formvalue.FlightPrice),
                        HotelId: hotelnameid,
                        RoomTypeId: hotelroomtypeid,
                        HotelRoomId: hotelRoomId,
                        RateTypeId: mealTypeId,
                        NoOfPax: noofpaxid,

                        HotelPrice: formvalue.HotelPrice ? formvalue.HotelPrice : 0,
                        SightseeingId: formvalue.SightseeingId,
                        VehicleId: vehicaltypeid,
                        SightseeingPrice: vehicalprice === "" ? 0 : vehicalprice,
                        AirlineId: Number(airlineid),
                        AttractionBasicId: formvalue?.AttractionBasicId,
                        inclusionId: formvalue?.InclusionId,
                        VehicleCategoryId: vehicleTransferId,
                        TransaferVehicleDetailId: selectedVehicleTransferDetail?.VehicleDetailId,
                        TransferSightseeingId: transferSightseeingDetail?.TransferSightseeingId,
                        AirportSightseeingId: airportSightseeingDetail?.AirportSightseeingId,
                    }])
                }
                else {
                    setDataItinerary(current => [...current, {
                        SeqNo: dataitinerarycounter,
                        Day: formvalue.Day,
                        DaySightseeingId: formvalue?.DaySightseeingId,
                        DaySchedule: formvalue.DaySchedule,
                        FlightFromLocationId: flightfromid,
                        FlightToLocationId: flighttoid,
                        FlightNo: flightno ? flightno : "",
                        ArrivalTime: (formvalue.ArrivalTimeD !== null && formvalue.ArrivalTimeD !== '' && formvalue.ArrivalTimeD !== '--:--') ? "2022-11-10T" + formvalue.ArrivalTimeD + ":00" : null,
                        DepartureTime: (formvalue.DepartureTimeD !== null && formvalue.DepartureTimeD !== '' && formvalue.DepartureTimeD !== '--:--') ? "2022-11-10T" + formvalue.DepartureTimeD + ":00" : null,
                        ArrivalTimeD: (formvalue.ArrivalTimeD !== null && formvalue.ArrivalTimeD !== '' && formvalue.ArrivalTimeD !== '--:--') ? "2022-11-10T" + formvalue.ArrivalTimeD + ":00" : null,
                        DepartureTimeD: (formvalue.DepartureTimeD !== null && formvalue.DepartureTimeD !== '' && formvalue.DepartureTimeD !== '--:--') ? "2022-11-10T" + formvalue.DepartureTimeD + ":00" : null,
                        ClassId: classid,
                        SupplierId: supplierid,
                        FlightPrice: Number(formvalue.FlightPrice),
                        HotelId: hotelnameid,
                        RoomTypeId: hotelroomtypeid,
                        HotelRoomId: hotelRoomId,
                        RateTypeId: mealTypeId,
                        NoOfPax: noofpaxid,

                        HotelPrice: formvalue.HotelPrice ? formvalue.HotelPrice : 0,
                        SightseeingId: formvalue.SightseeingId,
                        VehicleId: vehicaltypeid,
                        SightseeingPrice: vehicalprice === "" ? 0 : vehicalprice,
                        AirlineId: Number(airlineid),
                        AttractionBasicId: formvalue?.AttractionBasicId,
                        inclusionId: formvalue?.InclusionId,
                        VehicleCategoryId: vehicleTransferId,
                        TransaferVehicleDetailId: selectedVehicleTransferDetail?.VehicleDetailId,
                        TransferSightseeingId: transferSightseeingDetail?.TransferSightseeingId,
                        AirportSightseeingId: airportSightseeingDetail?.AirportSightseeingId,
                    }])
                }
            }
            else if (itineraryid > 0 && formvalue.Day.trim() !== '' && formvalue.DaySchedule.trim() !== '') {
                handleeditofitinerary(itineraryid);
                setEditDisabled(false);
                reseterrormessage();
            }
        }
    }

    const handleeditofitinerary = (id) => {
        const newList = dataitinerary?.map((item) => {
            if (item.SeqNo === id) {
                const updatedItem = {
                    ...item,
                    Day: formvalue.Day,
                    DaySightseeingId: formvalue?.DaySightseeingId,
                    DaySchedule: formvalue.DaySchedule,
                    FlightFromLocationId: flightfromid,
                    FlightToLocationId: flighttoid,
                    FlightNo: flightno ? flightno : "",
                    ArrivalTime: (formvalue.ArrivalTimeD !== null && formvalue.ArrivalTimeD !== '' && formvalue.ArrivalTimeD !== '--:--') ? "2022-11-10T" + formvalue.ArrivalTimeD + ":00" : null,
                    DepartureTime: (formvalue.DepartureTimeD !== null && formvalue.DepartureTimeD !== '' && formvalue.DepartureTimeD !== '--:--') ? "2022-11-10T" + formvalue.DepartureTimeD + ":00" : null,
                    ArrivalTimeD: (formvalue.ArrivalTimeD !== null && formvalue.ArrivalTimeD !== '' && formvalue.ArrivalTimeD !== '--:--') ? "2022-11-10T" + formvalue.ArrivalTimeD + ":00" : "",
                    DepartureTimeD: (formvalue.DepartureTimeD !== null && formvalue.DepartureTimeD !== '' && formvalue.DepartureTimeD !== '--:--') ? "2022-11-10T" + formvalue.DepartureTimeD + ":00" : "",
                    ClassId: classid,
                    SupplierId: supplierid,
                    FlightPrice: Number(formvalue.FlightPrice),
                    HotelId: hotelnameid,
                    RoomTypeId: hotelroomtypeid,
                    HotelRoomId: hotelRoomId,
                    RateTypeId: mealTypeId,
                    NoOfPax: noofpaxid,

                    HotelPrice: Number(formvalue.HotelPrice),
                    SightseeingId: formvalue.SightseeingId,
                    VehicleId: vehicaltypeid,
                    SightseeingPrice: vehicalprice === "" ? 0 : vehicalprice,
                    AirlineId: Number(airlineid),
                    AttractionBasicId: formvalue?.AttractionBasicId,
                    inclusionId: formvalue?.InclusionId,
                    VehicleCategoryId: vehicleTransferId,
                    TransaferVehicleDetailId: selectedVehicleTransferDetail?.VehicleDetailId,
                    TransferSightseeingId: transferSightseeingDetail?.TransferSightseeingId,
                    AirportSightseeingId: airportSightseeingDetail?.AirportSightseeingId,
                };
                return updatedItem;
            }
            return item;
        });
        setDataItinerary(newList);
    }

    useEffect(() => {
        handlegstcalculation();
        ClearItineraryDetail();
    }, [dataitinerary]);

    const removeitinerary = (id, e) => {
        setDataItinerary((oldState) => oldState?.filter((item) => item.SeqNo !== id));
        reseterrormessage();
        setEditDisabled(false);
    }

    useEffect(() => {
        if (dataitinerarycounter > 0) {
            AddItineraryData();
        }
    }, [dataitinerarycounter]);

    const handleclearItinerary = () => {
        ClearItineraryDetail();
    }

    const ClearItineraryDetail = () => {
        setItineraryBtnText('Add');
        setItineraryId(0);
        setHotelName('Hotel Name');
        setSightseeingName('Sightseeing Name');
        setHotelRating(0);

        formvalue.Rating = 0
        formvalue.Day = ''
        formvalue.DaySightseeingId = 0
        formvalue.DaySchedule = ''
        formvalue.AirrivalTime = null
        formvalue.DepartureTime = null
        formvalue.ArrivalTimeD = ''
        formvalue.DepartureTimeD = ''
        formvalue.HotelPrice = ''
        formvalue.SightseeingId = 0
        formvalue.FlightPrice = ''
        setArrivalTime("--:--");
        setDepartureTime("--:--");
        setHoursTime(null);
        setAirlineList([]);
        setFlightNoList([]);
        setAirlineClassList([]);
        setSupplierList([]);
        setRoomTypeList([]);
        setVehicalListData([]);

        setFlightFromId(0);
        setFlightToId(0);
        setClassId(0);
        setSupplierId(0);
        setVehicalTypeId(0);
        setVehicalPrice(0);


        formvalue.Duration = ''
        formvalue.PickUpPoint = ''
        formvalue.DropPoint = ''
        formvalue.ItineraryDetails = ''
        formvalue.HotelPrice = ''
        formvalue.Hours = ''
        setFlightNo('');
        setAirlineId(0);
        setHotelNameId(0);
        setHotelRoomTypeId(0);
        setSightSeeingId(0);
        setNoOfPaxId(0);
        setMealTypeId(0);
        setFormError('');
        setFromFlightDisable(false)
        setToFlightDisable(false)
        setHotelDisable(false)
        setSightseeingDisable(false)
        const richtext = document.querySelector('.dayschedule .jodit-wysiwyg');
        if (richtext !== null) {
            document.querySelector('.dayschedule .jodit-wysiwyg').innerHTML = null;
        }
        formvalue.AttractionBasicId = [];
        formvalue.InclusionId = []

        steVehicleTransferOpen(false)
        setVehicleTransferButtonText(false)
        setVehicleTransferDisabled(false)
        setVehicleTransferNameDisabled(false)
        setVehicleTransferId(0)
        setSelectedVehicleTransferDetail((prev) => ({
            ...prev,
            VehicleDetailId: 0,
            VehicleName: "",
            SeatingCapacity: "",
            VehicleType: "",
        }))

        setTransferSightseeingDetail((form) => ({
            ...form,
            TransferSightseeingId: 0,
            TransferSightseeingName: "",
            TransferSightseeingPickupPoint: "",
            TransferSightseeingDropPoint: "",
            TransferSightseeingDuration: null,
            TransferSightseeingItineraryDetails: "",
        }))
        setTransferSightseeingOpen(false);
        setTransferSightseeingbuttontext(false);
        setTransferSightseeingDisable(false);

        setAirportSightseeingDetail((form) => ({
            ...form,
            AirportSightseeingId: 0,
            AirportSightseeingName: "",
            AirportSightseeingPickupPoint: "",
            AirportSightseeingDropPoint: "",
            AirportSightseeingDuration: null,
            AirportSightseeingItineraryDetails: "",
        }))
        setAirportSightseeingOpen(false);
        setAirportSightseeingbuttontext(false);
        setAirportSightseeingDisable(false);
    }

    const clearFlightDetail = () => {
        formvalue.AirrivalTime = null
        formvalue.DepartureTime = null
        formvalue.ArrivalTimeD = ''
        formvalue.DepartureTimeD = ''
        formvalue.FlightPrice = ''
        formvalue.Duration = ''
        setArrivalTime("--:--");
        setDepartureTime("--:--");
        setHoursTime(null);
        setAirlineList([]);
        setFlightNoList([]);
        setAirlineClassList([]);
        setAirlineClassList([]);
        setSupplierList([]);

        setFlightNo('');
        setAirlineId(0);

        setFlightFromId(0);
        setFlightToId(0);
        setClassId(0);
        setSupplierId(0);

    }

    const handleSightseenhandlechangeretrive = async (id, fromid, toid) => {
        allsightseeing?.filter(obj => obj.SightseeingId === id).map((value) => {
            formvalue.SightseeingId = id
            formvalue.PickUpPoint = value.PickUpPoint
            formvalue.DropPoint = value.DropPoint
            formvalue.Hours = value.Hours
            formvalue.ItineraryDetails = value.ItineraryDetails
            setHoursTime(value.Hours ? dayjs(value.Hours) : null)
        })
        const SightseeingId = formvalue.SightseeingId;
        const vehicallist = await postUsersData('/master/v1/getpackagesightseeingdetail', { SightseeingId });
        const vehichallistD = vehicallist.data?.map((value) => ({
            label: value.VehicleName,
            value: value.VehicleDetailId
        }));
        setVehicalListData(vehichallistD);
        setVehicalTypeList(vehicallist.data);
        setSightSeeingId(id);
    }
    const getflightnodataforedit = async (id, fromid, toid, flightno) => {
        const flightnolistD = await getAllData('/master/v1/getpackageairlinedetail?airlineId=' + id + '&dstid=' + fromid + '&arvid=' + toid);
        const flightlistdata = flightnolistD.data?.map((value) => ({
            value: value.FlightNo,
            label: value.FlightNo
        })) || []
        setFlightNoList(flightlistdata);
        setFlightData(flightnolistD.data)
        flightnolistD.data?.filter(obj => obj.FlightNo === flightno).map((value) => {
            formvalue.DepartureTime = formatTimeHourMinute(value.DepartureTime)
            formvalue.AirrivalTime = formatTimeHourMinute(value.AirrivalTime)
            formvalue.Duration = value.Duration

        });

        const supplierlist = flightnolistD.data?.filter(obj => obj.FlightNo === flightno).map((value) => ({
            value: value.SupplierId,
            label: value.SupplierName
        })) || [];

        const classlist = flightnolistD.data?.filter(obj => obj.FlightNo === flightno).map((value) => ({
            value: value.AirlineClassId,
            label: value.AirlineClassName
        })) || [];

        setSupplierList(supplierlist);
        setAirlineClassList(classlist);
    }

    const handleEditItinerary = (id, e) => {
        e.preventDefault();
        e.stopPropagation();
        ClearItineraryDetail();
        setItineraryId(id);
        setItineraryBtnText('Update');

        dataitinerary?.filter(obj => obj.SeqNo === id).map((ele, index) => {
            formvalue.Day = ele.Day
            formvalue.DaySightseeingId = ele.DaySightseeingId
            formvalue.AttractionBasicId = ele?.AttractionBasicId
            formvalue.InclusionId = ele?.inclusionId
            formvalue.DaySchedule = ele.DaySchedule

            // Issue: when click on Edit for second time then first clear the joditEditor's value but not assign
            // solution: Add below commented code when editorRef.current.value = '' in ClearItineraryDetail function
            // if (editorRef.current) {
            //     editorRef.current.value = ele?.DaySchedule;
            // }

            setFlightFromId(ele.FlightFromLocationId);
            setFlightToId(ele.FlightToLocationId);
            if (ele.FlightFromLocationId !== 0 && ele.FlightToLocationId !== 0) {
                getAirlineData(ele.FlightFromLocationId, ele.FlightToLocationId);
                setAirlineId(ele.AirlineId);
                getflightnodataforedit(ele.AirlineId, ele.FlightFromLocationId, ele.FlightToLocationId, ele.FlightNo)
                setFlightNo(ele.FlightNo);
                setAirlineId(ele.AirlineId);

                setClassId(ele.ClassId);
                setSupplierId(ele.SupplierId);
                formvalue.FlightPrice = ele.FlightPrice
                let allfromflightlist = allflightfrom?.filter(IsAct => IsAct.IsActive === true);
                setFlightfrom(allflightfrom?.filter(IsAct => IsAct.IsActive === true));
                setFromFlightDisable(false);
                if (!allfromflightlist?.find(Isfromlist => Isfromlist.LocationId === ele.FlightFromLocationId)) {
                    setFromFlightDisable(true)
                    setFlightfrom((prvfromData) => prvfromData?.length > 0 ? [...prvfromData, allflightfrom?.find(isFrom => isFrom.LocationId === ele.FlightFromLocationId)] : [])

                }
                let allytoflightlist = allflightto?.filter(IsAct => IsAct.IsActive === true);
                setFlightTo(allflightto?.filter(IsAct => IsAct.IsActive === true));
                setToFlightDisable(false);
                if (!allytoflightlist?.find(Istolist => Istolist.LocationId === ele.FlightToLocationId)) {
                    setToFlightDisable(true)
                    setFlightTo((prvtoData) => prvtoData?.length > 0 ? [...prvtoData, allflightto?.find(isTo => isTo.LocationId === ele.FlightToLocationId)] : [])

                }
            }
            if (ele.HotelId > 0) {
                hotelList?.filter(obj => obj.HotelId === ele.HotelId).map(value => {
                    setHotelRating(value.rating);
                });
                setHotelNameId(ele.HotelId);

                let allhotellist = hotelList?.filter(IsAct => IsAct.isActive === true);
                setHotelDisable(false);
                const selectedHotel = allhotellist?.find(Ishotellist => Ishotellist.hotelId === ele.HotelId);
                setHotelRating(selectedHotel?.rating);
                setHotelName(selectedHotel?.name);
                const roomList = selectedHotel?.hotelRoomsModel.map((room) => ({
                    ...room,
                    label: room.roomTypeName,
                    value: room.roomTypeId
                }));
                setRoomTypeList(roomList);
                setHotelRoomId(ele?.HotelRoomId);
                setHotelRoomTypeId(ele?.RoomTypeId)

                const MealList = selectedHotel?.hotelRoomsModel.find((room) => room.hotelRoomId === ele?.HotelRoomId)?.hotelMealModel?.map((meal) => ({
                    ...meal,
                    label: meal.rateTypeName,
                    value: meal.rateTypeId
                }))

                setRoomMealList(MealList);
                setMealTypeId(ele?.RateTypeId);


                if (!selectedHotel) {
                    setHotelDisable(true)
                }

                formvalue.HotelPrice = ele.HotelPrice

                setNoOfPaxId(ele.NoOfPax);
            }

            if (ele.HotelId === 0) {
                setHotelDisable(false);
            }

            formvalue.AirrivalTime = ele.ArrivalTime
            formvalue.DepartureTime = ele.DepartureTime


            if (ele.ArrivalTime === null || ele.DepartureTime === null) {
                setDepartureTime("--:--");
                setArrivalTime("--:--");
            }
            else {
                formvalue.ArrivalTimeD = formatTimeHourMinute(ele.ArrivalTime)
                formvalue.DepartureTimeD = formatTimeHourMinute(ele.DepartureTime)
                setDepartureTime(formatTimeHourMinute(ele.DepartureTime))
                setArrivalTime(formatTimeHourMinute(ele.ArrivalTime))
            }

            formvalue.HotelPrice = ele.HotelPrice
            formvalue.SightseeingId = ele.SightseeingId

            if (ele.SightseeingId > 0) {
                handleSightseenhandlechangeretrive(ele.SightseeingId);
                allsightseeing?.filter(obj => obj.SightseeingId === ele.SightseeingId).map(value => {
                    setSightseeingName(value.SightseeingName);
                });

                setVehicalTypeId(ele.VehicleId);

                formvalue.VehicalPrice = ele.SightseeingPrice

                let allsightseeinglist = allsightseeing?.filter(IsAct => IsAct.IsActive === true);
                setSightSeeingList(allsightseeing?.filter(IsAct => IsAct.IsActive === true));
                setSightseeingDisable(false)
                if (!allsightseeinglist?.find(Issightlist => Issightlist.SightseeingId === ele.SightseeingId)) {
                    setSightseeingDisable(true)
                    setSightSeeingList((prvsightData) => prvsightData?.length > 0 ? [...prvsightData, allsightseeing?.find(isSight => isSight.SightseeingId === ele.SightseeingId)] : [])
                }
                setVehicalPrice(ele.SightseeingPrice);
            }

            if (ele?.VehicleCategoryId > 0) {
                setVehicleTransferId(ele?.VehicleCategoryId)
                let isVehicleCategoryActive;
                if (vehicleTransferCategoryAndListData?.vehicleCategoryList?.length > 0) {
                    isVehicleCategoryActive = vehicleTransferCategoryAndListData?.vehicleCategoryList?.find((fin) => fin?.value === ele?.VehicleCategoryId)
                    !isVehicleCategoryActive && setVehicleTransferDisabled(true);
                }
                if (isVehicleCategoryActive && vehicleTransferCategoryAndListData?.vehicleList?.length > 0 && ele?.TransaferVehicleDetailId > 0) {
                    const isVehicleTransferActive = vehicleTransferCategoryAndListData?.vehicleList?.filter((fil) => fil?.VehicleCategoryId === ele?.VehicleCategoryId)?.find((fin) => fin?.value === ele?.TransaferVehicleDetailId)
                    !isVehicleTransferActive && setVehicleTransferNameDisabled(true);
                    if (isVehicleTransferActive) {
                        setSelectedVehicleTransferDetail((prev) => ({
                            ...prev,
                            VehicleDetailId: isVehicleTransferActive?.VehicleDetailId,
                            VehicleName: isVehicleTransferActive?.VehicleName,
                            SeatingCapacity: isVehicleTransferActive?.SeatingCapacity,
                            VehicleType: isVehicleTransferActive?.VehicleType,
                        }))
                    }
                }

            }
            if (ele?.TransferSightseeingId > 0) {
                allsightseeing?.filter(obj => obj?.SightseeingId === ele?.TransferSightseeingId)?.forEach(value => {
                    setTransferSightseeingDetail((form) => ({
                        ...form,
                        TransferSightseeingId: ele?.TransferSightseeingId,
                        TransferSightseeingName: value?.SightseeingName,
                        TransferSightseeingPickupPoint: value?.PickUpPoint,
                        TransferSightseeingDropPoint: value?.DropPoint,
                        TransferSightseeingDuration: value?.Hours ? dayjs(value?.Hours) : null,
                        TransferSightseeingItineraryDetails: value?.ItineraryDetails,
                    }))
                });


                const allsightseeinglist = allsightseeing?.filter(IsAct => IsAct?.IsActive === true);
                setTransferSightSeeingList(allsightseeinglist);
                setTransferSightseeingDisable(false)
                if (!allsightseeinglist?.find(Issightlist => Issightlist?.SightseeingId === ele?.TransferSightseeingId)) {
                    setTransferSightseeingDisable(true)
                    setTransferSightSeeingList((prvsightData) => prvsightData?.length > 0 ? [...prvsightData, allsightseeing?.find(isSight => isSight?.SightseeingId === ele?.TransferSightseeingId)] : [])
                }
            }
            if (ele?.AirportSightseeingId > 0) {
                allsightseeing?.filter(obj => obj?.SightseeingId === ele?.AirportSightseeingId)?.forEach(value => {
                    setAirportSightseeingDetail((form) => ({
                        ...form,
                        AirportSightseeingId: ele?.AirportSightseeingId,
                        AirportSightseeingName: value?.SightseeingName,
                        AirportSightseeingPickupPoint: value?.PickUpPoint,
                        AirportSightseeingDropPoint: value?.DropPoint,
                        AirportSightseeingDuration: value?.Hours ? dayjs(value?.Hours) : null,
                        AirportSightseeingItineraryDetails: value?.ItineraryDetails,
                    }))
                });


                const allsightseeinglist = allsightseeing?.filter(IsAct => IsAct?.IsActive === true);
                setAirportSightSeeingList(allsightseeinglist);
                setAirportSightseeingDisable(false)
                if (!allsightseeinglist?.find(Issightlist => Issightlist?.SightseeingId === ele?.AirportSightseeingId)) {
                    setAirportSightseeingDisable(true)
                    setAirportSightSeeingList((prvsightData) => prvsightData?.length > 0 ? [...prvsightData, allsightseeing?.find(isSight => isSight?.SightseeingId === ele?.AirportSightseeingId)] : [])
                }
            }

        })
    }
    //#endregion


    //#region  gst count
    const [gstid, setGstId] = useState(1);
    const [gst, setGst] = useState(5);
    const [gsttype, setGstType] = useState('FIX');

    const gstlist = [
        { value: 1, label: '5' },
        { value: 2, label: '10' },
        { value: 3, label: '18' },
        { value: 4, label: '28' }
    ]

    const handlegstonchange = (e) => {
        reseterrormessage();
        setEditDisabled(false);
        formvalue.GST = e.value
        setGst(e.label);
        handlegstcalculation();
    }

    const handlegsttypechange = (e) => {
        formvalue.GST = gstid
        formvalue.PackageFixPrice = 1
        formvalue.PackageMarkupValue = '1'
        setGstType('GST');
    }

    useEffect(() => {
        handlegstcalculation();
    }, [gsttype]);

    const handlefixtypetax = () => {
        formvalue.GST = gstid
        formvalue.PackageFixPrice = 0
        formvalue.PackageMarkupValue = '0'
        setGstType('FIX');
        handlegstcalculation();
        setFormError('');
    }
    //#endregion

    const onChange = (e) => {
        var result;

        if ([e.target.name][0] === 'IsBestPackage') {
            setBestPackage(e.target.checked);
            result = e.target.checked
        }
        else if ([e.target.name][0] === 'IsHotDeals') {
            setHotDeals(e.target.checked);
            result = e.target.checked
        }
        else if ([e.target.name][0] === 'HotOfferPercentage') {
            result = isNaN(e.target.value) ? 0 : Number(onlyNumeric(e.target.value))
            formvalue.HotOfferPercentage = result
        }
        else if ([e.target.name][0] === 'IsInternationalDestination') {
            setIsInternationalDestination(e.target.checked);
            result = e.target.checked
        }
        else if ([e.target.name][0] === 'IsBestDestination') {
            setIsBestDestination(e.target.checked);
            result = e.target.checked
        }
        else if ([e.target.name][0] === 'IsTrendingHoliday') {
            setIsTrendingHoliday(e.target.checked);
            result = e.target.checked
        }
        else if ([e.target.name][0] === 'PackageInventoryCountD') {
            result = isNaN(e.target.value) ? 0 : Number(onlyNumeric(e.target.value));

            formvalue.PackageInventoryCount = result

        }
        else if ([e.target.name][0] === 'PackageCutOffCountD') {
            result = e.target.value === "" ? null : Number(onlyNumeric(e.target.value));
            if (result === null) {
                formvalue.PackageCutOffCount = null
            }
            else {
                formvalue.PackageCutOffCount = result
            }

        }
        else if ([e.target.name][0] === 'PackageValidateStartD') {

            formvalue.PackageValidateStart = e.target.value
            result = e.target.value;
        }
        else if ([e.target.name][0] === 'PackageValidateEndD') {
            formvalue.PackageValidateEnd = e.target.value
            result = e.target.value;
        }
        else if ([e.target.name][0] === 'PackageFixPrice') {
            formvalue.PackageFixPrice = ((e.target.value !== '' && !isNaN(e.target.value)) ? (NumericWithDecimal(e.target.value)) : '0')
            formvalue.PackageMarkupValue = ((e.target.value !== '' && !isNaN(e.target.value)) ? (NumericWithDecimal(e.target.value)) : '0')
            result = ((e.target.value !== '' && !isNaN(e.target.value)) ? (NumericWithDecimal(e.target.value)) : '0');
            handlegstcalculation();
        }
        else if ([e.target.name][0] === 'FlightPrice') {
            result = isNaN(e.target.value) ? 0 : Number(onlyNumeric(e.target.value))
        }
        else if ([e.target.name][0] === 'PackageDiscount') {
            result = Number(onlyNumeric(e.target.value));
        }
        else {
            result = e.target.value;
        }
        setFormValue({ ...formvalue, [e.target.name]: result });
        if ([e.target.name][0] === 'PackageName') {
            setBasicDraftDisabled(false);
        }

        reseterrormessage();
        setEditDisabled(false);
    }

    //#region textbox

    const config = useMemo(() => ({
        readonly: true, // all options from https://xdsoft.net/jodit/doc/,
        height: '100%',
        width: '100%',
        statusbar: false,
        removeButtons: ["link", "about"],
        toolbarAdaptive: false,
        height: 'auto',
        maxHeight: richboxheight === true ? 200 : 500,
        disablePlugins: ["source"],
        disabled: disabled ? true : false
    }), [disabled]);

    useEffect(() => {
        const richtexteboxheight = document.getElementById("layoutSidenav_content").clientWidth
        if (richtexteboxheight > 912) {
            setRichBoxHeight(true)
        }
        else {
            setRichBoxHeight(false)
        }
    }, []);

    const dayscheduleconfig = useMemo(() => ({
        readonly: false, // all options from https://xdsoft.net/jodit/doc/,
        height: '100%',
        width: '100%',
        statusbar: false,
        disablePlugins: ["source"],
        removeButtons: ["about", "image", "link", "select", "video"],
        height: 'auto',
        maxHeight: richboxheight === true ? 200 : 500,
        toolbarAdaptive: false,
        //autofocus: true,
        defaultMode: "1",
        disabled: disabled ? true : false
    }), [disabled]);
    //#endregion textbox

    const handlegstcalculation = () => {
        let basicpricecalculation = 0;
        setGst(5);
        const result = dataitinerary.reduce((total, currentValue) => total = total + (Number(currentValue.FlightPrice) + Number(currentValue.HotelPrice) + Number(currentValue.SightseeingPrice)), 0);
        basicpricecalculation = result;
        //fixprice
        if (result > 0) {
            formvalue.PackageBasicPrice = result
            if (gsttype === 'GST') {
                let markupvalue = (Number(basicpricecalculation) * Number(formvalue.PackageFixPrice)) / 100;
                const GSTAmount = (((Number(basicpricecalculation) + Number(markupvalue)) * Number(gst)) / 100);
                formvalue.PackageFinalPrice = (Number(basicpricecalculation) + Number(markupvalue) + Number(GSTAmount)).toFixed(2)
                setPkgFinalPrice((Number(basicpricecalculation) + Number(markupvalue) + Number(GSTAmount)).toFixed(2));
            }
            else {
                let gstfixvalue = (((Number(basicpricecalculation) + Number(formvalue.PackageFixPrice)) * Number(gst)) / 100);
                formvalue.PackageFinalPrice = (Number(basicpricecalculation) + Number(formvalue.PackageFixPrice) + Number(gstfixvalue)).toFixed(2)
                setPkgFinalPrice((Number(basicpricecalculation) + Number(formvalue.PackageFixPrice) + Number(gstfixvalue)).toFixed(2))
            }
        }
        else {
            formvalue.PackageBasicPrice = 0
            if (gsttype === 'GST') {
                formvalue.PackageFinalPrice = 0
                setPkgFinalPrice(0)

            }
            else {
                formvalue.PackageFinalPrice = 0
                setPkgFinalPrice(0)
            }

        }
    }


    //#region start input date type box

    const handleDateChange = (fieldname, e) => {
        if (fieldname === 'PackageValidateStartD') {
            formvalue.PackageValidateStartD = formatDateyearmonthday(e)
            formvalue.PackageValidateStart = formatDateyearmonthday(e)
            setPackageValidateStart(e);
        }
        else if (fieldname === 'PackageValidateEndD') {
            formvalue.PackageValidateEndD = formatDateyearmonthday(e)
            formvalue.PackageValidateEnd = formatDateyearmonthday(e)
            setPackageValidateEnd(e)
        }
        setEditDisabled(false);
        reseterrormessage();

    }

    const openDatePicker = (e) => {
        //open date picker on click date icon 
        document.querySelector("#" + e).click();
    };


    //#endregion end input date type box

    //#region start input time type box
    const [departureTime, setDepartureTime] = useState("--:--");
    const [arrivalTime, setArrivalTime] = useState("--:--");
    const [hoursTime, setHoursTime] = useState(null);

    const handleonchangeofTime = (fieldname, times) => {
        if (fieldname === 'ArrivalTimeD') {
            formvalue.ArrivalTimeD = times
            setArrivalTime(times)
            reseterrormessage();
        }
        else if (fieldname === 'DepartureTimeD') {
            formvalue.DepartureTimeD = times
            setDepartureTime(times)
            reseterrormessage();
        }
        else if (fieldname === 'Hours') {
            formvalue.Hours = times
            setHoursTime(times)
            reseterrormessage();
        }
    }
    //#endregion end input time type box

    const [childprice, setChildPrice] = useState(null)
    const handleChildPrice = (e) => {
        let result = NumericWithDecimal(e.target.value) === '' ? '' : NumericWithDecimal(e.target.value)
        setChildPrice(result)
        formvalue.ChildrenPrice = Number(result) !== 0 ? Number(result) : null

        reseterrormessage();
        setEditDisabled(false);
    }
    //region start return

    const handleVehicleTransferSelectChange = (name, e) => {
        if (name === "vehicleTransferId") {
            setVehicleTransferId(e?.value)
            setSelectedVehicleTransferDetail((prev) => ({
                ...prev,
                VehicleDetailId: 0,
                VehicleName: "",
                SeatingCapacity: "",
                VehicleType: "",
            }))
        }
        else {
            setSelectedVehicleTransferDetail((prev) => ({
                ...prev,
                VehicleDetailId: e?.VehicleDetailId,
                VehicleName: e?.VehicleName,
                SeatingCapacity: e?.SeatingCapacity,
                VehicleType: e?.VehicleType,
            }))
        }
        reseterrormessage();
    }

    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>ETM Package</h3>
            </div>
            <div className="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row">
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Select Country</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <Select
                                                ref={CountryId}
                                                id="CountryId"
                                                className="dropdown select_dropdown"
                                                options={locationDropdown?.country}
                                                value={locationDropdown?.country?.filter(obj => formvalue?.CountryId?.includes(obj?.value))}
                                                onChange={(e) => onSelectChange('CountryId', e)} // assign onChange function
                                                isDisabled={stateenable ? true : false}
                                                isSearchable
                                                isMulti
                                            />
                                            {formerror.Country && <p className='text-danger text-start'>{formerror.Country}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className={`col-form-label ${formvalue?.CountryId?.includes(1) ? 'required' : ''} `}>Select State</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <Select
                                                ref={StateId}
                                                id="StateId"
                                                className="dropdown select_dropdown"
                                                options={locationDropdown?.state}
                                                value={locationDropdown?.state?.filter(obj => formvalue?.StateId?.includes(obj?.value))}
                                                onChange={(e) => onSelectChange('StateId', e)} // assign onChange function
                                                isDisabled={(stateenable ? true : false) || !formvalue.CountryId.includes(1)}
                                                isSearchable
                                                isMulti
                                            />
                                            {formerror.StateId && <p className='text-danger text-start'>{formerror.StateId}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Select City</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <Select
                                                ref={Locationid}
                                                id="Locationid"
                                                className="dropdown select_dropdown"
                                                options={locationDropdown?.city}
                                                value={locationDropdown?.city?.filter(obj => formvalue?.LocationId?.includes(obj?.value))}
                                                onChange={(e) => onSelectChange('LocationId', e)} // assign onChange function
                                                isDisabled={stateenable ? true : false}
                                                isSearchable
                                                isMulti
                                            />
                                            {formerror.Locationid && <p className='text-danger text-start'>{formerror.Locationid}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Code</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <input type="text" id="inputPassword6" className="form-control"
                                                name="PackageCode"
                                                value={formvalue.PackageCode}
                                                disabled={true}
                                                placeholder="Package Code"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Name</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <input type="text" id="PackageName" className="form-control"
                                                name="PackageName"
                                                value={formvalue.PackageName}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder="Package Name"
                                            />
                                            {formerror.PackageName && <p className='text-danger text-start'>{formerror.PackageName}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Type</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            {/* //checkedvalueofpackagetypevalue */}
                                            {packagetypelist && packagetypelist?.map((ele, index) => {
                                                return (<div className="form-check-inline">
                                                    <input className="form-check-input" type="radio" name="flexRadioType" id="flexRadioLevel4" value={ele.PackageTypeId} key={ele.PackageTypeId} onChange={(e) => handlePackageTypeChange(ele.PackageTypeId, e)}
                                                        checked={checkedvalueofpackagetypevalue === ele.PackageTypeId ? true : false} disabled={stateenable ? true : false} />
                                                    <label className="form-check-label ms-1">{ele.PackageTypeName}</label>
                                                </div>
                                                );

                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Select Category</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <Select
                                                ref={PackageCategory}
                                                id="PackageCategory"
                                                className="dropdown select_dropdown"
                                                options={packagecategorydatalist}
                                                value={packagecategorydatalist?.filter(function (packagecategorydatalist) {
                                                    return packagecategorydatalist.value === formvalue?.PackageCategoryId;
                                                })}// set list of the data
                                                onChange={(e) => handledropdown('PackageCategoryId', e?.value)}
                                                isDisabled={disabled ? true : false}
                                                isSearchable
                                            />
                                            {formerror.PackageCategory && <p className='text-danger text-start'>{formerror.PackageCategory}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Price Type</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <div className="form-check-inline">
                                                <input
                                                    type="radio"
                                                    id="with_price"
                                                    className="form-check-input"
                                                    name='IsPriceType'
                                                    onChange={(e) => handleOnChange('IsPriceType', true)}
                                                    checked={formvalue?.IsPriceType === true ? true : false}
                                                    disabled={stateenable ? true : false}
                                                />
                                                <label className="form-check-label ms-1" htmlFor='with_price'>With Price</label>
                                            </div>
                                            <div className="form-check-inline">
                                                <input
                                                    type="radio"
                                                    id="without_price"
                                                    className="form-check-input"
                                                    name='IsPriceType'
                                                    onChange={(e) => handleOnChange('IsPriceType', false)}
                                                    checked={formvalue?.IsPriceType === false ? true : false}
                                                    disabled={stateenable ? true : false}
                                                />
                                                <label className="form-check-label ms-1" htmlFor='without_price'> Without Price</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Arrival Slot</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <Select
                                                id="ArrivalSlotId"
                                                ref={ArrivalSlotId}
                                                className="dropdown select_dropdown"
                                                options={arrivalslotlist}
                                                value={arrivalslotlist?.filter(function (arrivalslotlist) {
                                                    return arrivalslotlist.value === formvalue?.ArrivalSlotId;
                                                })}// set list of the data
                                                onChange={(e) => handledropdown('ArrivalSlotId', e?.value)}
                                                isDisabled={disabled ? true : false}
                                                isSearchable
                                            />
                                            {formerror.ArrivalSlotId && <p className='text-danger text-start'>{formerror.ArrivalSlotId}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Level</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            {packagelevellist && packagelevellist?.map((ele, index) => {
                                                return (
                                                    <div className="form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="flexRadioLevel"
                                                            id={ele?.PackageLevelName}
                                                            key={ele?.PackageLevelId}
                                                            checked={formvalue?.PackageLevelId === ele?.PackageLevelId}
                                                            disabled
                                                        />
                                                        <label className="form-check-label ms-1" htmlFor={ele?.PackageLevelName} >{ele?.PackageLevelName}</label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Routing</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            {
                                                IsInterCityRadio?.map((obj) => {
                                                    return (
                                                        <div className="form-check-inline" key={obj?.title}>
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="PackageRouting"
                                                                id={obj?.title}
                                                                checked={obj?.id === 1 ? formvalue?.IsInterCity : !formvalue?.IsInterCity}
                                                                disabled
                                                            />
                                                            <label className="form-check-label ms-1" htmlFor={obj?.title}>
                                                                {obj?.title}
                                                            </label>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Validity Start</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <div className="text-container">
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    className='form-control'
                                                    id='startdate'
                                                    selected={packageValidateStart}
                                                    onChange={(e) => handleDateChange('PackageValidateStartD', e)}
                                                    disabled={disabled ? true : false}
                                                    placeholderText="dd/mm/yyyy"
                                                    minDate={new Date()}
                                                    maxDate={new Date(new Date().getFullYear() + 20, 11, 30)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode='select'
                                                    autoComplete='off'
                                                />
                                                <span className="example-custom-input calendarBtn" onClick={(e) => openDatePicker("startdate")} id="calendarBtn1" disabled={disabled ? true : false} ><i className="fa fa-calendar"></i></span>
                                            </div>

                                            {formerror.PackageValidateStart && <p className='text-danger text-start'>{formerror.PackageValidateStart}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Departure Slot</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <Select
                                                id="DepartureSlotid"
                                                ref={DepartureSlotid}
                                                className="dropdown select_dropdown"
                                                options={departureslotlist}
                                                value={departureslotlist?.filter(function (departureslotlist) {
                                                    return departureslotlist.value === formvalue?.DepartureSlotId;
                                                })}// set list of the data
                                                onChange={(e) => handledropdown('DepartureSlotId', e?.value)}
                                                isDisabled={disabled ? true : false}
                                                isSearchable
                                            />
                                            {formerror.DepartureSlotid && <p className='text-danger text-start'>{formerror.DepartureSlotid}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Inventory Count</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <input type="text" id="PackageInventoryCount" className="form-control"
                                                name="PackageInventoryCountD"
                                                value={formvalue.PackageInventoryCountD}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder="Package Inventory Count"
                                            />
                                            {formerror.PackageInventoryCount && <p className='text-danger text-start'>{formerror.PackageInventoryCount}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Validity End</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <div className="text-container">
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    className='form-control'
                                                    id='enddate'
                                                    selected={packageValidateEnd}
                                                    onChange={(e) => handleDateChange('PackageValidateEndD', e)}
                                                    disabled={disabled ? true : false}
                                                    placeholderText="dd/mm/yyyy"
                                                    minDate={new Date()}
                                                    maxDate={new Date(new Date().getFullYear() + 20, 11, 30)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode='select'
                                                    autoComplete='off'
                                                />
                                                <span className="example-custom-input calendarBtn" onClick={(e) => openDatePicker("enddate")} id="calendarBtn1" disabled={disabled ? true : false} ><i className="fa fa-calendar"></i></span>
                                            </div>
                                            {formerror.PackageDateValidation && <p className='text-danger text-start'>{formerror.PackageDateValidation}</p>}
                                            {formerror.PackageValidateEnd && <p className='text-danger text-start'>{formerror.PackageValidateEnd}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 d-none'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">

                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" name="IsBestPackage" value={formvalue.IsBestPackage} onChange={onChange}
                                                    id="flexCheckChecked" disabled={disabled ? true : false} checked={bestpackage ? true : false} />
                                                <label className="form-check-label" htmlFor="flexCheckChecked">
                                                    Mark As Best Package
                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package cut off Days</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <div className='prefix_div'>
                                                <span className='prefix text-muted'>D-</span>
                                                <input type="text" id="PackageCutOffCount" className="form-control cutoffinput"
                                                    name="PackageCutOffCountD"
                                                    value={formvalue.PackageCutOffCountD}
                                                    onChange={onChange}
                                                    disabled={disabled ? true : false}
                                                    placeholder="Package cut off Days"
                                                />
                                            </div>
                                            {formerror.PackageCutOffCount && <p className='text-danger text-start'>{formerror.PackageCutOffCount}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-12 col-sm-12 '>
                                    <div className='row'>
                                        <div className="col-lg-2 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Highlights</label>
                                        </div>
                                        <div className="col-lg-10 mb-1 col-md-12">
                                            <textarea type='text' id="PackageHighlights" className="form-control"
                                                placeholder='Package Highlights'
                                                name="PackageHighlights"
                                                value={formvalue.PackageHighlights}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                            ></textarea>
                                            {formerror.PackageHighlights && <p className='text-danger text-start'>{formerror.PackageHighlights}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Banner</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            {/* <Select
                                                className="dropdown select_dropdown"
                                                options={bannerdatalist}
                                                value={bannerdatalist?.filter(function (bannerdatalist) {
                                                    return bannerdatalist.value === bannerId;
                                                })}// set list of the data
                                                onChange={handleBannerChange} // assign onChange function
                                                isDisabled={disabled ? true : false}
                                                isSearchable
                                            /> */}
                                            <CustomSelection
                                                selId="BannerImgPath"
                                                selRef={BannerImgPath}
                                                datalist={bannerdatalist}
                                                fieldid={bannerId}
                                                SelectionChange={handleBannerChange}
                                                isdisable={disabled || atFirstDisable}
                                                isactivedisable={bannerdisabled}
                                                issearchable={true}
                                            />
                                            {formerror.BannerImgPath && <p className='text-danger text-start'>{formerror.BannerImgPath}</p>}
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12 mx-auto">
                                            {bannerimgpath &&
                                                (
                                                    <div className="col-lg-4 col-md-6 col-6 mx-auto"  >
                                                        <img src={bannerimgpath} className="img_thumb w-100" alt='' />
                                                        <button className='closebtnimg' onClick={() => removeBannerImage()} type="button" data-close disabled={disabled ? true : false} >&times;</button>

                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Gallery</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <Select
                                                ref={GalleryCount}
                                                id="GalleryCount"
                                                className="dropdown select_dropdown"
                                                options={gallerylist}
                                                isMulti={true}
                                                value={
                                                    gallerylist?.filter(obj =>
                                                        formvalue?.PackageGallery?.some(
                                                            item => item.GalleryId === obj.value
                                                        )
                                                    ) || []
                                                }
                                                onChange={handleGalleryChange}
                                                isDisabled={disabled || atFirstDisable ? true : false}
                                                isSearchable
                                                isOptionSelected={true}
                                            // components={{ MultiValueRemove: () => null }}
                                            />
                                            {formerror.GalleryCount && <p className='text-danger text-start'>{formerror.GalleryCount}</p>}
                                        </div>
                                        <div className="col-lg-12 mb-1 col-md-12">
                                            <div className="row g-1 packageGallery_thumb">
                                                {galleryimgpath && galleryimgpath?.map((galleryimg, index) => {
                                                    return (
                                                        <div className="col-lg-3 col-md-6 col-6 mx-auto" key={index} >
                                                            <img src={galleryimg.GalleryPath} key={index} className="img_thumb w-100" alt='' />
                                                            <button className='closebtnimg' onClick={(e) => removeGalleryImage(galleryimg.GalleryId, galleryimg?.GalleryMasterImageId)} type="button" data-close disabled={disabled ? true : false} >&times;</button>
                                                        </div>
                                                    );
                                                })}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>

                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label">Active</label>
                                        </div>
                                        <div className="col-auto col-lg-8" disabled={false}>
                                            <Switch
                                                onChange={handleisActive}
                                                checked={formvalue?.IsActive}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </div>
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />

                                        {/* </div> */}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="mb-3 mt-5 row mx-1" style={{ display: isDetailblockshow ? 'block' : 'none' }}>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row">
                                <div className='col-lg-6 col-sm-6 ' >
                                    <div className='row'>
                                        <div className="col-lg-12 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Menu Master</label>
                                        </div>

                                    </div>
                                </div>
                                <div className='col-lg-12 col-12 col-md-12 '>
                                    <div className='row'>
                                        {menulist && menulist?.map((ele, index) => {
                                            return (
                                                <>
                                                    <div className="col-lg-2 col-md-3 col-6 mb-1">
                                                        <label className="col-form-label">{ele.PackageMenuUseName}</label>
                                                    </div>
                                                    <div className="col-lg-2 col-md-3 col-6 mb-1">
                                                        <input
                                                            name='menutype'
                                                            type="checkbox"
                                                            aria-label="..."
                                                            id="checkboxNoLabelm"
                                                            className="form-check-input mt-2 me-2"
                                                            checked={ele.PackageMenuId === 9 && formvalue?.IsPriceType === false ? false : ele.IsDefault ? true : false}
                                                            value={ele.PackageMenuId}
                                                            key={ele.PackageMenuId}
                                                            onChange={() => showDivHandlerD(ele.PackageMenuId)}
                                                            disabled={packageD?.state?.viewtype !== 'View' ? (ele.IsDisabled ? true : false) : true}
                                                        />
                                                    </div>
                                                </>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="accordion mb-3" id="accordionPanelsStayOpenExample">
                            {(Shown.Overview === true) && <div className="accordion-item mb-3">
                                <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                                    <button className="accordion-button collapsed border_set" id="OverviewError" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false" aria-controls="panelsStayOpen-collapseOne">
                                        Overview
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingOne">
                                    <div className="accordion-body">
                                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                                            <div className="row">
                                                <div className='col-lg-6 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-4 col-md-12 mb-1">
                                                            <label className="col-form-label required">Package Duration</label>
                                                        </div>
                                                        <div className="col-lg-8 mb-1 col-md-12">
                                                            <Select
                                                                className="dropdown select_dropdown"
                                                                options={durationlistofoverview}
                                                                value={durationlistofoverview?.filter(function (durationlistofoverview) {
                                                                    return durationlistofoverview.value === durationid;
                                                                })}// set list of the data
                                                                onChange={handledurationchange} // assign onChange function
                                                                isDisabled={disabled ? true : false}
                                                                isSearchable
                                                            />
                                                            {formerror.PackageDuration && <p className='text-danger text-start'>{formerror.PackageDuration}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-lg-12 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-12 mb-1">
                                                            <label className="col-form-label required">Best Time To Visit</label>
                                                        </div>
                                                        <div className="col-lg-1 col-md-4 mb-1">
                                                            <label className="col-form-label required">From</label>
                                                        </div>
                                                        <div className="col-lg-3 mb-1 col-md-8">
                                                            <Select
                                                                className="dropdown select_dropdown"
                                                                options={visitfromdurationlist}
                                                                value={visitfromdurationlist?.filter(function (visitfromdurationlist) {
                                                                    return visitfromdurationlist.value === visitfromdurationid;
                                                                })}// set list of the data
                                                                onChange={handledurationfromchange} // assign onChange function
                                                                isDisabled={disabled ? true : false}
                                                                isSearchable
                                                            />
                                                            {formerror.BestTimeVisitFrom && <p className='text-danger text-start'>{formerror.BestTimeVisitFrom}</p>}
                                                        </div>
                                                        <div className="col-lg-2 col-md-4 mb-1">
                                                            <label className="col-form-label required">To</label>
                                                        </div>
                                                        <div className="col-lg-3 mb-1 col-md-8">
                                                            <Select
                                                                className="dropdown select_dropdown"
                                                                options={visittodurationlist}
                                                                value={visittodurationlist?.filter(function (visittodurationlist) {
                                                                    return visittodurationlist.value === visittodurationid;
                                                                })}// set list of the data
                                                                onChange={handledurationtochange} // assign onChange function
                                                                isDisabled={disabled ? true : false}
                                                                isSearchable
                                                            />
                                                            {formerror.BestTimeToVisit && <p className='text-danger text-start'>{formerror.BestTimeToVisit}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-lg-6 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-4 col-md-12 mb-1">
                                                            <label className="col-form-label required">Package Start Point</label>
                                                        </div>
                                                        <div className="col-lg-8 mb-1 col-md-12">
                                                            {/* <Select
                                                                    className="dropdown select_dropdown"
                                                                    options={packagepointfromlist}
                                                                    value={packagepointfromlist?.filter(function (packagepointfromlist) {
                                                                        return packagepointfromlist.value === visitpointfromid;
                                                                    })}// set list of the data
                                                                    onChange={handlevisitfrompoint} // assign onChange function
                                                                    isDisabled={disabled ? true : false}
                                                                    isSearchable
                                                                /> */}
                                                            <CustomSelection
                                                                datalist={packagepointfromlist}
                                                                fieldid={visitpointfromid}
                                                                SelectionChange={handlevisitfrompoint}
                                                                isdisable={disabled}
                                                                isactivedisable={startpointdisabled}
                                                                issearchable={true}
                                                            />
                                                            {formerror.PackageStartPoint && <p className='text-danger text-start'>{formerror.PackageStartPoint}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-lg-6 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-4 col-md-12 mb-1">
                                                            <label className="col-form-label required">Package End Point</label>
                                                        </div>
                                                        <div className="col-lg-8 mb-1 col-md-12">
                                                            {/* <Select
                                                                    className="dropdown select_dropdown"
                                                                    options={packagepointtolist}
                                                                    value={packagepointtolist?.filter(function (packagepointtolist) {
                                                                        return packagepointtolist.value === visitpointtoid;
                                                                    })}// set list of the data
                                                                    onChange={handlevisittopoint} // assign onChange function
                                                                    isDisabled={disabled ? true : false}
                                                                    isSearchable
                                                                /> */}
                                                            <CustomSelection
                                                                datalist={packagepointtolist}
                                                                fieldid={visitpointtoid}
                                                                SelectionChange={handlevisittopoint}
                                                                isdisable={disabled}
                                                                isactivedisable={endpointdisabled}
                                                                issearchable={true}
                                                            />
                                                            {formerror.PackageEndPoint && <p className='text-danger text-start'>{formerror.PackageEndPoint}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-lg-6 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-4 col-md-12 mb-1">
                                                            <label className="col-form-label required">Package Theme</label>
                                                        </div>
                                                        <div className="col-lg-8 mb-1 col-md-12">

                                                            <Select
                                                                className="dropdown select_dropdown"
                                                                options={packagethemelist}
                                                                value={packagethemelist?.filter(function (packagethemelist) {
                                                                    return packagethemelist.value === themebyid;
                                                                })}// set list of the data
                                                                // value={packagethemelist.filter(obj => themebyid.includes(obj.value))}
                                                                onChange={handlethemebychange} // assign onChange function
                                                                isDisabled={disabled ? true : false}
                                                                isSearchable
                                                            />

                                                            {formerror.ThemeList && <p className='text-danger text-start'>{formerror.ThemeList}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-1 col-md-12">
                                                    <div className="row g-1">
                                                        {themeimgpath && themeimgpath?.map((themeimg, index) => {
                                                            if (themebycounter > 0) {
                                                                return (
                                                                    <div className="col-lg-2 col-md-3 col-6 mx-auto" key={index} >
                                                                        <img src={themeimg.ThemePath} key={index} className="img_thumb w-100" alt='' />
                                                                        <button className='closebtnimg' onClick={(e) => removeThmeImage(themeimg.Id, e)} type="button" data-close disabled={disabled ? true : false} >&times;</button>

                                                                    </div>
                                                                );
                                                            }
                                                        })}

                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                                <div className='col-lg-12 mb-1 col-md-12'>
                                                    <div className="form_border row mt-4">
                                                        {formerror.overviewCityDetail && <p className='mt-2 text-danger text-center'>{formerror.overviewCityDetail}</p>}
                                                        {overviewCityLengthError && <p className='mt-2 text-danger text-center'>{overviewCityLengthError}</p>}
                                                        {formerror.totalNightsPending && <p className="mt-2 text-center text-danger"> {formerror.totalNightsPending} </p>}
                                                        {overviewCityNightError && <p className="mt-2 text-center text-danger"> {overviewCityNightError} </p>}
                                                        <div className='col-lg-12 col-sm-12 mt-3'>
                                                            <div className='row'>
                                                                <div className='col-lg-6 col-sm-6'>
                                                                    <div className='row'>
                                                                        <div className="col-lg-4 col-md-12 mb-1">
                                                                            <label className="col-form-label required">City</label>
                                                                        </div>
                                                                        <div className="col-lg-8 mb-1 col-md-12">
                                                                            {/* <Select
                                                                                className="dropdown select_dropdown"
                                                                                options={overviewCityList}
                                                                                value={overviewCityList?.filter(function (overviewCity) {
                                                                                    return overviewCity.value === overviewCityid;
                                                                                })}
                                                                                onChange={handlecityDatachange}
                                                                                isDisabled={disabled}
                                                                                isSearchable
                                                                            /> */}
                                                                            <CustomSelection
                                                                                datalist={overviewCityList}
                                                                                fieldid={overviewCityid}
                                                                                SelectionChange={handlecityDatachange}
                                                                                isdisable={disabled}
                                                                                isactivedisable={citydisable}
                                                                                issearchable={true}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-lg-6 col-sm-6'>
                                                                    <div className='row'>
                                                                        <div className="col-lg-4 col-md-12 mb-1">
                                                                            <label className="col-form-label required">Night</label>
                                                                        </div>
                                                                        <div className="col-lg-8 mb-1 col-md-12">
                                                                            <Select
                                                                                className="dropdown select_dropdown"
                                                                                options={nightlist}
                                                                                value={nightlist?.filter(function (night) {
                                                                                    return night.value === nightid;
                                                                                })}
                                                                                onChange={handleNightChange}
                                                                                isDisabled={disabled}
                                                                                isSearchable
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex justify-content-center mt-3 bg-body">
                                                                    <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleOverviewAdd} disabled={disabled}> {overviewbtntext} </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <div className="mb-3 row py-3">
                                                                    <div className="col-lg-12 mb-1">
                                                                        <div className="row">
                                                                            <div className="col-lg-12 mb-1 table-scrollable">
                                                                                <table id="data" className="table table-hover" >
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th>City
                                                                                            </th>
                                                                                            <th className='text-center'>Night
                                                                                            </th>
                                                                                            <th className='text-end pe-4'>Edit
                                                                                            </th>
                                                                                            <th className='text-end pe-4'>Remove
                                                                                            </th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody id="location-data">
                                                                                        {overviewCityDetails?.map((element, index) => {

                                                                                            return (
                                                                                                <tr className="ReactTable" key={index}>
                                                                                                    <td>{element.city}</td>
                                                                                                    <td className='text-center'>{element.night}</td>
                                                                                                    <td className='text-end'><button type="button" onClick={(e) => { handleEditOverviewCity(element.packageOverviewCityId, e) }} className="btn btn-primary mx-1" id="btnEdit" disabled={disabled}>Edit</button></td>
                                                                                                    <td className='text-end'><button type="button" onClick={(e) => { removeverviewCity(element.packageOverviewCityId, e) }} className="btn btn-primary mx-1" id="btnAdd" disabled={disabled}>Remove</button></td>
                                                                                                </tr>
                                                                                            );

                                                                                        })}
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {(Shown.Itinerary === true) && <div className="accordion-item mb-3">
                                <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                                    <button className="accordion-button collapsed" type="button" id="ItineraryError" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                                        Day Schedule
                                    </button>
                                </h2>

                                <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                                    <div className="accordion-body">
                                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                                            <div className="row">
                                                {formerror.ItineraryError && <p className='text-danger text-center'>{formerror.ItineraryError}</p>}
                                                <div className='col-lg-12 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-12 mb-1">
                                                            <label className="col-form-label required">Sightseeing Name</label>
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-12">
                                                            <Select
                                                                name='DaySightseeingId'
                                                                inputId='DaySightseeingId'
                                                                className="dropdown select_dropdown"
                                                                options={sightseeinglistdata}
                                                                value={sightseeinglistdata?.filter(list => list?.value === formvalue?.DaySightseeingId)}
                                                                onChange={handleDaysightseeing}
                                                                isDisabled={disabled ? true : false}
                                                                isSearchable
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-lg-12 col-sm-12 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-12 mb-1">
                                                            <label className="col-form-label required">Enter Day</label>
                                                        </div>
                                                        <div className="col-lg-10 mb-1 col-md-12">
                                                            <textarea type="text"
                                                                id="inputPassword6"
                                                                className="form-control"
                                                                name="Day"
                                                                value={formvalue.Day}
                                                                onChange={onChange}
                                                                disabled={disabled ? true : false || formvalue?.DaySightseeingId <= 0}
                                                                placeholder="Enter Day"
                                                            />
                                                            {formerror.ItineraryDayError && <p className='text-danger text-start'>{formerror.ItineraryDayError}</p>}
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className='col-lg-12 col-sm-12 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-3 mb-1">
                                                            <label className="col-form-label required">Day Schedule</label>
                                                        </div>
                                                        <div className="col-lg-10 mb-1 col-md-9 dayschedule">
                                                            <RichTextBox
                                                                field="DaySchedule_1"
                                                                fieldvalue={formvalue.DaySchedule}
                                                                tabIndex={1}
                                                                OnChangeofRichBox={(value) => { formvalue.DaySchedule = value; }}
                                                                setRef={setEditorRef}
                                                                textconfig={dayscheduleconfig}
                                                            />
                                                            {formerror.ItineraryDayScheduleError && <p className='text-danger text-start'>{formerror.ItineraryDayScheduleError}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-lg-12 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-12 mb-1">
                                                            <label className="col-form-label">Add Inclusion</label>
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-12">
                                                            <Select
                                                                className="dropdown select_dropdown"
                                                                options={inclusionwithshortnamelist}
                                                                value={inclusionwithshortnamelist?.filter(list => formvalue?.InclusionId?.includes(list?.value))}
                                                                onChange={handleinclusionnamechange}
                                                                isDisabled={disabled ? true : false}
                                                                isSearchable
                                                                isMulti
                                                                hideSelectedOptions={false}
                                                                closeMenuOnSelect={false}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-lg-12 col-sm-12 '>
                                                    <div className={`${flightvisible ? '' : 'd-none'} row`} >
                                                        <div className="col-lg-2 col-md-12 mb-1">
                                                            <label className="col-form-label">Add Flight</label>
                                                        </div>
                                                        <div className="col-lg-1 col-md-2 mb-1">
                                                            <label className="col-form-label">From</label>
                                                        </div>
                                                        <div className="col-lg-3 mb-1 col-md-4">
                                                            {/* <Select
                                                                    className="dropdown select_dropdown"
                                                                    options={flightfrom}
                                                                    value={flightfrom?.filter(function (flightfrom) {
                                                                        return flightfrom.value === flightfromid;
                                                                    })}// set list of the data
                                                                    onChange={handleFlightFromchange} // assign onChange function
                                                                    isDisabled={disabled ? true : false}
                                                                    //isDisabled={flightdisable ? true : false}
                                                                    isSearchable
                                                                /> */}
                                                            <CustomSelection
                                                                datalist={flightfrom}
                                                                fieldid={flightfromid}
                                                                SelectionChange={handleFlightFromchange}
                                                                isdisable={disabled || !formvalue?.InclusionId?.includes(2)}
                                                                isactivedisable={fromflightdisable}
                                                                issearchable={true}
                                                            />
                                                        </div>
                                                        <div className="col-lg-1 col-md-2 mb-1">
                                                            <label className="col-form-label">To</label>
                                                        </div>
                                                        <div className="col-lg-3 mb-1 col-md-4">
                                                            {/* <Select
                                                                    className="dropdown select_dropdown"
                                                                    options={flightto}
                                                                    value={flightto?.filter(function (flightto) {
                                                                        return flightto.value === flighttoid;
                                                                    })}// set list of the data
                                                                    onChange={handleFlightToChange} // assign onChange function
                                                                    isDisabled={disabled ? true : false}
                                                                    //isDisabled={flightdisable ? true : false}
                                                                    isSearchable
                                                                /> */}

                                                            <CustomSelection
                                                                datalist={flightto}
                                                                fieldid={flighttoid}
                                                                SelectionChange={handleFlightToChange}
                                                                isdisable={disabled || !formvalue?.InclusionId?.includes(2)}
                                                                isactivedisable={toflightdisable}
                                                                issearchable={true}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2 mb-1 col-md-12">
                                                            <button disabled={!formvalue?.InclusionId?.includes(2)} type="button" className="btn btn-primary mx-1" onClick={handleFlight} id="btnAdd"><i className={`fa fa-plus ${flightbuttontext ? "fa-minus" : "fa-plus"}`} aria-hidden="true"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2 ${flightopen ? 'd-block' : 'd-none'} ${flightvisible ? '' : 'd-none'}`}>
                                                    <div className='row'>
                                                        <div className="col-lg-12 col-md-12 mb-1">
                                                            <label className="col-form-label ">Flight Details</label>
                                                        </div>
                                                        <div className='col-lg-12 col-sm-12 '>
                                                            <div className='row'>
                                                                <div className="col-lg-1 col-md-2 mb-1">
                                                                    <label className="col-form-label ">From</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-3">
                                                                    <Select
                                                                        className="dropdown select_dropdown"
                                                                        options={flightfrom}
                                                                        value={flightfrom?.filter(function (flightfrom) {
                                                                            return flightfrom.value === flightfromid;
                                                                        })}
                                                                        // onChange={handlesupplierchange} // assign onChange function
                                                                        isDisabled
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                                <div className="col-lg-1 col-md-2 mb-1">
                                                                    <label className="col-form-label ">To</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-3">
                                                                    <Select
                                                                        className="dropdown select_dropdown"
                                                                        options={flightto}
                                                                        value={flightto?.filter(function (flightto) {
                                                                            return flightto.value === flighttoid;
                                                                        })}// set list of the data
                                                                        // onChange={handlesupplierchange} // assign onChange function
                                                                        isDisabled
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                                <div className="col-lg-1 col-md-3 mb-1">
                                                                    <label className="col-form-label ">Duration</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-6">
                                                                    <input type="text" id="inputPassword6" className="form-control"
                                                                        name="Duration"
                                                                        value={formvalue.Duration}
                                                                        onChange={onChange}
                                                                        disabled
                                                                        placeholder="Duration"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label className="col-form-label "> Select Airline Name</label>
                                                                </div>
                                                                <div className="col-lg-8 mb-1 col-md-12">
                                                                    <Select
                                                                        className="dropdown select_dropdown"
                                                                        options={airlinelist}
                                                                        value={airlinelist?.filter(function (airlinelist) {
                                                                            return airlinelist.value === airlineid;
                                                                        })}// set list of the data
                                                                        onChange={handleAirlineChange} // assign onChange function
                                                                        isDisabled={disabled ? true : false}
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label className="col-form-label ">Flight No</label>
                                                                </div>
                                                                <div className="col-lg-8 mb-1 col-md-12">
                                                                    <Select
                                                                        className="dropdown select_dropdown"
                                                                        options={flightnolist}
                                                                        value={flightnolist?.filter(function (flightnolist) {
                                                                            return flightnolist.value === flightno;
                                                                        })}// set list of the data
                                                                        onChange={handleFlightNoChange} // assign onChange function
                                                                        isDisabled={disabled ? true : false}
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label className="col-form-label ">Arrival Time</label>
                                                                </div>
                                                                <div className="col-lg-8 mb-1 col-md-12">
                                                                    <CustomTimePicker classid="ArrivalTimeD" filedvalue={arrivalTime} isDisable={true} handleOnChange={(e) => handleonchangeofTime("ArrivalTimeD", e)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label className="col-form-label ">Departure Time</label>
                                                                </div>
                                                                <div className="col-lg-8 mb-1 col-md-12">
                                                                    <CustomTimePicker classid="DepartureTimeD" filedvalue={departureTime} isDisable={true} handleOnChange={(e) => handleonchangeofTime("DepartureTimeD", e)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label className="col-form-label ">Select Class</label>
                                                                </div>
                                                                <div className="col-lg-8 mb-1 col-md-12">
                                                                    <Select
                                                                        className="dropdown select_dropdown"
                                                                        options={airlineclasslist}
                                                                        value={airlineclasslist?.filter(function (airlineclasslist) {
                                                                            return airlineclasslist.value === classid;
                                                                        })}// set list of the data
                                                                        onChange={handleclasschange} // assign onChange function
                                                                        isDisabled={disabled ? true : false}
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label className="col-form-label ">Select Supplier</label>
                                                                </div>
                                                                <div className="col-lg-8 mb-1 col-md-12">
                                                                    <Select
                                                                        className="dropdown select_dropdown"
                                                                        options={supplierlist}
                                                                        value={supplierlist?.filter(function (supplierlist) {
                                                                            return supplierlist.value === supplierid;
                                                                        })}// set list of the data
                                                                        onChange={handlesupplierchange} // assign onChange function
                                                                        isDisabled={disabled ? true : false}
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label className="col-form-label ">Price</label>
                                                                </div>
                                                                <div className="col-lg-8 mb-1 col-md-12">
                                                                    <input type="text" id="inputPassword6" className="form-control"
                                                                        name="FlightPrice"
                                                                        value={formvalue.FlightPrice}
                                                                        onChange={onChange}
                                                                        disabled={disabled ? true : false}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-lg-12 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-12 mb-1">
                                                            <label className={`col-form-label ${EnableTransferSightseeingInclusionIds?.some((ele) => formvalue?.InclusionId?.includes(ele)) && 'required'} `}>Add Transfers</label>
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-12">

                                                            <CustomSelection
                                                                datalist={transfersightseeinglistdata}
                                                                fieldid={transferSightseeingDetail?.TransferSightseeingId}
                                                                SelectionChange={(e) => handletransfersightseeingchange(e, 'Transfers')}
                                                                isdisable={disabled || !EnableTransferSightseeingInclusionIds?.some((ele) => formvalue?.InclusionId?.includes(ele))}
                                                                isactivedisable={transferSightseeingdisable}
                                                                issearchable={true}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2 mb-1 col-md-12">
                                                            <button disabled={!EnableTransferSightseeingInclusionIds?.some((ele) => formvalue?.InclusionId?.includes(ele))} type="button" className="btn btn-primary mx-1" onClick={(e) => handleTransferSightseeing("Transfers")}><i className={`fa fa-plus ${transferSightseeingbuttontext ? "fa-minus" : "fa-plus"}`} aria-hidden="true"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2 ${transferSightseeingopen ? 'd-block' : 'd-none'}`}>
                                                    <div className='row'>
                                                        <div className="col-lg-12 col-md-12 mb-1">
                                                            <label className="col-form-label ">{transferSightseeingDetail?.TransferSightseeingName}</label>
                                                        </div>
                                                        <div className='col-lg-12 col-sm-12 '>
                                                            <div className='row'>
                                                                <div className="col-lg-1 col-md-2 mb-1">
                                                                    <label className="col-form-label ">Pick Up Point</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-3">
                                                                    <input type="text" id="TransferSightseeingPickupPoint" className="form-control"
                                                                        name="TransferSightseeingPickupPoint"
                                                                        disabled
                                                                        value={transferSightseeingDetail?.TransferSightseeingPickupPoint}
                                                                        placeholder='PickUpPoint'
                                                                        onChange={() => { }}
                                                                    />
                                                                    {/* <Select
                                                                            className="dropdown select_dropdown"
                                                                            //options={dightseeinglistdata}
                                                                            // value={suppliernamelist.filter(function (suppliernamelist) {
                                                                            // return suppliernamelist.value === supplierid;
                                                                            // })}// set list of the data
                                                                            // onChange={handlesupplierchange} // assign onChange function
                                                                            isDisabled={true}
                                                                            isSearchable={false}
                                                                        /> */}
                                                                    {/* {formErrors.Supplierid && <p className='text-danger text-start'>{formErrors.Supplierid}</p>} */}
                                                                </div>
                                                                <div className="col-lg-1 col-md-2 mb-1">
                                                                    <label className="col-form-label ">Drop Point</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-3">
                                                                    <input type="text" id="TransferSightseeingDropPoint" className="form-control"
                                                                        name="TransferSightseeingDropPoint"
                                                                        disabled
                                                                        value={transferSightseeingDetail?.TransferSightseeingDropPoint}
                                                                        placeholder="DropPoint"
                                                                        onChange={() => { }}
                                                                    />
                                                                </div>
                                                                <div className="col-lg-1 col-md-3 mb-1">
                                                                    <label className="col-form-label ">Duration</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-6">
                                                                    <TimePicker
                                                                        id='TransferSightseeingDuration'
                                                                        className='form-control defo_border'
                                                                        disabled={true}
                                                                        placeholder='--'
                                                                        format='HH'
                                                                        value={transferSightseeingDetail?.TransferSightseeingDuration}
                                                                        needConfirm={false}
                                                                        showNow={false}
                                                                        onChange={() => { }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-12 col-sm-12 '>
                                                            <div className='row'>
                                                                <div className="col-lg-2 col-md-12 mb-1">
                                                                    <label className="col-form-label">Itinerary Details</label>
                                                                </div>
                                                                <div className="col-lg-10 mb-1 col-md-12">
                                                                    <textarea type='text' id="TransferSightseeingItineraryDetails" className="form-control"
                                                                        name="TransferSightseeingItineraryDetails"
                                                                        value={transferSightseeingDetail?.TransferSightseeingItineraryDetails}
                                                                        disabled
                                                                        onChange={() => { }}
                                                                    ></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-lg-12 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-12 mb-1">
                                                            <label className={`col-form-label ${EnableAirportSightseeingInclusionIds?.some((ele) => formvalue?.InclusionId?.includes(ele)) && 'required'} `}>Add Airport Transfers</label>
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-12">

                                                            <CustomSelection
                                                                datalist={airportSightseeinglistdata}
                                                                fieldid={airportSightseeingDetail?.AirportSightseeingId}
                                                                SelectionChange={(e) => handletransfersightseeingchange(e, 'AirportTransfer')}
                                                                isdisable={disabled || !EnableAirportSightseeingInclusionIds?.some((ele) => formvalue?.InclusionId?.includes(ele))}
                                                                isactivedisable={airportSightseeingdisable}
                                                                issearchable={true}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2 mb-1 col-md-12">
                                                            <button disabled={!EnableAirportSightseeingInclusionIds?.some((ele) => formvalue?.InclusionId?.includes(ele))} type="button" className="btn btn-primary mx-1" onClick={(e) => handleTransferSightseeing("AirportTransfer")}><i className={`fa fa-plus ${airportSightseeingbuttontext ? "fa-minus" : "fa-plus"}`} aria-hidden="true"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2 ${airportSightseeingopen ? 'd-block' : 'd-none'}`}>
                                                    <div className='row'>
                                                        <div className="col-lg-12 col-md-12 mb-1">
                                                            <label className="col-form-label ">{airportSightseeingDetail?.AirportSightseeingName}</label>
                                                        </div>
                                                        <div className='col-lg-12 col-sm-12 '>
                                                            <div className='row'>
                                                                <div className="col-lg-1 col-md-2 mb-1">
                                                                    <label className="col-form-label ">Pick Up Point</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-3">
                                                                    <input type="text" id="AirportSightseeingPickupPoint" className="form-control"
                                                                        name="AirportSightseeingPickupPoint"
                                                                        disabled
                                                                        value={airportSightseeingDetail?.AirportSightseeingPickupPoint}
                                                                        placeholder='PickUpPoint'
                                                                        onChange={() => { }}
                                                                    />
                                                                    {/* <Select
                                                                            className="dropdown select_dropdown"
                                                                            //options={dightseeinglistdata}
                                                                            // value={suppliernamelist.filter(function (suppliernamelist) {
                                                                            // return suppliernamelist.value === supplierid;
                                                                            // })}// set list of the data
                                                                            // onChange={handlesupplierchange} // assign onChange function
                                                                            isDisabled={true}
                                                                            isSearchable={false}
                                                                        /> */}
                                                                    {/* {formErrors.Supplierid && <p className='text-danger text-start'>{formErrors.Supplierid}</p>} */}
                                                                </div>
                                                                <div className="col-lg-1 col-md-2 mb-1">
                                                                    <label className="col-form-label ">Drop Point</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-3">
                                                                    <input type="text" id="AirportSightseeingDropPoint" className="form-control"
                                                                        name="AirportSightseeingDropPoint"
                                                                        disabled
                                                                        value={airportSightseeingDetail?.AirportSightseeingDropPoint}
                                                                        placeholder="DropPoint"
                                                                        onChange={() => { }}
                                                                    />
                                                                </div>
                                                                <div className="col-lg-1 col-md-3 mb-1">
                                                                    <label className="col-form-label ">Duration</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-6">
                                                                    <TimePicker
                                                                        id='AirportSightseeingDuration'
                                                                        className='form-control defo_border'
                                                                        disabled={true}
                                                                        placeholder='--'
                                                                        format='HH'
                                                                        value={airportSightseeingDetail?.AirportSightseeingDuration}
                                                                        needConfirm={false}
                                                                        showNow={false}
                                                                        onChange={() => { }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-12 col-sm-12 '>
                                                            <div className='row'>
                                                                <div className="col-lg-2 col-md-12 mb-1">
                                                                    <label className="col-form-label">Itinerary Details</label>
                                                                </div>
                                                                <div className="col-lg-10 mb-1 col-md-12">
                                                                    <textarea type='text' id="AirportSightseeingItineraryDetails" className="form-control"
                                                                        name="AirportSightseeingItineraryDetails"
                                                                        value={airportSightseeingDetail?.AirportSightseeingItineraryDetails}
                                                                        disabled
                                                                        onChange={() => { }}
                                                                    ></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-lg-12 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-12 mb-1">
                                                            <label className={`col-form-label ${formvalue?.InclusionId?.includes(1) ? 'required' : ''}`}>
                                                                Add Hotels <br /> Or Similar Hotels
                                                            </label>
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-12">
                                                            <CustomSelection
                                                                datalist={hotelList}
                                                                fieldid={hotelnameid}
                                                                SelectionChange={handlehotelnamechange}
                                                                isdisable={disabled || !formvalue?.InclusionId?.includes(1)}
                                                                isactivedisable={hoteldisable}
                                                                issearchable={true}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2 mb-1 col-md-12">
                                                            <button disabled={!formvalue?.InclusionId?.includes(1)} type="button" className="btn btn-primary mx-1" onClick={() => handleHotel()} id="btnAdd"><i className={`fa fa-plus ${hotelbuttontext ? "fa-minus" : "fa-plus"}`} aria-hidden="true"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2 ${hotelbuttontext ? 'd-block' : 'd-none'}`}>
                                                    <div className='row'>
                                                        <div className="col-lg-12 col-md-12 mb-1">
                                                            <label className="col-form-label ">{hotelname}
                                                                <Rating
                                                                    readonly
                                                                    size={20}
                                                                    allowFraction
                                                                    className='ms-2'
                                                                    initialValue={hotelrating}
                                                                />
                                                            </label>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label className="col-form-label required">Select Room Type</label>
                                                                </div>
                                                                <div className="col-lg-8 mb-1 col-md-12">
                                                                    <Select
                                                                        className="dropdown select_dropdown"
                                                                        options={roomtypelist}
                                                                        value={roomtypelist?.filter(function (roomtypelist) {
                                                                            return roomtypelist.value === hotelroomtypeid
                                                                        })}
                                                                        onChange={handleRoomTypeChange} // assign onChange function
                                                                        isDisabled={disabled ? true : false}
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label className="col-form-label">No Of Pax</label>
                                                                </div>
                                                                <div className="col-lg-8 mb-1 col-md-12">
                                                                    <Select
                                                                        className="dropdown select_dropdown"
                                                                        options={[{ label: 2, value: 2 }]} // should be an array
                                                                        value={{ label: 2, value: 2 }}
                                                                        isDisabled={disabled ? true : false}
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label className="col-form-label required">Meal Type</label>
                                                                </div>
                                                                <div className="col-lg-8 mb-1 col-md-12">
                                                                    <Select
                                                                        className="dropdown select_dropdown"
                                                                        options={roomMealList}
                                                                        value={roomMealList?.filter(function (mealType) {
                                                                            return mealType.value === mealTypeId;
                                                                        })}// set list of the data
                                                                        onChange={(val) => handleMealType(val)} // assign onChange function
                                                                        isDisabled={disabled ? true : false}
                                                                        isSearchable
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {formvalue?.IsPriceType === true && (
                                                            <div className='col-lg-6 col-sm-6'>
                                                                <div className='row'>
                                                                    <div className="col-lg-4 col-md-12 mb-1">
                                                                        <label className="col-form-label ">Price</label>
                                                                    </div>
                                                                    <div className="col-lg-8 mb-1 col-md-12">
                                                                        <input type="text" id="inputPassword6" className="form-control"
                                                                            name="RoomPriceD"
                                                                            disabled
                                                                            value={formvalue.HotelPrice}
                                                                            onChange={onChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className='col-lg-12 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-12 mb-1">
                                                            <label className="col-form-label">Add Sightseeing</label>
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-12">

                                                            <CustomSelection
                                                                datalist={sightseeinglistdata}
                                                                fieldid={sightseeingid}
                                                                SelectionChange={handlesightseeingchange}
                                                                isdisable={disabled || !EnableSightseeingInclusionIds?.some((ele) => formvalue?.InclusionId?.includes(ele))}
                                                                isactivedisable={sightseeingdisable}
                                                                issearchable={true}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2 mb-1 col-md-12">
                                                            <button disabled={!EnableSightseeingInclusionIds?.some((ele) => formvalue?.InclusionId?.includes(ele))} type="button" className="btn btn-primary mx-1" onClick={handleSightseeing} id="btnAdd"><i className={`fa fa-plus ${sightseeingbuttontext ? "fa-minus" : "fa-plus"}`} aria-hidden="true"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2 ${sightseeingopen ? 'd-block' : 'd-none'}`}>
                                                    <div className='row'>
                                                        <div className="col-lg-12 col-md-12 mb-1">
                                                            <label className="col-form-label ">{sightseeingname}</label>
                                                        </div>
                                                        <div className='col-lg-12 col-sm-12 '>
                                                            <div className='row'>
                                                                <div className="col-lg-1 col-md-2 mb-1">
                                                                    <label className="col-form-label ">Pick Up Point</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-3">
                                                                    <input type="text" id="inputPassword6" className="form-control"
                                                                        name="PickupPoint"
                                                                        disabled
                                                                        value={formvalue.PickUpPoint}
                                                                        placeholder='PickUpPoint'
                                                                    />
                                                                    {/* <Select
                                                                            className="dropdown select_dropdown"
                                                                            //options={dightseeinglistdata}
                                                                            // value={suppliernamelist.filter(function (suppliernamelist) {
                                                                            // return suppliernamelist.value === supplierid;
                                                                            // })}// set list of the data
                                                                            // onChange={handlesupplierchange} // assign onChange function
                                                                            isDisabled={true}
                                                                            isSearchable={false}
                                                                        /> */}
                                                                    {/* {formErrors.Supplierid && <p className='text-danger text-start'>{formErrors.Supplierid}</p>} */}
                                                                </div>
                                                                <div className="col-lg-1 col-md-2 mb-1">
                                                                    <label className="col-form-label ">Drop Point</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-3">
                                                                    <input type="text" id="inputPassword6" className="form-control"
                                                                        name="DropPoint"
                                                                        disabled
                                                                        value={formvalue.DropPoint}
                                                                        placeholder="DropPoint"
                                                                    />
                                                                </div>
                                                                <div className="col-lg-1 col-md-3 mb-1">
                                                                    <label className="col-form-label ">Duration</label>
                                                                </div>
                                                                <div className="col-lg-3 mb-1 col-md-6">
                                                                    <TimePicker
                                                                        id='Hours'
                                                                        className='form-control defo_border'
                                                                        disabled={true}
                                                                        placeholder='--'
                                                                        format='HH'
                                                                        value={hoursTime}
                                                                        needConfirm={false}
                                                                        showNow={false}

                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-12 col-sm-12 '>
                                                            <div className='row'>
                                                                <div className="col-lg-2 col-md-12 mb-1">
                                                                    <label className="col-form-label">Itinerary Details</label>
                                                                </div>
                                                                <div className="col-lg-10 mb-1 col-md-12">
                                                                    <textarea type='text' id="inputPassword6" className="form-control"
                                                                        name="ItineraryDetails"
                                                                        value={formvalue.ItineraryDetails}
                                                                        disabled
                                                                    ></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-12 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-2 col-md-12 mb-1">
                                                                    <label className="col-form-label">Select Vehicle</label>
                                                                </div>
                                                                <div className="col-lg-4 mb-1 col-md-12">
                                                                    <Select
                                                                        className="dropdown select_dropdown"
                                                                        options={vehicalistdata}
                                                                        value={vehicalistdata?.filter(function (vehicalistdata) {
                                                                            return vehicalistdata.value === vehicaltypeid;
                                                                        })}// set list of the data
                                                                        onChange={handlevehicaltype} // assign onChange function
                                                                        isDisabled={disabled ? true : false}
                                                                        isSearchable

                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label htmlFor="inputPassword7" className="col-form-label ">Price</label>
                                                                </div>
                                                                <div className="col-lg-8 mb-1 col-md-12">
                                                                    <input type="text" id="inputPassword7" className="form-control"
                                                                        name="VehicalPrice"
                                                                        disabled
                                                                        value={vehicalprice}
                                                                        placeholder="Vehicle Price"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-lg-12 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-12 mb-1">
                                                            <label className="col-form-label">Add Vehicle</label>
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-12">

                                                            <CustomSelection
                                                                datalist={vehicleTransferCategoryAndListData?.vehicleCategoryList}
                                                                fieldid={vehicleTransferId}
                                                                SelectionChange={(e) => handleVehicleTransferSelectChange('vehicleTransferId', e)}
                                                                isdisable={disabled || !formvalue?.InclusionId?.includes(5)}
                                                                isactivedisable={vehicleTransferDisabled}
                                                                issearchable={true}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2 mb-1 col-md-12">
                                                            <button disabled={!formvalue?.InclusionId?.includes(5)} type="button" className="btn btn-primary mx-1" onClick={handleVehicle}><i className={`fa fa-plus ${vehicleTransferButtonText ? "fa-minus" : "fa-plus"}`} aria-hidden="true"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2 ${vehicleTransferOpen ? 'd-block' : 'd-none'}`}>
                                                    <div className='row'>
                                                        <div className='col-lg-12 col-sm-12 '>
                                                            <div className='row'>
                                                                <div className="col-lg-2 col-md-2 mb-1">
                                                                    <label htmlFor='VehicleDetailId' className="col-form-label">Vehicle Name</label>
                                                                </div>
                                                                <div className="col-lg-4 mb-1 col-md-3">
                                                                    <CustomSelection
                                                                        inputId="VehicleDetailId"
                                                                        datalist={vehicleTransferCategoryAndListData?.vehicleList?.filter((fil) => fil?.VehicleCategoryId === vehicleTransferId)}
                                                                        fieldid={selectedVehicleTransferDetail?.VehicleDetailId}
                                                                        SelectionChange={(e) => handleVehicleTransferSelectChange('VehicleDetailId', e)}
                                                                        isdisable={disabled || vehicleTransferDisabled}
                                                                        isactivedisable={vehicleTransferNameDisabled}
                                                                        issearchable={true}
                                                                    />
                                                                    {formerror?.VehicleDetailId && <p className='text-danger text-start'>{formerror?.VehicleDetailId}</p>}
                                                                </div>
                                                                <div className="col-lg-2 col-md-3 mb-1">
                                                                    <label htmlFor='VehicleTypeTransfer' className="col-form-label" >Vehicle Type</label>
                                                                </div>
                                                                <div className="col-lg-4 mb-1 col-md-6">
                                                                    <input type="text" id="VehicleTypeTransfer" className="form-control"
                                                                        name="VehicleType"
                                                                        value={selectedVehicleTransferDetail?.VehicleType}
                                                                        onChange={(e) => handleVehicleTransferSelectChange('VehicleType', e)}
                                                                        placeholder="Vehicle Type"
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div className="col-lg-2 col-md-2 mb-1">
                                                                    <label htmlFor='SeatingCapacityTransfer' className="col-form-label">Seating Capacity</label>
                                                                </div>
                                                                <div className="col-lg-4 mb-1 col-md-3">
                                                                    <input type="text" id="SeatingCapacityTransfer" className="form-control"
                                                                        name="SeatingCapacity"
                                                                        value={selectedVehicleTransferDetail?.SeatingCapacity}
                                                                        onChange={(e) => handleVehicleTransferSelectChange('SeatingCapacity', e)}
                                                                        placeholder="Seating Capacity"
                                                                        disabled
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-lg-12 col-sm-6 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-12 mb-1">
                                                            <label className="col-form-label">Add Attraction</label>
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-12">
                                                            <Select
                                                                className="dropdown select_dropdown"
                                                                options={attractionList}
                                                                value={attractionList?.filter(list => formvalue.AttractionBasicId?.includes(list?.value))}// set list of the data
                                                                onChange={(e) => handleSelectAttraction(e)} // assign onChange function
                                                                isDisabled={disabled ? true : false}
                                                                isSearchable
                                                                isMulti
                                                                components={{
                                                                    Option: InputOption
                                                                }}
                                                                hideSelectedOptions={false}
                                                                closeMenuOnSelect={false}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2 mb-1 col-md-12">
                                                            <button type="button" className="btn btn-primary mx-1"
                                                                onClick={() => setAttractionDetailShow(!attractionDetailShow)} >
                                                                <i className={`fa fa-plus ${attractionDetailShow ? "fa-minus" : "fa-plus"}`} aria-hidden="true" ></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    attractionDetailShow &&
                                                    <div className={`col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2`}>
                                                        <div className="row">
                                                            <div className="col-lg-12 mb-1 table-scrollable">
                                                                <table className="table table-hover" >
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Attraction Name</th>
                                                                            <th>Attraction Type</th>
                                                                            <th>Attraction Category</th>
                                                                            <th>Attraction Theme</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            attractionDetail?.map((item) => {
                                                                                return (
                                                                                    <tr key={item?.value}>
                                                                                        <td>{item?.label} </td>
                                                                                        <td>{item?.type}</td>
                                                                                        <td>{item?.category}</td>
                                                                                        <td>{item?.theme}</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                <div className="d-flex justify-content-center mt-3 bg-body">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary mx-1"
                                                        id="btnAdd"
                                                        disabled={disabled ? true : false}
                                                        onClick={handleitinerary}>
                                                        {itinerarybtntext}
                                                    </button>
                                                    <button type="button" className="btn btn-primary mx-1" id="btnClear" disabled={disabled ? true : false}
                                                        onClick={handleclearItinerary}
                                                    >Clear</button>
                                                </div>
                                                <div className='col-12'>
                                                    <div className="my-3 row form_border py-3">
                                                        <div className="col-lg-12 mb-1 table-scrollable">
                                                            <table id="data" className="table table-hover" >
                                                                <thead>
                                                                    <tr>
                                                                        <th>Day
                                                                        </th>
                                                                        <th className='text-end pe-4'>Edit
                                                                        </th>
                                                                        <th className='text-end pe-4'>Remove
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody id="location-data">
                                                                    {dataitinerary?.map((element, index) => {
                                                                        if (dataitinerarycounter > 0) {
                                                                            return (
                                                                                <tr className="ReactTable" key={index}>
                                                                                    <td>{element.Day}</td>
                                                                                    <td className='text-end'><button type="button" onClick={(e) => { handleEditItinerary(element.SeqNo, e) }} className="btn btn-primary mx-1" id="btnEdit" disabled={disabled ? true : false}>Edit</button></td>
                                                                                    <td className='text-end'><button type="button" onClick={(e) => { removeitinerary(element.SeqNo, e) }} className="btn btn-primary mx-1" id="btnAdd" disabled={disabled ? true : false}>Remove</button></td>
                                                                                </tr>
                                                                            );
                                                                        }
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {(Shown.Inclusion === true) && <div className="accordion-item mb-3">
                                <h2 className="accordion-header" id="panelsStayOpen-headingThree">
                                    <button className="accordion-button collapsed" type="button" id="InclusionError" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                                        Inclusion
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                                    <div className="accordion-body">
                                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                                            <div className="row">
                                                <div className='col-lg-12 col-sm-12 '>
                                                    <div className='row'>
                                                        {inclusionduplicateerror && <p className='text-center text-danger'>{inclusionduplicateerror}</p>}
                                                        {formerror.InclusionError && <p className='text-center text-danger'>{formerror.InclusionError}</p>}
                                                        <div className="col-lg-2 col-md-3 mb-1"><label className="col-form-label required">Add Inclusion</label></div>
                                                        <div className="col-lg-4 mb-1 col-md-4">
                                                            <Select
                                                                className="dropdown select_dropdown"
                                                                isDisabled={disabled ? true : false}
                                                                name='InclusionD'
                                                                value={inclusionlistdata?.find(({ value }) => value === inclusionvalue)}
                                                                options={inclusionlistdata?.filter((op) => op?.IsActive)}
                                                                onChange={handleinclusionchange}
                                                                isSearchable
                                                            />
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-4">
                                                            <button type="button" onClick={InclusionClick} className="btn btn-primary mx-1" disabled={disabled ? true : false} id="btnAdd">Add</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='mb-1 col-lg-12 col-md-12 mt-3'>
                                                    <table id="data" className="table table-hover" >
                                                        <thead>
                                                            <tr>
                                                                <th>Inclusion</th>
                                                                <th className='text-end pe-4'>Remove
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="location-data">
                                                            {datainclusiondetails && datainclusiondetails?.map((element, index) => {
                                                                if (datainclusioncounter > 0) {
                                                                    return (
                                                                        <tr className="ReactTable" key={index}>
                                                                            <td >{element?.Inclusion}</td>
                                                                            <td className='text-end'><button type="button" onClick={(e) => { inclusionremovev(element.SeqNo, e) }} className="btn btn-primary mx-1" id="btnAdd" disabled={disabled ? true : false} >Remove</button></td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {(Shown.Exclusion === true) && <div className="accordion-item mb-3">
                                <h2 className="accordion-header" id="panelsStayOpen-headingFour">
                                    <button className="accordion-button collapsed" id="ExclusionError" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false" aria-controls="panelsStayOpen-collapseFour">
                                        Exclusion
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseFour" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFour">
                                    <div className="accordion-body">
                                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                                            <div className="row">
                                                <div className='col-lg-12 col-sm-12 '>
                                                    <div className='row'>
                                                        {formerror.ExclusionError && <p className='text-center text-danger'>{formerror.ExclusionError}</p>}
                                                        {exclusionduplicateerror && <p className='text-center text-danger'>{exclusionduplicateerror}</p>}
                                                        <div className="col-lg-2 col-md-3 mb-1">
                                                            <label className="col-form-label required">Add Exclusion</label>
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-4">
                                                            <Select
                                                                className="dropdown select_dropdown"
                                                                isDisabled={disabled ? true : false}
                                                                name='ExclusionD'
                                                                value={exclusionistdata?.find(({ value }) => value === exclusionvalue)}
                                                                options={exclusionistdata?.filter((op) => op.IsActive)}
                                                                onChange={handleexclusionchange}
                                                                isSearchable
                                                            />
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-4">
                                                            <button type="button" onClick={ExclusionClick} disabled={disabled ? true : false} className="btn btn-primary mx-1" id="btnAdd">Add</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='mb-1 col-lg-12 col-md-12 mt-3'>
                                                    <table id="data" className="table table-hover" >
                                                        <thead>
                                                            <tr>
                                                                <th>Exclusion
                                                                </th>
                                                                <th className='text-end pe-4'>Remove
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="location-data">
                                                            {dataexclusiondetails?.map((element, index) => {
                                                                if (dataexclusioncounter > 0) {
                                                                    return (
                                                                        <tr className="ReactTable" key={index}>
                                                                            <td >{element.Exclusion}</td>
                                                                            <td className='text-end'><button type="button" onClick={(e) => { exclusionremovev(element.SeqNo, e) }} className="btn btn-primary mx-1" id="btnAdd" disabled={disabled ? true : false} >Remove</button></td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                            {(Shown.Policies === true) && <div className="accordion-item mb-3">
                                <h2 className="accordion-header" id="panelsStayOpen-headingFive">
                                    <button className="accordion-button collapsed" id="PolicyError" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="false" aria-controls="panelsStayOpen-collapseFive">
                                        Policy
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseFive" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFive">
                                    <div className="accordion-body">
                                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                                            <div className="row">
                                                {formerror.PolicyError && <p className='text-center text-danger'>{formerror.PolicyError}</p>}
                                                {policyduplicateerror && <p className='text-center text-danger'>{policyduplicateerror}</p>}
                                                <div className='col-lg-12 col-sm-12 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-3 mb-1">
                                                            <label className="col-form-label required">Add Policy</label>
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-4">
                                                            <Select
                                                                className="dropdown select_dropdown"
                                                                isDisabled={disabled ? true : false}
                                                                name='PolicyD'
                                                                value={policylistdata?.find(({ value }) => value === policyvalue)}
                                                                options={policylistdata}
                                                                onChange={handlepolicyonchange}
                                                                isSearchable
                                                            />
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-4">
                                                            <button type="button" onClick={PolicyClick} className="btn btn-primary mx-1" disabled={disabled ? true : false} id="btnAdd">Add</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='mb-1 col-lg-12 col-md-12 mt-3'>
                                                    <table id="data" className="table table-hover" >
                                                        <thead>
                                                            <tr>
                                                                <th>Policy
                                                                </th>
                                                                <th className='text-end pe-4'>Remove
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="location-data">
                                                            {datapolicydetails?.map((element, index) => {
                                                                if (datapolicycounter > 0) {
                                                                    return (
                                                                        <tr className="ReactTable" key={index}>
                                                                            <td >{element.Policy}</td>
                                                                            <td className='text-end'><button type="button" onClick={(e) => { policyremovev(element.SeqNo, e) }} disabled={disabled ? true : false} className="btn btn-primary mx-1" id="btnAdd" >Remove</button></td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {(Shown.Summary === true) && <div className="accordion-item mb-3">
                                <h2 className="accordion-header" id="panelsStayOpen-headingSix">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="false" aria-controls="panelsStayOpen-collapseSix">
                                        Detailed Itinerary
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseSix" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingSix">

                                    <div id="Summary" className="tabcontentpkg">
                                        <div className="summary-inner">
                                            <div className="summaer-box position-relative">
                                                {PkgSummary?.map((curElem) => {
                                                    return (
                                                        <>
                                                            <div className="accordion-body">
                                                                <div className="summary-title setclr">
                                                                    <ul className="p-0 d-flex setclr">
                                                                        <li><p className="text-dark m-0 fw-normal">{curElem.day}</p></li>
                                                                    </ul>
                                                                </div>

                                                                {(curElem.flightNo != null && curElem.flightNo !== "") && (
                                                                    <div className="day1-box day2box setclr">
                                                                        <ul className="row">
                                                                            <li className="col-lg-2 col-md-2 col-2 text-center" style={{ width: "100px" }}><img src="assets/img/flight.png" alt='' /> <p className="text-muted">Flight</p></li>
                                                                            <li className="col-lg-2 col-md-2 col-12 text-center text-lg-start ps-4">
                                                                                <div><p className="m-0 ">{curElem.airlineName}</p><p className="m-0">{curElem.flightNo}</p></div>
                                                                            </li>
                                                                            <li className="col-lg-2 col-md-2 col-12 text-center text-lg-start ps-4"><p className="fs-5 m-0 text-dark">{formatTimeHourMinute(curElem.departureTime)}</p><p className="fs-6">{curElem.flightFrom}</p></li>
                                                                            <li className='col-lg-2 col-md-2 col-12 text-center text-lg-start ps-4'><span className='d-flex align-items-center justify-content-center justify-content-lg-start'>{curElem.duration}</span><div className="d-flex align-items-center justify-content-center justify-content-lg-start"><span className="border_top"></span><img src="assets/img/hand.png" alt='img' /></div></li>
                                                                            <li className="col-lg-2 col-md-2 col-12 text-center text-lg-start ps-4"><p className="fs-5 m-0 text-dark">{formatTimeHourMinute(curElem.arrivalTime)}</p><p className="fs-6">{curElem.flightTo}</p></li>
                                                                        </ul>
                                                                    </div>)}
                                                                {curElem.hotelName != null && (
                                                                    <div className="day1-box">
                                                                        <ul className="row">
                                                                            <li className="col-lg-2 col-md-2 col-2 text-center" style={{ width: "100px" }}><img src="assets/img/hotel.png" className="img-fluid" alt='' /> <p className="text-muted">Hotel</p></li>
                                                                            <li className="col-lg-10 col-md-10 col-10 ps-4">
                                                                                <div className='row'>
                                                                                    <div className='col-lg-4 col-md-6 col-12'>
                                                                                        <img src={CommonFileURLWithFolder + curElem.documentPath} className="me-2 img-fluid" alt='' /></div>
                                                                                    <div className='col-lg-8 col-md-6 col-12'>
                                                                                        <p className="m-0 text-dark">{curElem.hotelName}</p>
                                                                                        <div className="star mb-2">
                                                                                            <ul className="d-flex p-0">
                                                                                                <Rating size={16} allowFraction readonly initialValue={curElem.hotelRating} />
                                                                                            </ul>
                                                                                        </div>
                                                                                        <p className="m-0">{curElem.roomType}<br />
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    </div>)}

                                                                < div className="day1-box">
                                                                    <ul className="row">
                                                                        <li className="col-lg-2 col-md-2 col-2 text-center" style={{ width: "100px" }}><img src="assets/img/explore.png" alt='' /> <p className="text-muted">Explore</p></li>
                                                                        <li className='col-lg-10 col-md-10 col-10 ps-4'>
                                                                            <p className="text-dark m-0">{curElem.sightSeeingCity}</p>
                                                                            <ul className="d-flex flex-column p-0">
                                                                                <li className="p-0">
                                                                                    <p className="text-muted mb-0 defualt-unstyled wraptextcont" dangerouslySetInnerHTML={{ __html: curElem.daySchedule }}></p>
                                                                                </li>
                                                                            </ul>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>}
                            {(Shown.About === true) && <div className="accordion-item mb-3">
                                <h2 className="accordion-header" id="panelsStayOpen-headingSeven">
                                    <button className="accordion-button collapsed" type="button" id="AboutPlaceError" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSeven" aria-expanded="false" aria-controls="panelsStayOpen-collapseSeven">
                                        About Place
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseSeven" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingSeven">
                                    <div className="accordion-body">
                                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                                            <div className="row">
                                                <div className='col-lg-12 col-sm-12 '>
                                                    <div className='row'>
                                                        {formerror.AboutPlaceError && <p className='text-center text-danger'>{formerror.AboutPlaceError}</p>}
                                                        <div className="col-lg-2 col-md-3 mb-1">
                                                            <label className="col-form-label required">Select City</label>
                                                        </div>
                                                        <div className="col-lg-4 mb-1 col-md-4">
                                                            {/* <Select
                                                                    className="dropdown select_dropdown"
                                                                    name='CityD'
                                                                    value={aboutplacecitydatalist?.filter(function (aboutplacecitydatalist) {
                                                                        return aboutplacecitydatalist.value === cityvalue;
                                                                    })}// set list of the data
                                                                    // value={aboutplacecitydatalist.find(({ value }) => value === cityvalue)}
                                                                    options={aboutplacecitydatalist}
                                                                    onChange={handlecityonchange}
                                                                    isSearchable
                                                                    isDisabled={disabled ? true : false}
                                                                /> */}
                                                            <CustomSelection
                                                                datalist={aboutplacecitydatalist}
                                                                fieldid={cityvalue}
                                                                SelectionChange={handlecityonchange}
                                                                isdisable={disabled}
                                                                isactivedisable={aboutcitydisable}
                                                                issearchable={true}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-lg-12 col-sm-12 '>
                                                    <div className='row'>
                                                        <div className="col-lg-2 col-md-3 mb-1">
                                                            <label className="col-form-label required">City Details</label>
                                                        </div>
                                                        <div className="col-lg-10 mb-1 col-md-9">

                                                            <RichTextBox
                                                                field="CityDetailsD"
                                                                fieldvalue={formvalue.CityDetailsD !== null ? formvalue.CityDetailsD : ''}
                                                                tabIndex={1}
                                                                OnChangeofRichBox={(value) => { formvalue.CityDetailsD = value; }}
                                                                setRef={setEditorRef2}
                                                                textconfig={config}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-lg-6 col-sm-6'>
                                                    <div className='row'>
                                                        <div className="col-lg-4 col-md-12 col-sm-12 mb-lg-1">
                                                            <label className="col-form-label">City Image</label>

                                                        </div>
                                                        <div className="col-lg-8 col-md-12 col-sm-12 mb-lg-1">
                                                            {(placeimagepath && placeimagepath !== `${CommonFileURLWithFolder}null` && placeimagepath !== CommonFileURLWithFolder) &&
                                                                (
                                                                    <>
                                                                        <div className="col-lg-3 col-md-3 col-6 my-2 cityimage">
                                                                            <img src={placeimagepath} className="cityimage" alt='' />
                                                                        </div>
                                                                    </>
                                                                )}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 mb-1 col-md-12 d-flex justify-content-center">
                                                    <button type="button" onClick={CityClick} disabled={disabled ? true : false} className="btn btn-primary mx-1" id="btnAboutPlaceAdd">{aboutplacebtntext}</button>
                                                </div>
                                                <div className='mb-1 col-lg-12 col-md-12 mt-3'>
                                                    <table id="data" className="table table-hover" >
                                                        <thead>
                                                            <tr>
                                                                <th>City
                                                                </th>
                                                                <th className='text-end pe-4'>Edit
                                                                </th>
                                                                <th className='text-end pe-4'>Remove
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="location-data">
                                                            {datacitydetails?.map((element, index) => {

                                                                if (datacitycounter > 0) {
                                                                    return (
                                                                        <tr className="ReactTable" key={index}>
                                                                            <td >{element.CityName}</td>
                                                                            <td className='text-end'><button type="button" onClick={(e) => { cityeditdata(element.SeqNo, e) }} className="btn btn-primary mx-1" id="btnedit" disabled={disabled ? true : false}>Edit</button></td>
                                                                            <td className='text-end'><button type="button" onClick={(e) => { cityremovev(element.SeqNo, e) }} className="btn btn-primary mx-1" id="btnAdd" disabled={disabled ? true : false}>Remove</button></td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            })}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                            {(Shown.Visibility === true) &&
                                <div className="accordion mt-3" id="accordionPanelsStayOpenExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="panelsStayOpen-headingVisibility">
                                            <button className="accordion-button collapsed border_set" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseVisibility" aria-expanded="false" aria-controls="panelsStayOpen-collapseVisibility">
                                                Home page Section Visibility
                                            </button>
                                        </h2>
                                        <div id="panelsStayOpen-collapseVisibility" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingVisibility">
                                            <div className="accordion-body">
                                                <div className='col-lg-12 col-12 col-md-12 '>
                                                    <div className='row'>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-1 mb-1 col-md-12">
                                                                    <input className="form-check-input mt-2 me-2" type="checkbox" id="checkboxNoLabel"
                                                                        value={formvalue.IsHotDeals} onChange={onChange} disabled={disabled ? true : false} checked={hotdeals ? true : false}
                                                                        aria-label="..." name="IsHotDeals" />
                                                                </div>
                                                                <div className="col-lg-4 col-md-12 mb-1">
                                                                    <label className="col-form-label">Hot Deals</label>
                                                                </div>
                                                                <div className="col-lg-6 mb-1 col-md-12">
                                                                    <input type="text" id="inputPassword6" className="form-control"
                                                                        name="HotOfferPercentage"
                                                                        value={formvalue.HotOfferPercentage}
                                                                        onChange={onChange}
                                                                        disabled={disabled ? true : false}
                                                                        placeholder="Enter the Offer %"
                                                                    />

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-1 mb-1 col-md-12">
                                                                    <input className="form-check-input mt-2 me-2" type="checkbox" id="checkboxNoLabel"
                                                                        aria-label="..." name="IsBestDestination"
                                                                        value={formvalue.IsBestDestination} onChange={onChange} disabled={disabled ? true : false} checked={isbestdestinatio ? true : false} />
                                                                </div>
                                                                <div className="col-lg-11 mb-1 col-md-12">
                                                                    <label className="col-form-label">Explore the Best Destinations Around the World</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-1 mb-1 col-md-12">
                                                                    <input className="form-check-input mt-2 me-2" type="checkbox" id="checkboxNoLabel"
                                                                        value={formvalue.IsInternationalDestination} onChange={onChange} disabled={disabled ? true : false} checked={isinternationaldestination ? true : false}
                                                                        aria-label="..." name="IsInternationalDestination" />
                                                                </div>
                                                                <div className="col-lg-11 mb-1 col-md-12">
                                                                    <label className="col-form-label">International Destinations</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-6 col-sm-6 '>
                                                            <div className='row'>
                                                                <div className="col-lg-1 mb-1 col-md-12">
                                                                    <input className="form-check-input mt-2 me-2" type="checkbox" id="checkboxNoLabel"
                                                                        value={formvalue.IsTrendingHoliday} onChange={onChange} disabled={disabled ? true : false} checked={istrendingholiday ? true : false}
                                                                        aria-label="..." name="IsTrendingHoliday" />
                                                                </div>
                                                                <div className="col-lg-11 mb-1 col-md-12">
                                                                    <label className="col-form-label">Trending Holidays in India</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {(Shown.Price === true && formvalue?.IsPriceType) &&

                                <div className="accordion mt-3" id="accordionPanelsStayOpenExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="panelsStayOpen-headingPricing">
                                            <button className="accordion-button collapsed border_set" type="button" id="PricingError" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapsePricing" aria-expanded="false" aria-controls="panelsStayOpen-collapsePricing">
                                                Pricing
                                            </button>
                                        </h2>
                                        <div id="panelsStayOpen-collapsePricing" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingPricing">
                                            <div className="accordion-body">
                                                <div className="row px-3 mb-3">
                                                    <div className='form_border'>
                                                        <label className="col-form-label fw-bold">Children</label>
                                                        <div className="row pb-3">
                                                            <div className='col-lg-6 col-sm-6 '>
                                                                <div className='row'>
                                                                    <div className="col-lg-4 col-md-12 mb-1">
                                                                        <label className="col-form-label required">Price</label>
                                                                    </div>
                                                                    <div className="col-lg-8 mb-1 col-md-12">
                                                                        <input type="text" id="inputPassword6" className="form-control"
                                                                            name="ChildrenPrice"
                                                                            value={childprice}
                                                                            maxLength={10}
                                                                            onChange={(e) => handleChildPrice(e)}
                                                                            disabled={disabled ? true : false}
                                                                        />
                                                                        {formerror.ChildrenPrice && <p className='text-danger text-start'>{formerror.ChildrenPrice}</p>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        {formvalue?.IsPriceType && (
                            <>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Basic price</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <input type="text" id="inputPassword6" className="form-control"
                                                name="PackageBasicPrice"
                                                value={formvalue.PackageBasicPrice}
                                                placeholder="Package Basic price"
                                                disabled
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Add Mark Up</label>
                                        </div>
                                        <div className="col-lg-8 mt-1 mb-1 col-md-12">
                                            <div className="form-check-inline">
                                                <input className="form-check-input" type="radio" name="flexRadioMarkup" value={0} key={0} id="flexRadioMarkup1" onChange={handlefixtypetax} checked={gsttype === 'FIX' ? true : false} disabled={disabled ? true : false} />
                                                <label className="form-check-label ms-1" htmlFor="flexRadioMarkup1">
                                                    Fix
                                                </label>
                                            </div>
                                            <div className="form-check-inline">
                                                <input className="form-check-input" type="radio" name="flexRadioMarkup" value={1} key={1} id="flexRadioMarkup2" onChange={handlegsttypechange} checked={gsttype === 'GST' ? true : false} disabled={disabled ? true : false} />
                                                <label className="form-check-label ms-1" htmlFor="flexRadioMarkup2">
                                                    Percentage
                                                </label>
                                            </div>
                                            <div className="col-lg-8 mb-1 col-md-12">
                                                <input type="text" id="inputPassword6" className="form-control"
                                                    name="PackageFixPrice"
                                                    value={formvalue.PackageFixPrice}
                                                    onChange={onChange}
                                                    disabled={disabled ? true : false}
                                                    placeholder="Package Fix Price"
                                                />

                                            </div>
                                            {formerror.MarkupvalueError && <p className='text-danger text-start'>{formerror.MarkupvalueError}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Add Discount</label>
                                        </div>
                                        <div className="col-lg-8 mt-1 mb-1 col-md-12">
                                            <label className="form-check-label" htmlFor="PackageDiscount">
                                                Percentage
                                            </label>
                                            <div className="col-lg-8 mb-1 col-md-12">
                                                <input type="text" id="PackageDiscount" className="form-control"
                                                    name="PackageDiscount"
                                                    value={formvalue.PackageDiscount}
                                                    onChange={(e) => {
                                                        if (onlyNumeric(e.target.value) <= 100) {
                                                            onChange(e)
                                                        }
                                                    }}
                                                    disabled={disabled ? true : false}
                                                    placeholder="Package Discount"
                                                />
                                            </div>
                                            {formerror.PackageDiscount && <p className='text-danger text-start'>{formerror.PackageDiscount}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">GST</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <Select
                                                className="dropdown select_dropdown"
                                                value={gstlist?.filter(function (gstlist) {
                                                    return gstlist.value === gstid;
                                                })}// set list of the data
                                                options={gstlist}
                                                isDisabled
                                                onChange={handlegstonchange}
                                                isSearchable
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-sm-6 '>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 mb-1">
                                            <label className="col-form-label required">Package Final Price</label>
                                        </div>
                                        <div className="col-lg-8 mb-1 col-md-12">
                                            <input
                                                type="text"
                                                id="inputPassword6"
                                                className="form-control"
                                                name="PackageFinalPrice"
                                                value={pkgfinalprice}
                                                disabled={disabled ? true : false}
                                                placeholder="Package Final Price"
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    <div className="d-flex justify-content-center">
                        <button type="button"
                            className="btn btn-primary mx-1"
                            id="btnbasicdraft"
                            onClick={(e) => onBasicDraftSubmit(e)}
                            disabled={basicdraftdisabled ? true : false}
                            style={{ display: isbasicShown ? 'block' : 'none' }}
                        >Save As Draft</button>

                        <button type="button"
                            className="btn btn-primary mx-1"
                            id="btnAdd"
                            style={{ display: isAddDraftShown ? 'block' : 'none' }}
                            onClick={(e) => onDraftSubmit(e)}
                            disabled={editdisabled ? true : false}
                        >Save As Draft</button>
                        <button type="button"
                            className="btn btn-primary mx-1"
                            id="btnAdd"
                            style={{ display: isAddShown ? 'block' : 'none' }}
                            onClick={(e) => onSubmitData(e)}
                            disabled={editdisabled ? true : false}
                        >Submit</button>

                        <button type="button"
                            className="btn btn-primary mx-1"
                            id="btnClear"
                            onClick={handleclear}
                            disabled={cleardisabled ? true : false}
                        >Clear</button>

                        <button type="button" className="btn btn-primary mx-1"
                            id="btnVisible"
                            onClick={handleBackButton}
                            disabled={backdisable ? true : false}
                        >Back</button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default Packagemaster